import * as React from "react";

function SvgAccomazzoFamilyTree(props) {
  return (
      <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={54507}
    height={2191.6}
    style={{
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "#fff",
      fillRule: "evenodd",
      fontFamily: "Roboto",
      fontSize: 14,
      textAnchor: "middle",
    }}
    {...props}
  >
    <style>{"svg text{stroke:none;white-space:pre}"}</style>
      <path strokeWidth={3} d="M25885.5 370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M25885.5 370.38h150v50h-150z" />
        <text fill="#000" transform="translate(25885.5 370.38)">
          <tspan x={47.656} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Rolando"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(before 1742-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(25865.5 350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"1"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M26135.5 370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M26135.5 370.38h150v50h-150z" />
        <text fill="#000" transform="translate(26135.5 370.38)">
          <tspan x={25.383} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Anna Catharina"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1723-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(26115.5 350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"2"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M25715.5 380.38h120v30h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25715.5 380.38h120v30h-120z" />
      <text fill="#000" transform="translate(25715.5 380.38)">
        <tspan x={16.438} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={19.62}>
          {" Pauli Josephi"}
        </tspan>
      </text>
    </g>
    <path d="M25565.5 380.38h115v30h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25565.5 380.38h115v30h-115z" />
      <text fill="#000" transform="translate(25565.5 380.38)">
        <tspan x={20.629} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={19.62}>
          {" Julia Grana"}
        </tspan>
      </text>
    </g>
    <path d="M25635.5 220.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25635.5 220.38h150v50h-150z" />
      <text fill="#000" transform="translate(25635.5 220.38)">
        <tspan x={45.965} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Stephani"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(-before 1758)"}
        </tspan>
      </text>
    </g>
    <path d="M25835.5 230.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25835.5 230.38h150v30h-150z" />
      <text fill="#000" transform="translate(25835.5 230.38)">
        <tspan x={17.031} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Catharina Carraris"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M25835.5 245.38h-25 0-25M25775.5 380.38v-60h35v-75M25960.5 370.38v-50h-150v-70"
    />
      <path strokeWidth={3} d="M26040.5 220.38h145v50h-145z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M26040.5 220.38h145v50h-145z" />
        <text fill="#000" fontSize={14} transform="translate(26040.5 220.38)">
          <tspan x={27.102} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={81.219} y={21.22}>
            {" Joannes Pauli"}
          </tspan>
          <tspan x={72.5} y={38.02}>
            {"(1680-)"}
          </tspan>
        </text>
      </g>
    <path d="M26235.5 230.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26235.5 230.38h150v30h-150z" />
      <text fill="#000" transform="translate(26235.5 230.38)">
        <tspan x={30.645} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Joanne Maria"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M26235.5 245.38h-25 0-25" />
      <path strokeWidth={3} d="M25965.5 120.38h115v50h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M25965.5 120.38h115v50h-115z" />
        <text fill="#000" transform="translate(25965.5 120.38)">
          <tspan x={32.012} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={21.22}>
            {" Joannis"}
          </tspan>
          <tspan x={57.5} y={38.02}>
            {"(1651-)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M26113 220.38v-37.5h0v-37.5M26210.5 370.38v-62.5h0v-62.5"
    />
      <path strokeWidth={3} d="M26005.5 520.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M26005.5 520.38h150v50h-150z" />
        <text fill="#000" transform="translate(26005.5 520.38)">
          <tspan x={40.184} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Jois Bapta"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1755-1803)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(25985.5 500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"7"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M26245.5 530.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26245.5 530.38h150v30h-150z" />
      <text fill="#000" transform="translate(26245.5 530.38)">
        <tspan x={31.43} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Antonia Vairo"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M26125.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M26125.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(26125.5 670.38)">
          <tspan x={44.18} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Giovanna"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1799-1877)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(26105.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"14"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M25835.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M25835.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(25835.5 670.38)">
          <tspan x={41.125} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Francesca"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1794-1877)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(25815.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"13"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M26385.5 670.38h200v50h-200z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M26385.5 670.38h200v50h-200z" />
        <text fill="#000" transform="translate(26385.5 670.38)">
          <tspan x={23.828} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={108.719} y={21.22}>
            {" Giuseppe detto Rolando"}
          </tspan>
          <tspan x={100} y={38.02}>
            {"(1783-1869)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(26365.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"15"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M26080.5 520.38v-62.5h0v-62.5M26155.5 545.38h90M25910.5 670.38v-50h290v-75M26200.5 670.38v-50h0v-75M26485.5 670.38v-50h-285v-75"
    />
      <path strokeWidth={3} d="M25450.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M25450.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(25450.5 670.38)">
          <tspan x={43.582} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Pasquale"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1785-1850)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(25430.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"12"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M25345.5 520.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M25345.5 520.38h150v50h-150z" />
        <text fill="#000" transform="translate(25345.5 520.38)">
          <tspan x={31.648} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Jois Jacobus"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1755-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(25325.5 500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"6"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M25560.5 530.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25560.5 530.38h125v30h-125z" />
      <text fill="#000" transform="translate(25560.5 530.38)">
        <tspan x={30.645} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Margarita"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M25715.5 395.38h-17.5 0-17.5" />
    <path d="M25435.5 380.38h120v30h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25435.5 380.38h120v30h-120z" />
      <text fill="#000" transform="translate(25435.5 380.38)">
        <tspan x={18.648} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={19.62}>
          {" Maria Chietti"}
        </tspan>
      </text>
    </g>
    <path d="M25285.5 380.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25285.5 380.38h100v30h-100z" />
      <text fill="#000" transform="translate(25285.5 380.38)">
        <tspan x={20.965} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Stephani"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M25435.5 395.38h-17.5 0-32.5" />
    <path d="M25355.5 230.38h120v30h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25355.5 230.38h120v30h-120z" />
      <text fill="#000" transform="translate(25355.5 230.38)">
        <tspan x={22.641} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={19.62}>
          {" Anna Maria"}
        </tspan>
      </text>
    </g>
    <path d="M25195.5 230.38h115v30h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25195.5 230.38h115v30h-115z" />
      <text fill="#000" transform="translate(25195.5 230.38)">
        <tspan x={19.918} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={19.62}>
          {" Jois Jacobi"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M25355.5 245.38h-22.5 0-22.5M25420.5 520.38v-50h0v-75M25560.5 545.38h-32.5 0-32.5M25525.5 670.38v-50h0v-75M25335.5 380.38v-67.5h0v-67.5M25600.5 695.38h235"
    />
      <path strokeWidth={3} d="M29175.5 870.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M29175.5 870.38h150v50h-150z" />
        <text fill="#000" fontSize={14} transform="translate(29175.5 870.38)">
          <tspan x={43.305} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Tommaso"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1814-1893)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(29155.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"31"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M28705.5 1070.38h155v50h-155z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28705.5 1070.38h155v50h-155z" />
        <text fill="#000" transform="translate(28705.5 1070.38)">
          <tspan x={23.43} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={86.219} y={21.22}>
            {" Antonio Rolando"}
          </tspan>
          <tspan x={77.5} y={38.02}>
            {"(1828-1917)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(28685.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"30"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M28910.5 1080.38h105v30h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M28910.5 1080.38h105v30h-105z" />
      <text fill="#000" transform="translate(28910.5 1080.38)">
        <tspan x={22.629} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={61.219} y={19.62}>
          {" Catterina"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M24790.5 870.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M24790.5 870.38h150v50h-150z" />
        <text fill="#000" fontSize={14} transform="translate(24790.5 870.38)">
          <tspan x={32.777} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Giov. Battista"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1810-1893)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(24770.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"29"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M24580.5 870.38h160v50h-160z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M24580.5 870.38h160v50h-160z" />
        <text fill="#000" fontSize={14} transform="translate(24580.5 870.38)">
          <tspan x={21.711} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={88.719} y={21.22}>
            {" Rosa Bosia (Bugia)"}
          </tspan>
          <tspan x={80} y={38.02}>
            {"(1817-1895)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M24790.5 895.38h-25 0-25" />
      <path strokeWidth={3} d="M29460.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M29460.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(29460.5 670.38)">
          <tspan x={34.32} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Chiara/Clara"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1790-1877)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(29440.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"16"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M29745.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M29745.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(29745.5 670.38)">
          <tspan x={25.445} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Carlo Clemente"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1798-1868)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(29725.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"17"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M29865.5 870.38h180v50h-180z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M29865.5 870.38h180v50h-180z" />
        <text fill="#000" transform="translate(29865.5 870.38)">
          <tspan x={24.695} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={98.719} y={21.22}>
            {" Tommaso Domenico"}
          </tspan>
          <tspan x={90} y={38.02}>
            {"(1840-1815)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(29845.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"32"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M30095.5 880.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M30095.5 880.38h150v30h-150z" />
      <text fill="#000" transform="translate(30095.5 880.38)">
        <tspan x={16.789} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Lucia Rabbezzana"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M30045.5 895.38h50M29250.5 870.38v-50h-240v-87.5M28780.5 1070.38v-250h230v-87.5"
    />
      <path strokeWidth={3} d="M30060.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M30060.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(30060.5 670.38)">
          <tspan x={54.863} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Pietro"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1780-1868)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(30040.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"18"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M29635.5 520.38h160v50h-160z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M29635.5 520.38h160v50h-160z" />
        <text fill="#000" transform="translate(29635.5 520.38)">
          <tspan x={54.023} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={88.719} y={21.22}>
            {" Stefano"}
          </tspan>
          <tspan x={80} y={38.02}>
            {"(1755-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(29615.5 500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"8"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M29845.5 530.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M29845.5 530.38h150v30h-150z" />
      <text fill="#000" transform="translate(29845.5 530.38)">
        <tspan x={13.195} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Margherita Argenta"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M29795.5 545.38h50" />
      <path strokeWidth={3} d="M28900.5 370.38h160v50h-160z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28900.5 370.38h160v50h-160z" />
        <text fill="#000" transform="translate(28900.5 370.38)">
          <tspan x={32.137} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={88.719} y={21.22}>
            {" Petrus Antonio"}
          </tspan>
          <tspan x={80} y={38.02}>
            {"(1732-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(28880.5 350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"3"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M29110.5 380.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M29110.5 380.38h100v30h-100z" />
      <text fill="#000" transform="translate(29110.5 380.38)">
        <tspan x={31.621} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Paula"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M29060.5 395.38h50" />
      <path strokeWidth={3} d="M28770.5 220.38h185v50h-185z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28770.5 220.38h185v50h-185z" />
        <text fill="#000" transform="translate(28770.5 220.38)">
          <tspan
            x={23.605}
            y={21.22}
            fontFamily="Noto Color Emoji"
            fontSize={14}
          >
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={101.219} y={21.22} fontSize={14}>
            {" Dominicus Francisco"}
          </tspan>
          <tspan x={92.5} y={38.02} fontSize={14}>
            {"(1697-)"}
          </tspan>
        </text>
      </g>
    <path d="M29005.5 230.38h215v30h-215z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M29005.5 230.38h215v30h-215z" />
      <text fill="#000" transform="translate(29005.5 230.38)">
        <tspan x={31.238} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={116.219} y={19.62}>
          {" Magdalena Maranzana"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M29005.5 245.38h-25 0-25" />
      <path strokeWidth={3} d="M28695.5 130.38h140v30h-140z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28695.5 130.38h140v30h-140z" />
        <text fill="#000" transform="translate(28695.5 130.38)">
          <tspan x={27.426} y={19.62} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={78.719} y={19.62}>
            {" Joannis Petri"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M28863 220.38v-37.5h0v-37.5M28980.5 370.38v-62.5h0v-62.5M29535.5 670.38v-50h285v-75M29820.5 670.38v-50h0v-75M29715.5 520.38v-50H28333v50"
    />
    <path d="M30285.5 680.38h225v30h-225z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M30285.5 680.38h225v30h-225z" />
      <text fill="#000" transform="translate(30285.5 680.38)">
        <tspan x={30.258} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={121.219} y={19.62}>
          {" Margarita Ferraris/Ferrero"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M33380.5 870.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M33380.5 870.38h150v50h-150z" />
        <text fill="#000" transform="translate(33380.5 870.38)">
          <tspan x={38.414} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Sebastiano"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1831-1906)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(33360.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"33"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M30210.5 695.38h75" />
      <path strokeWidth={3} d="M38325.5 870.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M38325.5 870.38h125v50h-125z" />
        <text fill="#000" transform="translate(38325.5 870.38)">
          <tspan x={26.063} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Maddalena"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1840-1879)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(38305.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"34"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M34155.5 1070.38h140v50h-140z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M34155.5 1070.38h140v50h-140z" />
        <text fill="#000" transform="translate(34155.5 1070.38)">
          <tspan x={19.457} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={78.719} y={21.22}>
            {" Paolo Giuseppe"}
          </tspan>
          <tspan x={70} y={38.02}>
            {"(1871-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(34135.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"63"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M37170.5 1070.38h135v50h-135z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M37170.5 1070.38h135v50h-135z" />
        <text fill="#000" transform="translate(37170.5 1070.38)">
          <tspan x={36.559} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={76.219} y={21.22}>
            {" Giuseppe"}
          </tspan>
          <tspan x={67.5} y={38.02}>
            {"(1876-1960)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(37150.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"64"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M34355.5 1080.38h135v30h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M34355.5 1080.38h135v30h-135z" />
      <text fill="#000" transform="translate(34355.5 1080.38)">
        <tspan x={18.754} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={19.62}>
          {" Olimpia Murzio"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M37365.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M37365.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(37365.5 1070.38)">
          <tspan x={30.273} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Teresa Verrua"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1880-1946)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M38450.5 1070.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M38450.5 1070.38h100v50h-100z" />
        <text fill="#000" transform="translate(38450.5 1070.38)">
          <tspan x={32.547} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Rosa"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1862-1904)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(38430.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"65"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M38600.5 1070.38h190v50h-190z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M38600.5 1070.38h190v50h-190z" />
      <text fill="#000" fontSize={14} transform="translate(38600.5 1070.38)">
        <tspan x={23.957} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={103.719} y={21.22}>
          {" Giuseppe Riccomagno"}
        </tspan>
        <tspan x={95} y={38.02}>
          {"(1945-1913)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M34225.5 1070.38v-100h595v-75M37238 1070.38v-100h-1077.5"
    />
    <path
      fill="none"
      d="M38500.5 1070.38v-100h-3680v-70M34295.5 1095.38h60M37305.5 1095.38h60M38600.5 1095.38h-25 0-25"
    />
      <path strokeWidth={3} d="M39330.5 870.38h155v50h-155z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M39330.5 870.38h155v50h-155z" />
        <text fill="#000" transform="translate(39330.5 870.38)">
          <tspan x={22.512} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={86.219} y={21.22}>
            {" Marco Domenico"}
          </tspan>
          <tspan x={77.5} y={38.02}>
            {"(1853-1939)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(39310.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"35"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M38285.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M38285.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(38285.5 670.38)">
          <tspan x={21.047} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Rosa Maranzana"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1815-1861)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(38265.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"19"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M38485.5 670.38h135v50h-135z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M38485.5 670.38h135v50h-135z" />
        <text fill="#000" transform="translate(38485.5 670.38)">
          <tspan x={47.895} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={76.219} y={21.22}>
            {" Paolo"}
          </tspan>
          <tspan x={67.5} y={38.02}>
            {"(1815-1888)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(38465.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"20"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M39165.5 520.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M39165.5 520.38h100v50h-100z" />
        <text fill="#000" transform="translate(39165.5 520.38)">
          <tspan x={19.375} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Giovanni"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1792-1854)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(39145.5 500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"9"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M39315.5 530.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M39315.5 530.38h150v30h-150z" />
      <text fill="#000" transform="translate(39315.5 530.38)">
        <tspan x={12.141} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Maddalena Roberto"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M39315.5 545.38h-25 0-25" />
      <path strokeWidth={3} d="M38925.5 370.38h120v50h-120z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M38925.5 370.38h120v50h-120z" />
        <text fill="#000" transform="translate(38925.5 370.38)">
          <tspan x={20.891} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={68.719} y={21.22}>
            {" Pauli Antoni"}
          </tspan>
          <tspan x={60} y={38.02}>
            {"(1741-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(38905.5 350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"4"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M39095.5 380.38h165v30h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M39095.5 380.38h165v30h-165z" />
      <text fill="#000" transform="translate(39095.5 380.38)">
        <tspan x={25.211} y={19.62} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.047} y={19.62} fontSize={14}>
          {" Benedicta "}
        </tspan>
        <tspan x={125.336} y={19.62}>
          {"Faldella"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M39095.5 395.38h-25 0-25" />
      <path strokeWidth={3} d="M38820.5 230.38h135v30h-135z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M38820.5 230.38h135v30h-135z" />
        <text fill="#000" fontSize={14} transform="translate(38820.5 230.38)">
          <tspan x={41.98} y={19.62} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={76.219} y={19.62}>
            {" Josephi"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M39020.5 230.38h200v30h-200z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M39020.5 230.38h200v30h-200z" />
        <text fill="#000" transform="translate(39020.5 230.38)">
          <tspan x={29.234} y={19.62} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={108.719} y={19.62}>
            {" Francisca Gambertoli"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M38955.5 245.38h65" />
      <path strokeWidth={3} d="M40210.5 670.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M40210.5 670.38h100v50h-100z" />
        <text fill="#000" transform="translate(40210.5 670.38)">
          <tspan x={29.863} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Pietro"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1818-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(40190.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"21"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M38485.5 695.38h-25 0-25M38553 670.38v-62.5h737.5v-62.5M40260.5 670.38v-62.5h-970v-57.5M38388 870.38v-100h72.5v-75M39408 870.38v-100h-947.5v-75"
    />
    <path d="M39575.5 880.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M39575.5 880.38h150v30h-150z" />
      <text fill="#000" transform="translate(39575.5 880.38)">
        <tspan x={15.793} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Angela Rabezzana"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M39815.5 1070.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M39815.5 1070.38h100v50h-100z" />
        <text fill="#000" transform="translate(39815.5 1070.38)">
          <tspan x={26.477} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Aurelio"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1895-1935)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(39795.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"66"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M39485.5 895.38h90M39865.5 1070.38v-100h-325v-75" />
      <path strokeWidth={3} d="M40265.5 870.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M40265.5 870.38h150v50h-150z" />
        <text fill="#000" transform="translate(40265.5 870.38)">
          <tspan x={25.246} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Luigi Guglielmo"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1853-1937)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(40245.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"36"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M40405.5 670.38h175v50h-175z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M40405.5 670.38h175v50h-175z" />
        <text fill="#000" transform="translate(40405.5 670.38)">
          <tspan x={22.637} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={96.219} y={21.22}>
            {" Margherita Masoero"}
          </tspan>
          <tspan x={87.5} y={38.02}>
            {"(1830-1880)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(40390.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"22"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M40310.5 695.38h95M40285.5 870.38h75v-175h5" />
      <path strokeWidth={3} d="M40550.5 870.38h200v50h-200z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M40550.5 870.38h200v50h-200z" />
        <text fill="#000" transform="translate(40550.5 870.38)">
          <tspan x={37.926} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={108.719} y={21.22}>
            {" Maria Rosa Antonia"}
          </tspan>
          <tspan x={100} y={38.02}>
            {"(1857-1901)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(40530.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"37"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M40415.5 895.38h135" />
      <path strokeWidth={3} d="M41230.5 870.38h180v50h-180z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M41230.5 870.38h180v50h-180z" />
        <text fill="#000" fontSize={14} transform="translate(41230.5 870.38)">
          <tspan x={31.215} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={98.719} y={21.22}>
            {" Casimiro Vincenzo"}
          </tspan>
          <tspan x={90} y={38.02}>
            {"(1854-1929)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(41210.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"38"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M40665.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M40665.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(40665.5 670.38)">
          <tspan x={15.445} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Michele Domenico"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1817-1882)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(40640.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"23"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M40865.5 680.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40865.5 680.38h150v30h-150z" />
      <text fill="#000" transform="translate(40865.5 680.38)">
        <tspan x={15.063} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Susanna Maggiora"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M40815.5 695.38h50M40650.5 870.38v-100h195v-75M41320.5 870.38v-100h-475v-50"
    />
      <path strokeWidth={3} d="M40600.5 520.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M40600.5 520.38h100v50h-100z" />
        <text fill="#000" transform="translate(40600.5 520.38)">
          <tspan x={19.059} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Giuseppe"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1787-1865)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(40580.5 500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"10"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M40775.5 520.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M40775.5 520.38h150v50h-150z" />
        <text fill="#000" transform="translate(40775.5 520.38)">
          <tspan x={21.805} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Antonia Rosaero"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1786-1868)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(40755.5 500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"11"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M40450.5 370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M40450.5 370.38h150v50h-150z" />
        <text fill="#000" transform="translate(40450.5 370.38)">
          <tspan x={20.414} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Giovanni Battista"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1757-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(40430.5 350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"5"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M40700.5 380.38h215v30h-215z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40700.5 380.38h215v30h-215z" />
      <text fill="#000" transform="translate(40700.5 380.38)">
        <tspan x={16.742} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={116.219} y={19.62}>
          {" Maddalena Vigliotti/Vigliotto"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M40700.5 395.38h-90 0-10" />
    <path d="M40400.5 230.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40400.5 230.38h100v30h-100z" />
      <text fill="#000" transform="translate(40400.5 230.38)">
        <tspan x={20.965} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Stephani"}
        </tspan>
      </text>
    </g>
    <path d="M40565.5 230.38h130v30h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40565.5 230.38h130v30h-130z" />
      <text fill="#000" transform="translate(40565.5 230.38)">
        <tspan x={23.648} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={73.719} y={19.62}>
          {" Maria Chietti"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M40500.5 245.38h65M40525.5 370.38v-62.5h0v-62.5M40650.5 520.38v-52.5h0v-72.5M40700.5 545.38h75M40740.5 670.38v-62.5h0v-62.5"
    />
      <path strokeWidth={3} d="M41505.5 870.38h175v50h-175z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M41505.5 870.38h175v50h-175z" />
        <text fill="#000" transform="translate(41505.5 870.38)">
          <tspan x={26.031} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={96.219} y={21.22}>
            {" Giuseppina Monica"}
          </tspan>
          <tspan x={87.5} y={38.02}>
            {"(1862-1944)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(41485.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"39"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M42595.5 870.38h200v50h-200z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M42595.5 870.38h200v50h-200z" />
        <text fill="#000" transform="translate(42595.5 870.38)">
          <tspan x={19.398} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={108.719} y={21.22}>
            {" Antonio Domenico Enrico"}
          </tspan>
          <tspan x={100} y={38.02}>
            {"(1851-1918)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(42575.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"40"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M42860.5 870.38h180v50h-180z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M42860.5 870.38h180v50h-180z" />
        <text fill="#000" transform="translate(42860.5 870.38)">
          <tspan x={17.426} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={98.719} y={21.22}>
            {" Massimina Maranzana"}
          </tspan>
          <tspan x={90} y={38.02}>
            {"(1853-1938)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M45425.5 870.38h240v50h-240z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M45425.5 870.38h240v50h-240z" />
        <text fill="#000" transform="translate(45425.5 870.38)">
          <tspan x={39.254} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={128.719} y={21.22}>
            {" Giacomo Calisto Edoardo"}
          </tspan>
          <tspan x={120} y={38.02}>
            {"(1852-1932)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(45405.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"42"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M45115.5 870.38h200v50h-200z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M45115.5 870.38h200v50h-200z" />
        <text fill="#000" transform="translate(45115.5 870.38)">
          <tspan x={33.32} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={108.719} y={21.22}>
            {" Prassede Rabezzana"}
          </tspan>
          <tspan x={100} y={38.02}>
            {"(1857-1933)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M44430.5 870.38h200v50h-200z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M44430.5 870.38h200v50h-200z" />
        <text fill="#000" transform="translate(44430.5 870.38)">
          <tspan x={38.996} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={108.719} y={21.22}>
            {" Paolo Stefano Luigi"}
          </tspan>
          <tspan x={100} y={38.02}>
            {"(1858-1932)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(44410.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"41"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M44680.5 870.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M44680.5 870.38h150v50h-150z" />
        <text fill="#000" fontSize={14} transform="translate(44680.5 870.38)">
          <tspan x={21.41} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Laura Rabezzana"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1886-1937)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M46310.5 870.38h200v50h-200z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M46310.5 870.38h200v50h-200z" />
        <text fill="#000" transform="translate(46310.5 870.38)">
          <tspan x={30.969} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={108.719} y={21.22}>
            {" Maria Lucia Costanza"}
          </tspan>
          <tspan x={100} y={38.02}>
            {"(1854-1936)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(46290.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"43"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M46560.5 870.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M46560.5 870.38h200v50h-200z" />
      <text fill="#000" fontSize={14} transform="translate(46560.5 870.38)">
        <tspan x={27.363} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Francesco Riccomagno"}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(1849-1912)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M43195.5 670.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M43195.5 670.38h125v50h-125z" />
        <text fill="#000" transform="translate(43195.5 670.38)">
          <tspan x={44.453} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Carlo"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1827- 1899)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(43175.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"25"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M43395.5 670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43395.5 670.38h150v50h-150z" />
      <text fill="#000" transform="translate(43395.5 670.38)">
        <tspan x={25.336} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Luigia Piccinino"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1833-1912)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M41845.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M41845.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(41845.5 670.38)">
          <tspan x={45.91} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Gervasio"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1814-1859)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(41825.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"24"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M41595.5 670.38h200v50h-200z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M41595.5 670.38h200v50h-200z" />
        <text fill="#000" transform="translate(41595.5 670.38)">
          <tspan x={47.941} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={108.719} y={21.22}>
            {" Teresa Mazzola"}
          </tspan>
          <tspan x={100} y={38.02}>
            {"(1819-1842)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M42340.5 520.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M42340.5 520.38h150v50h-150z" />
        <text fill="#000" transform="translate(42340.5 520.38)">
          <tspan x={45.059} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Secondo"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1785-1843)"}
          </tspan>
        </text>
      </g>
    <path d="M42545.5 520.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42545.5 520.38h135v50h-135z" />
      <text fill="#000" transform="translate(42545.5 520.38)">
        <tspan x={25.289} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Luigia Borghi"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1790-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M42490.5 545.38h55" />
    <path d="M42270.5 380.38h110v30h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42270.5 380.38h110v30h-110z" />
      <text fill="#000" transform="translate(42270.5 380.38)">
        <tspan x={39.137} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={63.719} y={19.62}>
          {" Carli"}
        </tspan>
      </text>
    </g>
    <path d="M42445.5 380.38h190v30h-190z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42445.5 380.38h190v30h-190z" />
      <text fill="#000" transform="translate(42445.5 380.38)">
        <tspan x={29.535} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={103.719} y={19.62}>
          {" Catharina Boschieri"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M42380.5 395.38h65M42415.5 520.38v-62.5h0v-62.5M41845.5 695.38h-22.5 0-27.5M41410.5 895.38h95M42795.5 895.38h65M45425.5 895.38h-60 0-50M44630.5 895.38h50M46510.5 895.38h50M46410.5 870.38v-100h-1445"
    />
    <path strokeDasharray="3 4" d="M49090.5 870.38h130v50h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M49090.5 870.38h130v50h-130z" />
      <text fill="#000" transform="translate(49090.5 870.38)">
        <tspan x={65} y={21.22}>
          {"See Felice"}
        </tspan>
        <tspan x={65} y={38.02}>
          {"(1856-1924)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M49290.5 872.88h150v45h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M49290.5 872.88h150v45h-150z" />
        <text fill="#000" fontSize={14} transform="translate(49290.5 872.88)">
          <tspan x={18.66} y={18.72} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={18.72}>
            {" Angela Mortarotti"}
          </tspan>
          <tspan x={75} y={35.52}>
            {"(1859-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M49270.5 895.38" />
      <path strokeWidth={3} d="M48840.5 1070.38h200v50h-200z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M48840.5 1070.38h200v50h-200z" />
        <text fill="#000" transform="translate(48840.5 1070.38)">
          <tspan x={25.871} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={108.719} y={21.22}>
            {" Paolo Ernesto Secondo"}
          </tspan>
          <tspan x={100} y={38.02}>
            {"(1889-1969)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(48820.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"72"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M46555.5 1070.38h200v50h-200z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M46555.5 1070.38h200v50h-200z" />
        <text fill="#000" transform="translate(46555.5 1070.38)">
          <tspan x={32.926} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={108.719} y={21.22}>
            {" Gemma Riccomagno"}
          </tspan>
          <tspan x={100} y={38.02}>
            {"(1896-1995)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(46535.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"71"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M46655.5 1070.38v-100h-115v-75M48840.5 1095.38h-2030 0-55"
    />
      <path strokeWidth={3} d="M44420.5 1070.38h115v50h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M44420.5 1070.38h115v50h-115z" />
        <text fill="#000" transform="translate(44420.5 1070.38)">
          <tspan x={26.918} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={21.22}>
            {" Pasquale"}
          </tspan>
          <tspan x={57.5} y={38.02}>
            {"(1886-1863)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(44400.5 1055.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"70"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M44478 1070.38v-100h177.5v-75" />
      <path strokeWidth={3} d="M45295.5 1070.38h230v50h-230z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M45295.5 1070.38h230v50h-230z" />
        <text fill="#000" transform="translate(45295.5 1070.38)">
          <tspan x={25.969} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={123.719} y={21.22}>
            {" Secondo Francesco Antonio"}
          </tspan>
          <tspan x={115} y={38.02}>
            {"(1887-1977)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(45275.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"69"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M45575.5 1070.38h145v50h-145z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M45575.5 1070.38h145v50h-145z" />
        <text fill="#000" transform="translate(45575.5 1070.38)">
          <tspan x={28.867} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={81.219} y={21.22}>
            {" Maria Cerrina"}
          </tspan>
          <tspan x={72.5} y={38.02}>
            {"(1891-1955)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M45525.5 1095.38h50M45410.5 1070.38v-100h-45v-75" />
      <path strokeWidth={3} d="M42988 1070.38h107.5v50H42988z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M42988 1070.38h107.5v50H42988z" />
        <text fill="#000" transform="translate(42988 1070.38)">
          <tspan x={22.691} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={62.469} y={21.22}>
            {" Desiderio"}
          </tspan>
          <tspan x={53.75} y={38.02}>
            {"(1887-1980)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(42968 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"68"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M43160.5 1070.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43160.5 1070.38h145v50h-145z" />
      <text fill="#000" transform="translate(43160.5 1070.38)">
        <tspan x={13.867} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Angela Ruggerone"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1894-1975)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M40210.5 1070.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M40210.5 1070.38h100v50h-100z" />
        <text fill="#000" transform="translate(40210.5 1070.38)">
          <tspan x={29.863} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Pietro"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1878-1947)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(40190.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"67"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M40375.5 1080.38h175v30h-175z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M40375.5 1080.38h175v30h-175z" />
        <text fill="#000" transform="translate(40375.5 1080.38)">
          <tspan x={20.672} y={19.62} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={96.219} y={19.62}>
            {" Maria Luigia Binoglio"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M40375.5 1095.38h-40 0-25" />
      <path strokeWidth={3} d="M6035.5 870.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M6035.5 870.38h150v50h-150z" />
        <text fill="#000" transform="translate(6035.5 870.38)">
          <tspan x={20.414} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Giovanni Battista"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1817-1882)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(6010.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"28"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M5810.5 870.38h170v50h-170z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M5810.5 870.38h170v50h-170z" />
        <text fill="#000" transform="translate(5810.5 870.38)">
          <tspan x={25.25} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={93.719} y={21.22}>
            {" Maria Gambertolio"}
          </tspan>
          <tspan x={85} y={38.02}>
            {"(1818-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(5790.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"27"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M6035.5 895.38h-30 0-25M6110.5 870.38v-100h19605v-75"
    />
      <path strokeWidth={3} d="M4640.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M4640.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(4640.5 1070.38)">
          <tspan x={17.984} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Celeste/Celestino"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1841-1905)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(4620.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"45"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M4850.5 1070.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M4850.5 1070.38h125v50h-125z" />
        <text fill="#000" transform="translate(4850.5 1070.38)">
          <tspan x={24.18} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Rosa Muzio"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1843-1886)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M6615.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M6615.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(6615.5 1070.38)">
          <tspan x={31.766} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Eugenio Luigi"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1845-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(6595.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"46"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M6860.5 1070.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M6860.5 1070.38h150v50h-150z" />
      <text fill="#000" transform="translate(6860.5 1070.38)">
        <tspan x={24.504} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Celestina Clerici"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1847-1919)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M4740.5 1220.38h210v50h-210z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M4740.5 1220.38h210v50h-210z" />
        <text fill="#000" fontSize={14} transform="translate(4740.5 1220.38)">
          <tspan x={18.461} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={113.719} y={21.22}>
            {" Pietro Francesco Tranquillo"}
          </tspan>
          <tspan x={105} y={38.02}>
            {"(1875-1943)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(4720.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"73"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M4330.5 1220.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M4330.5 1220.38h150v50h-150z" />
        <text fill="#000" transform="translate(4330.5 1220.38)">
          <tspan x={19.133} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Adele Maranzana"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1878-1905)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M4790.5 1095.38h60M4720.5 1070.38v-50h1285v-95M6690.5 1070.38v-50h-685v-125M4735.5 1245.38h5-260"
    />
      <path strokeWidth={3} d="M4655.5 1375.38h250v50h-250z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M4655.5 1375.38h250v50h-250z" />
        <text fill="#000" transform="translate(4655.5 1375.38)">
          <tspan x={36.813} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={133.719} y={21.22}>
            {" Celestino Giovanni Federico"}
          </tspan>
          <tspan x={125} y={38.02}>
            {"(1905-1957)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(4640.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"75"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M6350.5 1220.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M6350.5 1220.38h130v50h-130z" />
        <text fill="#000" transform="translate(6350.5 1220.38)">
          <tspan x={28.211} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Luigi Pietro"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1872-1946)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(6330.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"74"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M6175.5 1220.38h140v50h-140z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M6175.5 1220.38h140v50h-140z" />
        <text fill="#000" transform="translate(6175.5 1220.38)">
          <tspan x={18.512} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={78.719} y={21.22}>
            {" Maria Bonvicino"}
          </tspan>
          <tspan x={70} y={38.02}>
            {"(1871-1955)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M6260.5 1370.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M6260.5 1370.38h125v50h-125z" />
        <text fill="#000" transform="translate(6260.5 1370.38)">
          <tspan x={25.898} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Giuseppina"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1910-1999)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M6330.5 1370.38v-125h-15M4905.5 1395.38h1355" />
    <path d="M10765.5 1220.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M10765.5 1220.38h100v50h-100z" />
      <text fill="#000" transform="translate(10765.5 1220.38)">
        <tspan x={33.465} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Luigi"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1890-1977)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(10745.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"49"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M9420.5 1220.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9420.5 1220.38h100v50h-100z" />
      <text fill="#000" transform="translate(9420.5 1220.38)">
        <tspan x={24.789} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Santina"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1885-1963)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(9400.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"51"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M10925.5 1220.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M10925.5 1220.38h125v50h-125z" />
      <text fill="#000" transform="translate(10925.5 1220.38)">
        <tspan x={15.277} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Anna Quaglino"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1905-1970)"}
        </tspan>
      </text>
    </g>
    <path d="M9210.5 1220.38h130v50h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9210.5 1220.38h130v50h-130z" />
      <text fill="#000" transform="translate(9210.5 1220.38)">
        <tspan x={16.719} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={73.719} y={21.22}>
          {" Francesco Orsi"}
        </tspan>
        <tspan x={65} y={38.02}>
          {"(1875-1950)"}
        </tspan>
      </text>
    </g>
    <path d="M9955.5 1070.38h165v50h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9955.5 1070.38h165v50h-165z" />
      <text fill="#000" transform="translate(9955.5 1070.38)">
        <tspan x={41.402} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={91.219} y={21.22}>
          {" Rosa Poggio"}
        </tspan>
        <tspan x={82.5} y={38.02}>
          {"(1866-1952)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M10170.5 1070.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M10170.5 1070.38h100v50h-100z" />
        <text fill="#000" transform="translate(10170.5 1070.38)">
          <tspan x={29.324} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Emilio"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1858-1924)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(10150.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"47"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M24400.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M24400.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(24400.5 1070.38)">
          <tspan x={20.125} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Giuseppe Angelo"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1848-1922)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(24380.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"48"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M24600.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M24600.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(24600.5 1070.38)">
          <tspan x={13.781} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Giuseppina Cerrato"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1855-1928)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M25625.5 1070.38h190v50h-190z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M25625.5 1070.38h190v50h-190z" />
        <text fill="#000" transform="translate(25625.5 1070.38)">
          <tspan x={38.133} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={103.719} y={21.22}>
            {" Antonio Giuseppe"}
          </tspan>
          <tspan x={95} y={38.02}>
            {"(1853-1935)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(25605.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"55"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M10170.5 1095.38h-25 0-25M24550.5 1095.38h50" />
      <path strokeWidth={3} d="M24935.5 1220.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M24935.5 1220.38h100v50h-100z" />
        <text fill="#000" transform="translate(24935.5 1220.38)">
          <tspan x={25.922} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Tarsilla"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1882-1962)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(24915.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"50"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M25085.5 1220.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M25085.5 1220.38h100v50h-100z" />
        <text fill="#000" transform="translate(25085.5 1220.38)">
          <tspan x={22.359} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Edoardo"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1880-1952)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(25065.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"52"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M18311.5 1220.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M18311.5 1220.38h100v50h-100z" />
        <text fill="#000" transform="translate(18311.5 1220.38)">
          <tspan x={29.656} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Luigia"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1885-1950)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(18291.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"53"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M25435.5 1220.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M25435.5 1220.38h100v50h-100z" />
        <text fill="#000" transform="translate(25435.5 1220.38)">
          <tspan x={25.617} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Alfredo"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1881-1960)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(25415.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"56"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M25285.5 1220.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M25285.5 1220.38h100v50h-100z" />
        <text fill="#000" transform="translate(25285.5 1220.38)">
          <tspan x={23.711} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Gemma"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1885-1956)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(25265.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"58"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M18466.5 1230.38h141.5v30h-141.5z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M18466.5 1230.38h141.5v30h-141.5z" />
      <text fill="#000" transform="translate(18466.5 1230.38)">
        <tspan x={12.719} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={79.469} y={19.62}>
          {" George Sepulveda"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M25405.5 1070.38h160v50h-160z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M25405.5 1070.38h160v50h-160z" />
        <text fill="#000" transform="translate(25405.5 1070.38)">
          <tspan x={30.547} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={88.719} y={21.22}>
            {" Adele De Volpe"}
          </tspan>
          <tspan x={80} y={38.02}>
            {"(1848-1899)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M25800.5 1220.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M25800.5 1220.38h100v50h-100z" />
        <text fill="#000" transform="translate(25800.5 1220.38)">
          <tspan x={27.047} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Pericle"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1883-1919)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(25780.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"57"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M26085.5 1220.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M26085.5 1220.38h100v50h-100z" />
        <text fill="#000" transform="translate(26085.5 1220.38)">
          <tspan x={32.547} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Rosa"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1888-1983)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(26065.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"59"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M26230.5 1220.38h175v50h-175z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M26230.5 1220.38h175v50h-175z" />
        <text fill="#000" transform="translate(26230.5 1220.38)">
          <tspan x={19.422} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={96.219} y={21.22}>
            {" Giacomo Giulio Travo"}
          </tspan>
          <tspan x={87.5} y={38.02}>
            {"(1886-1962)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M25625.5 1095.38h-30 0-30M26185.5 1245.38h45M26190.5 1245.38h-2.5 0-2.5"
    />
      <path strokeWidth={3} d="M28605.5 1220.38h174.769v50H28605.5z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path
          fill="none"
          stroke="none"
          d="M28605.5 1220.38h174.769v50H28605.5z"
        />
        <text fill="#000" transform="translate(28605.5 1220.38)">
          <tspan x={29.041} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={96.103} y={21.22}>
            {" Giuseppe Rolando"}
          </tspan>
          <tspan x={87.385} y={38.02}>
            {"(1873-1940)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(28585.5 1205.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"60"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M28905.5 1230.38h115v30h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28905.5 1230.38h115v30h-115z" />
        <text fill="#000" transform="translate(28905.5 1230.38)">
          <tspan x={17.656} y={19.62} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={19.62}>
            {" Ida Baracco"}
          </tspan>
        </text>
      </g>
    <path d="M29705.5 1080.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M29705.5 1080.38h150v30h-150z" />
      <text fill="#000" transform="translate(29705.5 1080.38)">
        <tspan x={17.328} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Rosa Gambertolio"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M29905.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M29905.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(29905.5 1070.38)">
          <tspan x={22.547} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {"  Francesco Carlo"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1866-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(29885.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"61"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M30095.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M30095.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(30095.5 1070.38)">
          <tspan x={19.273} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Ing. Antonio Luigi"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1889-1964)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(30075.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"62"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M30280.5 1080.38h145v30h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M30280.5 1080.38h145v30h-145z" />
      <text fill="#000" transform="translate(30280.5 1080.38)">
        <tspan x={13.293} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={19.62}>
          {" Angela Rabezzana"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M30245.5 1095.38h35" />
      <path strokeWidth={3} d="M38480.5 1220.38h200v50h-200z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M38480.5 1220.38h200v50h-200z" />
        <text fill="#000" transform="translate(38480.5 1220.38)">
          <tspan x={22.781} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={108.719} y={21.22}>
            {" Maddalena Riccomagno"}
          </tspan>
          <tspan x={100} y={38.02}>
            {"(1884-1965)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M38575.5 1220.38v-62.5h0v-62.5" />
      <path strokeWidth={3} d="M41390.5 1220.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M41390.5 1220.38h150v50h-150z" />
        <text fill="#000" transform="translate(41390.5 1220.38)">
          <tspan x={45.879} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Riccardo"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1884-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M41465.5 1220.38v-162.5h0v-162.5" />
    <path d="M40230.5 1370.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40230.5 1370.38h135v50h-135z" />
      <text fill="#000" transform="translate(40230.5 1370.38)">
        <tspan x={21.844} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Riccardo Luigi"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1906-1989)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M40298 1370.38v-100h47.5v-175" />
      <path strokeWidth={3} d="M38705.5 1370.38h160v50h-160z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M38705.5 1370.38h160v50h-160z" />
        <text fill="#000" transform="translate(38705.5 1370.38)">
          <tspan x={22.988} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={88.719} y={21.22}>
            {" Giuseppe Michele"}
          </tspan>
          <tspan x={80} y={38.02}>
            {"(1906-1969)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(41370.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"77"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(38685.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"79"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M38785.5 1370.38v-125h5" />
      <path strokeWidth={3} d="M37060.5 1370.38h120v50h-120z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M37060.5 1370.38h120v50h-120z" />
        <text fill="#000" transform="translate(37060.5 1370.38)">
          <tspan x={43.465} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={68.719} y={21.22}>
            {" Luigi"}
          </tspan>
          <tspan x={60} y={38.02}>
            {"(1910-1986)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(37035.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"76"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M45475.5 1370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M45475.5 1370.38h150v50h-150z" />
        <text fill="#000" transform="translate(45475.5 1370.38)">
          <tspan x={25.223} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Giacomo Carlo"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1914-1943)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(45455.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"78"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M45550.5 1370.38v-137.5h0v-137.5M29000.5 770.38q0-10 10-10M29020.5 770.38q0-10-10-10M29020.5 770.38h800v-50M40335.5 1245.38q0-15 10-15M40345.5 1230.38q11 1 11 15M40335.5 1245.38h-1245 0-77.5"
    />
      <path strokeWidth={3} d="M29805.5 1220.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M29805.5 1220.38h150v50h-150z" />
        <text fill="#000" transform="translate(29805.5 1220.38)">
          <tspan x={27.262} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Clarina Luigina"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1897-1918)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(29785.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"44"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M29560.5 1080.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M29560.5 1080.38h125v30h-125z" />
      <text fill="#000" transform="translate(29560.5 1080.38)">
        <tspan x={16.551} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Rosa Piccinino"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M29510.5 1095.38h50" />
      <path strokeWidth={3} d="M29465.5 1220.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M29465.5 1220.38h150v50h-150z" />
        <text fill="#000" transform="translate(29465.5 1220.38)">
          <tspan x={55.281} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Mario"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1890-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(29445.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"91"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M29615.5 1245.38h190M29538 1220.38v-62.5h0v-62.5" />
    <path d="M29635.5 1370.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M29635.5 1370.38h150v50h-150z" />
      <text fill="#000" transform="translate(29635.5 1370.38)">
        <tspan x={25.359} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Tommaso Luigi"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1918-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M29710.5 1370.38v-65h0v-60" />
      <path strokeWidth={3} d="M6773 1220.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M6773 1220.38h130v50h-130z" />
        <text fill="#000" transform="translate(6773 1220.38)">
          <tspan x={16.68} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Giovanni Paolo"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1870-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(6753 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"92"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M6955.5 1230.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M6955.5 1230.38h125v30h-125z" />
      <text fill="#000" transform="translate(6955.5 1230.38)">
        <tspan x={13.273} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Angela Ciattino"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M6865.5 1370.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M6865.5 1370.38h125v50h-125z" />
        <text fill="#000" transform="translate(6865.5 1370.38)">
          <tspan x={25.828} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Pietro Luigi"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1904-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(6845.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"93"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M6903 1245.38h52.5M6928 1370.38v-62.5h0v-62.5" />
      <path strokeWidth={3} d="M1905.5 670.38h145v50h-145z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1905.5 670.38h145v50h-145z" />
        <text fill="#000" transform="translate(1905.5 670.38)">
          <tspan x={41.559} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={81.219} y={21.22}>
            {" Giuseppe"}
          </tspan>
          <tspan x={72.5} y={38.02}>
            {"(1804-1876)"}
          </tspan>
        </text>
      </g>
    <path d="M2995.5 530.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2995.5 530.38h150v30h-150z" />
      <text fill="#000" transform="translate(2995.5 530.38)">
        <tspan x={30.836} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Rosa Varvello"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M1650.5 670.38h165v50h-165z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1650.5 670.38h165v50h-165z" />
        <text fill="#000" transform="translate(1650.5 670.38)">
          <tspan x={18.07} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={91.219} y={21.22}>
            {" Domenica Maggiora"}
          </tspan>
          <tspan x={82.5} y={38.02}>
            {"(1808-1861)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M1680.5 870.38h160v50h-160z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1680.5 870.38h160v50h-160z" />
        <text fill="#000" transform="translate(1680.5 870.38)">
          <tspan x={23.227} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={88.719} y={21.22}>
            {" Luigia Maddalena"}
          </tspan>
          <tspan x={80} y={38.02}>
            {"(1847-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M1255.5 870.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1255.5 870.38h150v50h-150z" />
        <text fill="#000" transform="translate(1255.5 870.38)">
          <tspan x={26.148} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Pietro Giovanni"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1839-)"}
          </tspan>
        </text>
      </g>
    <path d="M1200.5 680.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M1200.5 680.38h100v30h-100z" />
      <text fill="#000" transform="translate(1200.5 680.38)">
        <tspan x={24.023} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Stefano"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M1350.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1350.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(1350.5 670.38)">
          <tspan
            x={26.723}
            y={21.22}
            fontFamily="Noto Color Emoji"
            fontSize={14}
          >
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22} fontSize={14}>
            {" Teresa Celoria"}
          </tspan>
          <tspan x={75} y={38.02} fontSize={14}>
            {"(1807-1843)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M1300.5 695.38h50M1330.5 870.38v-50h0v-125" />
    <path d="M1125.5 530.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M1125.5 530.38h100v30h-100z" />
      <text fill="#000" transform="translate(1125.5 530.38)">
        <tspan x={23.609} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Josephi"}
        </tspan>
      </text>
    </g>
    <path d="M1275.5 530.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M1275.5 530.38h100v30h-100z" />
      <text fill="#000" transform="translate(1275.5 530.38)">
        <tspan x={21.633} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Theresie"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M1225.5 545.38h50M1250.5 680.38v-67.5h0v-67.5" />
      <path strokeWidth={3} d="M1400.5 1220.38h220v50h-220z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1400.5 1220.38h220v50h-220z" />
        <text fill="#000" transform="translate(1400.5 1220.38)">
          <tspan x={19.156} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={118.719} y={21.22}>
            {"Giuseppe Desiderio Pasquale"}
          </tspan>
          <tspan x={110} y={38.02}>
            {"(1877-)"}
          </tspan>
        </text>
      </g>
    <path d="M1695.5 1230.38h145v30h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M1695.5 1230.38h145v30h-145z" />
      <text fill="#000" transform="translate(1695.5 1230.38)">
        <tspan x={12.5} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={19.62}>
          {" Margherita Raviola"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M1695.5 1245.38h-50 0-25" />
      <path strokeWidth={3} d="M1760.5 1370.38h165v50h-165z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1760.5 1370.38h165v50h-165z" />
        <text fill="#000" transform="translate(1760.5 1370.38)">
          <tspan x={19.055} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={91.219} y={21.22}>
            {" Pietro Luigi Lorenzo"}
          </tspan>
          <tspan x={82.5} y={38.02}>
            {"(1903-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M1830.5 1370.38v-50h-170v-75" />
    <g transform="translate(1885.5 645.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"95"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(1630.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"96"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(1660.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"97"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(1235.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"98"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(1380.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"99"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(1740.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"100"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M3940.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M3940.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(3940.5 670.38)">
          <tspan x={46.289} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Giovanni"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1801-1859)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(3920.5 655.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"101"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M4140.5 680.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M4140.5 680.38h125v30h-125z" />
      <text fill="#000" transform="translate(4140.5 680.38)">
        <tspan x={12.742} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Rosa Martinotti"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M4240.5 870.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M4240.5 870.38h150v50h-150z" />
        <text fill="#000" transform="translate(4240.5 870.38)">
          <tspan x={58.461} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Luigi"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1824-1867)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(4220.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"102"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M4055.5 880.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M4055.5 880.38h125v30h-125z" />
      <text fill="#000" transform="translate(4055.5 880.38)">
        <tspan x={19.188} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Rosa Faldella"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M4440.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M4440.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(4440.5 1070.38)">
          <tspan x={51.695} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Angela"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1855-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(4420.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"103"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M4180.5 895.38h60M4090.5 695.38h50M1680.5 895.38h-115 0-160M1510.5 1220.38v-162.5h0v-162.5M4640.5 1095.38h-50"
    />
    <path d="M4185.5 1080.38h190v30h-190z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M4185.5 1080.38h190v30h-190z" />
      <text fill="#000" transform="translate(4185.5 1080.38)">
        <tspan x={29.781} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={103.719} y={19.62}>
          {" Giovanni Maranzana"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M4780.5 1375.38v-55h-175v-75" />
    <g transform="translate(4305.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"104"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M1815.5 695.38h90" />
      <path strokeWidth={3} d="M33610.5 1370.38h155v50h-155z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M33610.5 1370.38h155v50h-155z" />
        <text fill="#000" transform="translate(33610.5 1370.38)">
          <tspan x={15.059} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={86.219} y={21.22}>
            {" Sebastiano Romolo"}
          </tspan>
          <tspan x={77.5} y={38.02}>
            {"(1899-1987)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(33590.5 1345.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"108"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M33688 1370.38v-150h637.5v-125" />
      <path strokeWidth={3} d="M1335.5 1370.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1335.5 1370.38h100v50h-100z" />
        <text fill="#000" transform="translate(1335.5 1370.38)">
          <tspan x={30.281} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Mario"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1913-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(1315.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"152"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M1385.5 1370.38v-50h275v-75" />
    <path d="M1140.5 1380.38h130v30h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M1140.5 1380.38h130v30h-130z" />
      <text fill="#000" transform="translate(1140.5 1380.38)">
        <tspan x={19.344} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={73.719} y={19.62}>
          {" Elena Avignon"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M1335.5 1390.38v5h-65" />
      <path strokeWidth={3} d="M1240.5 1520.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1240.5 1520.38h130v50h-130z" />
        <text fill="#000" transform="translate(1240.5 1520.38)">
          <tspan x={36.375} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Graziella"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1947-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(1220.5 1500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"111"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M1305.5 1395.38v62.5h0v62.5" />
    <path strokeDasharray="4 5" d="M555.5 220.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M555.5 220.38h150v50h-150z" />
      <text fill="#000" transform="translate(555.5 220.38)">
        <tspan x={75} y={21.22}>
          {"See Pauli Stephani"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1711-)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M670.5 370.38h140v50h-140z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M670.5 370.38h140v50h-140z" />
        <text fill="#000" transform="translate(670.5 370.38)">
          <tspan x={28.949} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={78.719} y={21.22}>
            {" Pauli Antoni"}
          </tspan>
          <tspan x={70} y={38.02}>
            {"(1735-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(650.5 355.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"80"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M475.5 380.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M475.5 380.38h125v30h-125z" />
      <text fill="#000" transform="translate(475.5 380.38)">
        <tspan x={18.813} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Anna Faldella"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M670.5 395.38H643h0-42.5M745.5 370.38v-50h0v-75" />
      <path strokeWidth={3} d="M680.5 520.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M680.5 520.38h150v50h-150z" />
        <text fill="#000" transform="translate(680.5 520.38)">
          <tspan x={47.109} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Vincenti"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1782-1853)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(660.5 500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"83"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M900.5 520.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M900.5 520.38h150v50h-150z" />
        <text fill="#000" transform="translate(900.5 520.38)">
          <tspan x={25.48} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Maria Gerrone"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1783-1841)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(880.5 500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"82"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M830.5 380.38h120v30h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M830.5 380.38h120v30h-120z" />
      <text fill="#000" transform="translate(830.5 380.38)">
        <tspan x={16.383} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={19.62}>
          {" Pauli Gerrone"}
        </tspan>
      </text>
    </g>
    <path d="M1000.5 380.38h160v30h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M1000.5 380.38h160v30h-160z" />
      <text fill="#000" transform="translate(1000.5 380.38)">
        <tspan x={22.242} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={88.719} y={19.62}>
          {" Francesca Guazzi"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M950.5 395.38h50M975.5 520.38v-62.5h0v-62.5" />
      <path strokeWidth={3} d="M790.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M790.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(790.5 670.38)">
          <tspan x={31.414} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Gian. Battista"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1815- 1889)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(760.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"87"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M1000.5 670.38h165v50h-165z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1000.5 670.38h165v50h-165z" />
        <text fill="#000" transform="translate(1000.5 670.38)">
          <tspan x={23.422} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={91.219} y={21.22}>
            {" Teresa Maranzana"}
          </tspan>
          <tspan x={82.5} y={38.02}>
            {"(1819-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(980.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"86"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M895.5 870.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M895.5 870.38h150v50h-150z" />
        <text fill="#000" transform="translate(895.5 870.38)">
          <tspan x={30.148} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Filippo Fedele"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1850-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(870.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"89"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M1108 880.38h122.5v30H1108z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M1108 880.38h122.5v30H1108z" />
      <text fill="#000" transform="translate(1108 880.38)">
        <tspan x={18.813} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={69.969} y={19.62}>
          {" Teresa Iviglia"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M1010.5 1220.38h160v50h-160z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1010.5 1220.38h160v50h-160z" />
        <text fill="#000" transform="translate(1010.5 1220.38)">
          <tspan x={17.719} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={88.719} y={21.22}>
            {" Maurizio (Giovanni)"}
          </tspan>
          <tspan x={80} y={38.02}>
            {"(1876-1961)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M810.5 1230.38h155v30h-155z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M810.5 1230.38h155v30h-155z" />
        <text fill="#000" transform="translate(810.5 1230.38)">
          <tspan x={14.609} y={19.62} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={86.219} y={19.62}>
            {" Ernesta Martinengo"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M545.5 1370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M545.5 1370.38h150v50h-150z" />
        <text fill="#000" transform="translate(545.5 1370.38)">
          <tspan x={32.492} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Stefano Luigi"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1911-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(525.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"105"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M940.5 1370.38H1123v50H940.5z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M940.5 1370.38H1123v50H940.5z" />
        <text fill="#000" transform="translate(940.5 1370.38)">
          <tspan x={18.164} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={99.969} y={21.22}>
            {" Augusto Ercole (Giulio)"}
          </tspan>
          <tspan x={91.25} y={38.02}>
            {"(1914-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(920.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"106"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M620.5 1370.38v-50H988v-75M1031.75 1370.38v-50H988v-75"
    />
    <g transform="translate(990.5 1195.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"109"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M750.5 1380.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M750.5 1380.38h150v30h-150z" />
      <text fill="#000" transform="translate(750.5 1380.38)">
        <tspan x={13.719} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Evelina Martinengo"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M900.5 1395.38h40" />
      <path strokeWidth={3} d="M845.5 1520.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M845.5 1520.38h150v50h-150z" />
        <text fill="#000" transform="translate(845.5 1520.38)">
          <tspan x={53.477} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Sergio"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1942-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(825.5 1500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"112"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M920.5 1520.38v-62.5h0v-62.5M965.5 1245.38h45M830.5 545.38h70M865.5 670.38v-62.5h0v-62.5M940.5 695.38h60M970.5 870.38v-87.5h0v-87.5M1045.5 895.38h62.5M1080.5 1220.38v-235h0v-90"
    />
      <path strokeWidth={3} d="M230.5 520.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M230.5 520.38h150v50h-150z" />
        <text fill="#000" transform="translate(230.5 520.38)">
          <tspan x={32.164} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Angela Maria"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1776-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(210.5 500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"85"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M130.5 370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M130.5 370.38h150v50h-150z" />
        <text fill="#000" transform="translate(130.5 370.38)">
          <tspan x={38.164} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Jois Antoni"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1741-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(110.5 350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"81"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M330.5 380.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M330.5 380.38h100v30h-100z" />
      <text fill="#000" transform="translate(330.5 380.38)">
        <tspan x={23.336} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {"  Joanna"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M80.5 230.38h100v30h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M80.5 230.38h100v30h-100z" />
        <text fill="#000" transform="translate(80.5 230.38)">
          <tspan x={13.445} y={19.62} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={19.62}>
            {"  Jois Bapta"}
          </tspan>
        </text>
      </g>
    <path d="M230.5 230.38h165v30h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M230.5 230.38h165v30h-165z" />
      <text fill="#000" transform="translate(230.5 230.38)">
        <tspan x={16.281} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={91.219} y={19.62}>
          {" Angela Maria Minetti"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M180.5 245.38h50" />
    <path d="M65.5 130.38h130v30h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M65.5 130.38h130v30h-130z" />
      <text fill="#000" transform="translate(65.5 130.38)">
        <tspan x={21.07} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={73.719} y={19.62}>
          {" Jois Stephani"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M130.5 230.38v-35h0v-35M205.5 370.38v-62.5h0v-62.5M280.5 395.38h50M305.5 520.38v-62.5h0v-62.5"
    />
      <path strokeWidth={3} d="M445.5 520.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M445.5 520.38h150v50h-150z" />
        <text fill="#000" transform="translate(445.5 520.38)">
          <tspan x={51.07} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Andrea"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1771-after 1829)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(425.5 500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"84"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M380.5 545.38h65M520.5 520.38v-50h125v-75M755.5 520.38v-50h-110v-75"
    />
      <path strokeWidth={3} d="M545.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M545.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(545.5 670.38)">
          <tspan x={22.934} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Maria Casalone"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1804-1853)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M345.5 670.38h140v50h-140z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M345.5 670.38h140v50h-140z" />
        <text fill="#000" transform="translate(345.5 670.38)">
          <tspan
            x={37.359}
            y={21.22}
            fontFamily="Noto Color Emoji"
            fontSize={14}
          >
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={78.719} y={21.22} fontSize={14}>
            {" Valentino"}
          </tspan>
          <tspan x={70} y={38.02} fontSize={14}>
            {"(1804-1842)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(330.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"88"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M455.5 870.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M455.5 870.38h100v50h-100z" />
        <text fill="#000" transform="translate(455.5 870.38)">
          <tspan x={26.07} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Andrea"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1838-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(435.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"90"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M250.5 880.38h140v30h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M250.5 880.38h140v30h-140z" />
      <text fill="#000" transform="translate(250.5 880.38)">
        <tspan x={16.664} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={19.62}>
          {" Angela Colombo"}
        </tspan>
      </text>
    </g>
    <path d="M485.5 1070.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M485.5 1070.38h100v50h-100z" />
      <text fill="#000" transform="translate(485.5 1070.38)">
        <tspan x={19.047} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Valentino"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1861-)"}
        </tspan>
      </text>
    </g>
    <path d="M635.5 1080.38h140v30h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M635.5 1080.38h140v30h-140z" />
      <text fill="#000" transform="translate(635.5 1080.38)">
        <tspan x={19.898} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={19.62}>
          {" Anna Allisaiardi"}
        </tspan>
      </text>
    </g>
    <path d="M395.5 1220.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M395.5 1220.38h200v50h-200z" />
      <text fill="#000" transform="translate(395.5 1220.38)">
        <tspan x={11.359} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Francesco Giovanni Battista"}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(1896-)"}
        </tspan>
      </text>
    </g>
    <path d="M640.5 1220.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M640.5 1220.38h150v50h-150z" />
      <text fill="#000" transform="translate(640.5 1220.38)">
        <tspan x={11.977} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Agnese Lucia Maria"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1896-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M505.5 870.38v-100h15v-75M455.5 895.38h-65 0M585.5 1095.38h50M715.5 1220.38v-50h-105v-70M535.5 1070.38v-100h-110v-75"
    />
      <path strokeWidth={3} d="M625.5 870.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M625.5 870.38h105v50h-105z" />
        <text fill="#000" transform="translate(625.5 870.38)">
          <tspan x={23.805} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Susanna"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1840-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(605.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"107"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M678 870.38v-100H520.5v-70M485.5 695.38h60M415.5 670.38v-62.5h0v-62.5"
    />
      <path strokeWidth={3} d="M24085.5 1220.38h180v50h-180z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M24085.5 1220.38h180v50h-180z" />
        <text fill="#000" transform="translate(24085.5 1220.38)">
          <tspan x={29.414} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={98.719} y={21.22}>
            {" Rosa Clara Beatrice"}
          </tspan>
          <tspan x={90} y={38.02}>
            {"(1878-1910)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(24065.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62} paintOrder="stroke">
            {"113"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M23885.5 1230.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M23885.5 1230.38h150v30h-150z" />
      <text fill="#000" transform="translate(23885.5 1230.38)">
        <tspan x={12.184} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Secondo Sattamino"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M5750.5 1520.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M5750.5 1520.38h130v50h-130z" />
        <text fill="#000" transform="translate(5750.5 1520.38)">
          <tspan x={45.281} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Mario"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1940-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(5730.5 1500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"117"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M5335.5 1520.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M5335.5 1520.38h130v50h-130z" />
        <text fill="#000" transform="translate(5335.5 1520.38)">
          <tspan x={42.836} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Oreste"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1937-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(5315.5 1500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"116"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M4920.5 1520.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M4920.5 1520.38h130v50h-130z" />
        <text fill="#000" transform="translate(4920.5 1520.38)">
          <tspan x={44.656} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Luigia"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1932-2018)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(4900.5 1500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"115"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M4500.5 1520.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M4500.5 1520.38h130v50h-130z" />
        <text fill="#000" transform="translate(4500.5 1520.38)">
          <tspan x={45.633} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Adele"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1928-1963)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(4480.5 1500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"114"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M4565.5 1520.38v-50h680v-70M5400.5 1520.38v-50h-155v-70"
    />
    <path
      fill="none"
      d="M4985.5 1520.38v-50h260v-75M5815.5 1520.38v-50h-570v-75"
    />
    <g transform="translate(6240.5 1345.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"118"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M1995.5 1370.38h160v50h-160z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1995.5 1370.38h160v50h-160z" />
        <text fill="#000" fontSize={14} transform="translate(1995.5 1370.38)">
          <tspan x={10.91} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={88.719} y={21.22}>
            {" Margherita Raimondo"}
          </tspan>
          <tspan x={80} y={38.02}>
            {"(1913-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M1925.5 1395.38h70" />
      <path strokeWidth={3} d="M1730.5 1520.38h180v50h-180z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1730.5 1520.38h180v50h-180z" />
        <text fill="#000" transform="translate(1730.5 1520.38)">
          <tspan x={25} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={98.719} y={21.22}>
            {" Giuseppe Francesco"}
          </tspan>
          <tspan x={90} y={38.02}>
            {"(1934-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(1710.5 1500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"119"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M1960.5 1520.38h105v50h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M1960.5 1520.38h105v50h-105z" />
      <text fill="#000" transform="translate(1960.5 1520.38)">
        <tspan x={29.422} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={61.219} y={21.22}>
          {" Franco"}
        </tspan>
        <tspan x={52.5} y={38.02}>
          {"(1939-)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(1940.5 1500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"120"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M1820.5 1520.38v-50h130v-75M2013 1520.38v-50h-62.5v-75"
    />
      <path strokeWidth={3} d="M35390.5 1370.38h120v50h-120z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M35390.5 1370.38h120v50h-120z" />
        <text fill="#000" transform="translate(35390.5 1370.38)">
          <tspan x={39.656} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={68.719} y={21.22}>
            {" Primo"}
          </tspan>
          <tspan x={60} y={38.02}>
            {"(1907-2005)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(35370.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"121"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M35450.5 1370.38v-150h-1125v-120M28780.27 1245.38h125.23-5M43095.5 1095.38h65M30135.5 670.38v-50h-315v-75M42945 770.38h-1352v100"
    />
      <path strokeWidth={3} d="M45125.5 1070.38h120v50h-120z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M45125.5 1070.38h120v50h-120z" />
        <text fill="#000" transform="translate(45125.5 1070.38)">
          <tspan x={43.465} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={68.719} y={21.22}>
            {" Luigi"}
          </tspan>
          <tspan x={60} y={38.02}>
            {"(1882-1934)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(45105.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"123"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M45185.5 1070.38v-100h180v-70" />
    <path d="M5935.5 1520.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M5935.5 1520.38h125v50h-125z" />
      <text fill="#000" transform="translate(5935.5 1520.38)">
        <tspan x={12.906} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Ivana Corazzari"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1940-)"}
        </tspan>
      </text>
    </g>
    <path d="M5510.5 1520.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M5510.5 1520.38h120v50h-120z" />
      <text fill="#000" transform="translate(5510.5 1520.38)">
        <tspan x={18.211} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Laura Cerruti"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1938-)"}
        </tspan>
      </text>
    </g>
    <path d="M5085.5 1520.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M5085.5 1520.38h115v50h-115z" />
      <text fill="#000" transform="translate(5085.5 1520.38)">
        <tspan x={20.047} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Dino Gasco"}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(1932-2019)"}
        </tspan>
      </text>
    </g>
    <path d="M4655.5 1530.38h145v30h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M4655.5 1530.38h145v30h-145z" />
      <text fill="#000" transform="translate(4655.5 1530.38)">
        <tspan x={14.898} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={19.62}>
          {" Giuseppe Balliano"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M4630.5 1545.38h25M5050.5 1545.38h35M5465.5 1545.38h45M5880.5 1545.38h55"
    />
    <path d="M5430.5 1670.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M5430.5 1670.38h120v50h-120z" />
      <text fill="#000" transform="translate(5430.5 1670.38)">
        <tspan x={34.703} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Claudio"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1965-)"}
        </tspan>
      </text>
    </g>
    <path d="M5850.5 1670.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M5850.5 1670.38h120v50h-120z" />
      <text fill="#000" transform="translate(5850.5 1670.38)">
        <tspan x={40.391} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Paolo"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1968-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M5490.5 1670.38v-62.5h0v-62.5M5910.5 1670.38v-62.5h0v-62.5"
    />
    <g transform="translate(5490.5 1500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"124"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(5410.5 1650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"125"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M29400.5 1070.38h110v50h-110z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M29400.5 1070.38h110v50h-110z" />
        <text fill="#000" transform="translate(29400.5 1070.38)">
          <tspan x={28.371} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={63.719} y={21.22}>
            {" Antonio"}
          </tspan>
          <tspan x={55} y={38.02}>
            {"(1858-1927)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M46105.5 1070.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M46105.5 1070.38h130v50h-130z" />
        <text fill="#000" transform="translate(46105.5 1070.38)">
          <tspan x={45.473} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Maria"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1894-1973)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M46170.5 1070.38v-100h-770" />
      <path strokeWidth={3} d="M46280.5 1070.38h170v50h-170z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M46280.5 1070.38h170v50h-170z" />
        <text fill="#000" transform="translate(46280.5 1070.38)">
          <tspan x={18.285} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={93.719} y={21.22}>
            {" Antonio Riccomagno"}
          </tspan>
          <tspan x={85} y={38.02}>
            {"(1889-1964)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M46365.5 1070.38v-100h175v-45M46280.5 1095.38h-40 0-5"
    />
    <path d="M10095.5 1220.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M10095.5 1220.38h100v50h-100z" />
      <text fill="#000" transform="translate(10095.5 1220.38)">
        <tspan x={33.906} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Nina"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1888)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(10075.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"126"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M9280.5 1370.38h185v50h-185z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9280.5 1370.38h185v50h-185z" />
      <text fill="#000" transform="translate(9280.5 1370.38)">
        <tspan x={24.203} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={101.219} y={21.22}>
          {" Joseph Domenic Orsi"}
        </tspan>
        <tspan x={92.5} y={38.02}>
          {"(1905-1983)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(9255.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"127"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M495.5 1220.38v-50h115v-75" />
    <path d="M300.5 1070.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M300.5 1070.38h150v50h-150z" />
      <text fill="#000" transform="translate(300.5 1070.38)">
        <tspan x={20.57} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Giuseppe Angelo"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1868-)"}
        </tspan>
      </text>
    </g>
    <path d="M95.5 1070.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M95.5 1070.38h150v50h-150z" />
      <text fill="#000" transform="translate(95.5 1070.38)">
        <tspan x={17.234} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Giuseppa Zublena"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1879)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M375.5 1070.38v-100h50v-75M245.5 1095.38h55" />
    <g transform="translate(280.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"128"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M190.5 1370.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M190.5 1370.38h100v50h-100z" />
      <text fill="#000" transform="translate(190.5 1370.38)">
        <tspan x={35.805} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Ugo"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1913-)"}
        </tspan>
      </text>
    </g>
    <path d="M.5 1380.38h120v30H.5z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M.5 1380.38h120v30H.5z" />
      <text fill="#000" transform="translate(.5 1380.38)">
        <tspan x={17.273} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={19.62}>
          {" Enrica Ghioni"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M120.5 1395.38h70" />
    <g transform="translate(170.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"129"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M240.5 1370.38v-50h30v-225M1240.5 1545.38h-115 0-130"
    />
      <path strokeWidth={3} d="M1480.5 1370.38h95v50h-95z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1480.5 1370.38h95v50h-95z" />
        <text fill="#000" transform="translate(1480.5 1370.38)">
          <tspan x={30.961} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={56.219} y={21.22}>
            {" Luigi"}
          </tspan>
          <tspan x={47.5} y={38.02}>
            {"(1920-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(1460.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"130"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M1528 1370.38v-50h132.5v-50M29855.5 1095.38h50M29880.5 1220.38v-62.5h0v-62.5M33530.5 895.38h4795v5"
    />
      <path strokeWidth={3} d="M30420.5 870.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M30420.5 870.38h150v50h-150z" />
        <text fill="#000" transform="translate(30420.5 870.38)">
          <tspan x={33.254} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Gian Battista"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1813-1888)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(30400.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"131"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M30615.5 880.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M30615.5 880.38h150v30h-150z" />
      <text fill="#000" transform="translate(30615.5 880.38)">
        <tspan x={25.273} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Teresa Fontana"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M30615.5 895.38h-45 45" />
      <path strokeWidth={3} d="M30520.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M30520.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(30520.5 1070.38)">
          <tspan x={22.906} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Placido Epifanio"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1854-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(30500.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"132"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M30845.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M30845.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(30845.5 1070.38)">
          <tspan x={38.566} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Maddalena"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1855-1904)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M30670.5 1095.38h175v-5" />
    <g transform="translate(30825.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"133"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M30675.5 1220.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M30675.5 1220.38h150v50h-150z" />
        <text fill="#000" transform="translate(30675.5 1220.38)">
          <tspan x={44.059} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Giuseppe"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1888-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(30655.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"134"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M30865.5 1230.38h135v30h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M30865.5 1230.38h135v30h-135z" />
      <text fill="#000" transform="translate(30865.5 1230.38)">
        <tspan x={21.813} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={19.62}>
          {" Angela Berruti"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M30825.5 1245.38h40" />
      <path strokeWidth={3} d="M30770.5 1370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M30770.5 1370.38h150v50h-150z" />
        <text fill="#000" transform="translate(30770.5 1370.38)">
          <tspan x={29.016} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Stefano Felice"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1913-1943)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(30750.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"135"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M29955.5 870.38v-50h-420v-50M29980.5 1070.38v-100h90v-75M30170.5 1070.38v-100h-100v-75M30495.5 870.38v-100h-250v-75M30595.5 1070.38v-87.5h0v-87.5M30750.5 1220.38v-62.5h0v-62.5M30845.5 1370.38v-62.5h0v-62.5M2885.5 545.38h110M4440.5 1095.38h-30 0-35M4405.5 1220.38v-62.5h0v-62.5"
    />
      <path strokeWidth={3} d="M3800.5 870.38h115v50h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M3800.5 870.38h115v50h-115z" />
        <text fill="#000" transform="translate(3800.5 870.38)">
          <tspan x={34.922} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={21.22}>
            {" Teresa"}
          </tspan>
          <tspan x={57.5} y={38.02}>
            {"(1828-1896)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(3780.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"137"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M3570.5 870.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M3570.5 870.38h105v50h-105z" />
        <text fill="#000" transform="translate(3570.5 870.38)">
          <tspan x={34.344} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Carlo"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1825-1896)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(3550.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"136"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M3240.5 1070.38h115v50h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M3240.5 1070.38h115v50h-115z" />
        <text fill="#000" transform="translate(3240.5 1070.38)">
          <tspan x={29.684} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={21.22}>
            {" Candido"}
          </tspan>
          <tspan x={57.5} y={38.02}>
            {"(1856-1932)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(3220.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"139"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M3005.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M3005.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(3005.5 1070.38)">
          <tspan x={27.094} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Angela (Luigia)"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1856-1914)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(2985.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"138"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M3140.5 1220.38h115v50h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M3140.5 1220.38h115v50h-115z" />
        <text fill="#000" transform="translate(3140.5 1220.38)">
          <tspan x={16.586} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={21.22}>
            {" Alfredo Luigi"}
          </tspan>
          <tspan x={57.5} y={38.02}>
            {"(1897-1918)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(3110.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"140"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M4315.5 870.38v-100h-205v-75M3155.5 1095.38h85" />
    <g transform="translate(40210.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"141"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M40650.5 1370.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40650.5 1370.38h125v50h-125z" />
      <text fill="#000" transform="translate(40650.5 1370.38)">
        <tspan x={32.109} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Vincenzo"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1920-2012)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(40630.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"142"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M40713 1370.38v-100h-367.5v-90M53940.5 1670.38v-50h-70v-50M53868 1545.38h5z"
    />
    <path d="M53905.5 1520.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M53905.5 1520.38h150v50h-150z" />
      <text fill="#000" transform="translate(53905.5 1520.38)">
        <tspan x={12.953} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Barbara De Stefano"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1968-)"}
        </tspan>
      </text>
    </g>
    <path d="M53250.5 1380.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M53250.5 1380.38h100v30h-100z" />
      <text fill="#000" transform="translate(53250.5 1380.38)">
        <tspan x={24.023} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Stefano"}
        </tspan>
      </text>
    </g>
    <path d="M53135.5 1380.38h75v30h-75z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M53135.5 1380.38h75v30h-75z" />
      <text fill="#000" transform="translate(53135.5 1380.38)">
        <tspan x={15.094} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={46.219} y={19.62}>
          {" Ambra"}
        </tspan>
      </text>
    </g>
    <path d="M54185.5 1370.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M54185.5 1370.38h110v50h-110z" />
      <text fill="#000" transform="translate(54185.5 1370.38)">
        <tspan x={33.387} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Marco"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1967-)"}
        </tspan>
      </text>
    </g>
    <path d="M54025.5 1370.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M54025.5 1370.38h110v50h-110z" />
      <text fill="#000" transform="translate(54025.5 1370.38)">
        <tspan x={35.793} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Laura"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1963-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M54130.5 1245.38h60" />
    <path d="M53990.5 1220.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M53990.5 1220.38h140v50h-140z" />
      <text fill="#000" transform="translate(53990.5 1220.38)">
        <tspan x={13.766} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Maria Rosa Bison"}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(1936-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M54375.5 1095.38h-60 60" />
    <path d="M54370.5 1220.38h130v50h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M54370.5 1220.38h130v50h-130z" />
      <text fill="#000" transform="translate(54370.5 1220.38)">
        <tspan x={28.02} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={73.719} y={21.22}>
          {" Maria Rosa"}
        </tspan>
        <tspan x={65} y={38.02}>
          {"(1940-1951)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M54375.5 1070.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M54375.5 1070.38h130v50h-130z" />
        <text fill="#000" transform="translate(54375.5 1070.38)">
          <tspan x={21.559} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Anna Boanno"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1910-1990)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M54105.5 1095.38h-150 150" />
      <path strokeWidth={3} d="M53945.5 1070.38h160v50h-160z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M53945.5 1070.38h160v50h-160z" />
        <text fill="#000" transform="translate(53945.5 1070.38)">
          <tspan x={24.602} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={88.719} y={21.22}>
            {" Enrichetta Verrua"}
          </tspan>
          <tspan x={80} y={38.02}>
            {"(1915-1983)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M53780.5 1070.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M53780.5 1070.38h125v50h-125z" />
        <text fill="#000" transform="translate(53780.5 1070.38)">
          <tspan x={37.027} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Ernesto"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1907-1976)"}
          </tspan>
        </text>
      </g>
    <path d="M52865.5 1380.38h135v30h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M52865.5 1380.38h135v30h-135z" />
      <text fill="#000" transform="translate(52865.5 1380.38)">
        <tspan x={14.18} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={19.62}>
          {" Giuseppe Berruti"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M53895.5 895.38h-115 115" />
      <path strokeWidth={3} d="M53730.5 870.38h165v50h-165z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M53730.5 870.38h165v50h-165z" />
        <text fill="#000" transform="translate(53730.5 870.38)">
          <tspan x={17.316} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={91.219} y={21.22}>
            {" Giovanna Garavaglia"}
          </tspan>
          <tspan x={82.5} y={38.02}>
            {"(1873-1935)"}
          </tspan>
        </text>
      </g>
    <path strokeDasharray="3 4" d="M53530.5 870.38h130v50h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M53530.5 870.38h130v50h-130z" />
      <text fill="#000" transform="translate(53530.5 870.38)">
        <tspan x={65} y={21.22}>
          {"See Giuseppe"}
        </tspan>
        <tspan x={65} y={38.02}>
          {"(1857-1925)"}
        </tspan>
      </text>
    </g>
    <path d="M54190.5 1220.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M54190.5 1220.38h120v50h-120z" />
      <text fill="#000" transform="translate(54190.5 1220.38)">
        <tspan x={39.824} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Bruno"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1935-)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M54140.5 1070.38h175v50h-175z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M54140.5 1070.38h175v50h-175z" />
        <text fill="#000" transform="translate(54140.5 1070.38)">
          <tspan x={22.445} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={96.219} y={21.22}>
            {" Pietro Mario Ernesto"}
          </tspan>
          <tspan x={87.5} y={38.02}>
            {"(1903-1974)"}
          </tspan>
        </text>
      </g>
    <path d="M53890.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M53890.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(53890.5 1670.38)">
        <tspan x={13.566} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Maddalena"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(2008-)"}
        </tspan>
      </text>
    </g>
    <path d="M53755.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M53755.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(53755.5 1670.38)">
        <tspan x={28.207} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Emma"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(2005-)"}
        </tspan>
      </text>
    </g>
    <path d="M53740.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M53740.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(53740.5 1520.38)">
        <tspan x={26.07} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Andrea"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1969-)"}
        </tspan>
      </text>
    </g>
    <path d="M53810.5 1370.38h95v50h-95z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M53810.5 1370.38h95v50h-95z" />
      <text fill="#000" transform="translate(53810.5 1370.38)">
        <tspan x={16.711} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={56.219} y={21.22}>
          {" Iole Bona"}
        </tspan>
        <tspan x={47.5} y={38.02}>
          {"(1943-)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M53640.5 1370.38h115v50h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M53640.5 1370.38h115v50h-115z" />
        <text fill="#000" transform="translate(53640.5 1370.38)">
          <tspan x={36.199} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={21.22}>
            {" Enrico"}
          </tspan>
          <tspan x={57.5} y={38.02}>
            {"(1942-1989)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M53675.5 1245.38h45z" />
    <path d="M53720.5 1220.38h170v50h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M53720.5 1220.38h170v50h-170z" />
      <text fill="#000" transform="translate(53720.5 1220.38)">
        <tspan x={17.457} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={93.719} y={21.22}>
          {" Giustina Gambertolio"}
        </tspan>
        <tspan x={85} y={38.02}>
          {"(1925-2000)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M53555.5 1220.38h120v50h-120z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M53555.5 1220.38h120v50h-120z" />
        <text fill="#000" transform="translate(53555.5 1220.38)">
          <tspan x={29.059} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={68.719} y={21.22}>
            {" Giuseppe"}
          </tspan>
          <tspan x={60} y={38.02}>
            {"(1926-1995)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M53385.5 1220.38h120v50h-120z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M53385.5 1220.38h120v50h-120z" />
        <text fill="#000" transform="translate(53385.5 1220.38)">
          <tspan x={31.289} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={68.719} y={21.22}>
            {" Giovanni"}
          </tspan>
          <tspan x={60} y={38.02}>
            {"(1936-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M53500.5 1095.38h55z" />
      <path strokeWidth={3} d="M53555.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M53555.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(53555.5 1070.38)">
          <tspan x={25.832} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Maddalena Arri"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1903-1988)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M53355.5 1070.38h145v50h-145z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M53355.5 1070.38h145v50h-145z" />
        <text fill="#000" transform="translate(53355.5 1070.38)">
          <tspan x={19.172} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={81.219} y={21.22}>
            {" Ettore Tommaso"}
          </tspan>
          <tspan x={72.5} y={38.02}>
            {"(1900-1989)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M52900.5 1245.38h65" />
    <path d="M52745.5 1220.38h155v50h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M52745.5 1220.38h155v50h-155z" />
      <text fill="#000" transform="translate(52745.5 1220.38)">
        <tspan x={11.492} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={86.219} y={21.22}>
          {" Angelo Pietro Berruti"}
        </tspan>
        <tspan x={77.5} y={38.02}>
          {"(1910-1978)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M53165.5 1220.38h135v50h-135z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M53165.5 1220.38h135v50h-135z" />
        <text fill="#000" transform="translate(53165.5 1220.38)">
          <tspan x={16.34} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={76.219} y={21.22}>
            {" Giovanna Luigia"}
          </tspan>
          <tspan x={67.5} y={38.02}>
            {"(1921-2008)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M52965.5 1220.38h135v50h-135z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M52965.5 1220.38h135v50h-135z" />
        <text fill="#000" transform="translate(52965.5 1220.38)">
          <tspan x={25.719} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={76.219} y={21.22}>
            {" Laura Teresa"}
          </tspan>
          <tspan x={67.5} y={38.02}>
            {"(1920-1994)"}
          </tspan>
        </text>
      </g>
    <path strokeDasharray="3 4" d="M53020.5 1070.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M53020.5 1070.38h100v50h-100z" />
      <text fill="#000" transform="translate(53020.5 1070.38)">
        <tspan x={50} y={21.22}>
          {"See Giuseppe"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1894-1967)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M53150.5 1070.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M53150.5 1070.38h105v50h-105z" />
        <text fill="#000" transform="translate(53150.5 1070.38)">
          <tspan x={29.195} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Angela"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1896-1947)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M44070.5 1095.38h45" />
    <path strokeDasharray="3 4" d="M43970.5 1070.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43970.5 1070.38h100v50h-100z" />
      <text fill="#000" transform="translate(43970.5 1070.38)">
        <tspan x={50} y={21.22}>
          {"See Angela"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1896-1947)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M44163 1070.38v-100h397.5" />
      <path strokeWidth={3} d="M44115.5 1070.38h95v50h-95z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M44115.5 1070.38h95v50h-95z" />
        <text fill="#000" transform="translate(44115.5 1070.38)">
          <tspan x={16.559} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={56.219} y={21.22}>
            {" Giuseppe"}
          </tspan>
          <tspan x={47.5} y={38.02}>
            {"(1894-1967)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M7810.5 1395.38v62.5h0v62.5M7963 1520.38v-125h-2.5M7940.5 1395.38h45M7785.5 1395.38h50"
    />
    <path d="M8060.5 1530.38h65v30h-65z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M8060.5 1530.38h65v30h-65z" />
      <text fill="#000" transform="translate(8060.5 1530.38)">
        <tspan x={13.777} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={41.219} y={19.62}>
          {" Anna"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M7910.5 1520.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M7910.5 1520.38h105v50h-105z" />
        <text fill="#000" transform="translate(7910.5 1520.38)">
          <tspan x={35.398} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Luigi"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1945-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M7755.5 1520.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M7755.5 1520.38h105v50h-105z" />
        <text fill="#000" transform="translate(7755.5 1520.38)">
          <tspan x={21.578} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Ernestina"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1928-)"}
          </tspan>
        </text>
      </g>
    <path d="M7985.5 1380.38h145v30h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M7985.5 1380.38h145v30h-145z" />
      <text fill="#000" transform="translate(7985.5 1380.38)">
        <tspan x={21.188} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={19.62}>
          {" Delfina Mazzola"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M7613 1370.38h172.5v50H7613z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M7613 1370.38h172.5v50H7613z" />
        <text fill="#000" fontSize={14} transform="translate(7613 1370.38)">
          <tspan x={11.016} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={94.969} y={21.22}>
            {" Gelsomina Gambertolio"}
          </tspan>
          <tspan x={86.25} y={38.02}>
            {"(1906-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M18445.923 1570.38v-25h60.577" />
    <path d="M18600.5 1670.38h195v50h-195z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M18600.5 1670.38h195v50h-195z" />
      <text fill="#000" transform="translate(18600.5 1670.38)">
        <tspan x={12.336} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={106.219} y={21.22}>
          {" Catherine A. Weatherford"}
        </tspan>
        <tspan x={97.5} y={38.02}>
          {"(1952-)"}
        </tspan>
      </text>
    </g>
    <path d="M18718 1820.38h195v50h-195z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M18718 1820.38h195v50h-195z" />
      <text fill="#000" transform="translate(18718 1820.38)">
        <tspan x={16.82} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={106.219} y={21.22}>
          {" Rena Celestina Sepulveda"}
        </tspan>
        <tspan x={97.5} y={38.02}>
          {"(1988-)"}
        </tspan>
      </text>
    </g>
    <path d="M27250.5 1970.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27250.5 1970.38h100v50h-100z" />
      <text fill="#000" transform="translate(27250.5 1970.38)">
        <tspan x={30.227} y={21.22} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDEA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22} fontSize={14}>
          {" Aidan"}
        </tspan>
        <tspan x={50} y={38.02} fontSize={14}>
          {"(2023-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M52425.5 1080.38v15h100M51740.5 1050.38v20h20" />
      <path strokeWidth={3} d="M51935.5 670.38h102.5v50h-102.5z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M51935.5 670.38h102.5v50h-102.5z" />
        <text fill="#000" transform="translate(51935.5 670.38)">
          <tspan x={31.148} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={59.969} y={21.22}>
            {" Pietro"}
          </tspan>
          <tspan x={51.25} y={38.02}>
            {"(1814-1892)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M51925.5 1095.38h115z" />
      <path strokeWidth={3} d="M52090.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M52090.5 670.38h150v50h-150z" />
        <text fill="#000" fontSize={14} transform="translate(52090.5 670.38)">
          <tspan x={12.027} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Maddalena Nebiolo"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1821-1891)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M52605.5 870.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M52605.5 870.38h100v50h-100z" />
        <text fill="#000" transform="translate(52605.5 870.38)">
          <tspan x={19.059} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Giuseppe"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1858-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M51565.5 895.38h50z" />
    <path d="M51615.5 880.38h130v30h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M51615.5 880.38h130v30h-130z" />
      <text fill="#000" transform="translate(51615.5 880.38)">
        <tspan x={17.313} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={73.719} y={19.62}>
          {" Giuseppe Tesia"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M51465.5 870.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M51465.5 870.38h100v50h-100z" />
        <text fill="#000" transform="translate(51465.5 870.38)">
          <tspan x={27.426} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Teresa"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1855-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M52345.5 895.38h50z" />
      <path strokeWidth={3} d="M52245.5 870.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M52245.5 870.38h100v50h-100z" />
        <text fill="#000" transform="translate(52245.5 870.38)">
          <tspan x={32.547} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Rosa"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1852-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M51760.5 1070.38h315z" />
    <path d="M52075.5 880.38h140v30h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M52075.5 880.38h140v30h-140z" />
      <text fill="#000" transform="translate(52075.5 880.38)">
        <tspan x={12.375} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={19.62}>
          {" Francesca Grasso"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M51925.5 870.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M51925.5 870.38h100v50h-100z" />
        <text fill="#000" transform="translate(51925.5 870.38)">
          <tspan x={29.984} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Felice"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1846-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M52785.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M52785.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(52785.5 1070.38)">
          <tspan x={19.039} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Maria Maddalena"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1893-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M52550.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M52550.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(52550.5 1070.38)">
          <tspan x={12.398} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Maria Cristina Rosa"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1898-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M52275.5 1095.38h50z" />
      <path strokeWidth={3} d="M52125.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M52125.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(52125.5 1070.38)">
          <tspan x={14.695} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Anselmina Cristina"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1895-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M51740.5 1070.38h155v50h-155z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M51740.5 1070.38h155v50h-155z" />
        <text fill="#000" transform="translate(51740.5 1070.38)">
          <tspan x={24.906} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={86.219} y={21.22}>
            {" Pietro Francesco"}
          </tspan>
          <tspan x={77.5} y={38.02}>
            {"(1879-1942)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M51525.5 1095.38h50z" />
    <path d="M51575.5 1080.38h140v30h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M51575.5 1080.38h140v30h-140z" />
      <text fill="#000" transform="translate(51575.5 1080.38)">
        <tspan x={19.539} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={19.62}>
          {" Maria Dellaosta"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M51425.5 1070.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M51425.5 1070.38h100v50h-100z" />
        <text fill="#000" transform="translate(51425.5 1070.38)">
          <tspan x={20.949} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Giovanni"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1882-1937)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M51590.5 1370.38v-62.5h0v-62.5" />
    <path d="M51528 1370.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M51528 1370.38h135v50h-135z" />
      <text fill="#000" transform="translate(51528 1370.38)">
        <tspan x={30.52} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Maria Rosa"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1956-)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M51930.5 1230.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M51930.5 1230.38h150v50h-150z" />
        <text fill="#000" transform="translate(51930.5 1230.38)">
          <tspan x={23.676} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Rosa Francesca"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1919-1992)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M51410.5 1245.38h125z" />
    <path d="M51620.5 1220.38h185v50h-185z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M51620.5 1220.38h185v50h-185z" />
      <text fill="#000" transform="translate(51620.5 1220.38)">
        <tspan x={14.625} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={101.219} y={21.22}>
          {" Giuseppina Ida Panatero"}
        </tspan>
        <tspan x={92.5} y={38.02}>
          {"(1925-2015)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M51410.5 1220.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M51410.5 1220.38h150v50h-150z" />
        <text fill="#000" transform="translate(51410.5 1220.38)">
          <tspan x={34.055} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Felice Emilio"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1916-2002)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M7614.5 955.38q11 0 11 15M7604.5 970.38q0-15 10-15M7835.5 1230.38v-60h0v-75M7810.5 1095.38h50"
    />
    <path d="M7860.5 1080.38h120v30h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M7860.5 1080.38h120v30h-120z" />
      <text fill="#000" transform="translate(7860.5 1080.38)">
        <tspan x={14.125} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={19.62}>
          {" Angelo Berruti"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M7710.5 1070.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M7710.5 1070.38h100v50h-100z" />
        <text fill="#000" transform="translate(7710.5 1070.38)">
          <tspan x={32.547} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Rosa"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1860-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M6605.5 1245.38h40" />
    <path strokeDasharray="4 5" d="M6645.5 1220.38h95v50h-95z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M6645.5 1220.38h95v50h-95z" />
      <text fill="#000" transform="translate(6645.5 1220.38)">
        <tspan x={47.5} y={21.22}>
          {"See Albina"}
        </tspan>
        <tspan x={47.5} y={38.02}>
          {"(1868-1941)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M7505.5 1680.38v-60h0v-75" />
    <path d="M7460.5 1680.38h115v31h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M7460.5 1680.38h115v31h-115z" />
      <text fill="#000" transform="translate(7460.5 1680.38)">
        <tspan x={19.648} y={20.12} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={20.12}>
          {" Maria Luisa"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M7340.5 1245.38h165z" />
      <path strokeWidth={3} d="M7390.5 1520.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M7390.5 1520.38h100v50h-100z" />
        <text fill="#000" transform="translate(7390.5 1520.38)">
          <tspan x={29.063} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Emilio"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1925-1992)"}
          </tspan>
        </text>
      </g>
    <path d="M7525.5 1520.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M7525.5 1520.38h145v50h-145z" />
      <text fill="#000" transform="translate(7525.5 1520.38)">
        <tspan x={14.859} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Rosemma Bottino"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1933-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M7715.5 1245.38h62.5" />
    <path d="M7778 1230.38h115v30h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M7778 1230.38h115v30h-115z" />
      <text fill="#000" transform="translate(7778 1230.38)">
        <tspan x={15.586} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={19.62}>
          {" Maria Berruti"}
        </tspan>
      </text>
    </g>
    <path d="M7300.5 1820.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M7300.5 1820.38h115v50h-115z" />
      <text fill="#000" transform="translate(7300.5 1820.38)">
        <tspan x={33.57} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Andrea"}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(1986-)"}
        </tspan>
      </text>
    </g>
    <path d="M7120.5 1820.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M7120.5 1820.38h115v50h-115z" />
      <text fill="#000" transform="translate(7120.5 1820.38)">
        <tspan x={40.969} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Elisa"}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(1981-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M7168 1670.38v-50h-112.5v-50M6983 1670.38v-50h72.5v-75"
    />
    <path d="M7290.5 1670.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M7290.5 1670.38h115v50h-115z" />
      <text fill="#000" transform="translate(7290.5 1670.38)">
        <tspan x={10.797} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Valeria Busato"}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(1958-)"}
        </tspan>
      </text>
    </g>
    <path d="M7110.5 1670.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M7110.5 1670.38h115v50h-115z" />
      <text fill="#000" transform="translate(7110.5 1670.38)">
        <tspan x={30.797} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Eugenio"}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(1957-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M6875.5 1695.38h50" />
    <path d="M6760.5 1670.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M6760.5 1670.38h115v50h-115z" />
      <text fill="#000" transform="translate(6760.5 1670.38)">
        <tspan x={19.25} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Livio Momo"}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(1943-)"}
        </tspan>
      </text>
    </g>
    <path d="M6925.5 1670.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M6925.5 1670.38h115v50h-115z" />
      <text fill="#000" transform="translate(6925.5 1670.38)">
        <tspan x={28.875} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Graziella"}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(1949-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M7138 1520.38v-125h-.5M7030.5 1545.38h50" />
    <path d="M6915.5 1520.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M6915.5 1520.38h115v50h-115z" />
      <text fill="#000" transform="translate(6915.5 1520.38)">
        <tspan x={15.383} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Elda Imarisio"}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(1926-2012)"}
        </tspan>
      </text>
    </g>
    <path d="M7080.5 1520.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M7080.5 1520.38h115v50h-115z" />
      <text fill="#000" transform="translate(7080.5 1520.38)">
        <tspan x={35.797} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Walter"}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(1925-2012)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M7115.5 1395.38h45" />
      <path strokeWidth={3} d="M7160.5 1370.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M7160.5 1370.38h105v50h-105z" />
        <text fill="#000" transform="translate(7160.5 1370.38)">
          <tspan x={25.977} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Eugenia"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1903-1958)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M7010.5 1370.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M7010.5 1370.38h105v50h-105z" />
        <text fill="#000" transform="translate(7010.5 1370.38)">
          <tspan x={25.797} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Eugenio"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1898-1987)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M7275.5 1220.38v-50h0zM7340.5 1245.38h95z" />
    <path d="M7460.5 1370.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M7460.5 1370.38h125v50h-125z" />
      <text fill="#000" transform="translate(7460.5 1370.38)">
        <tspan x={12.93} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Maria Cattaneo"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1903-1949)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M7310.5 1370.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M7310.5 1370.38h105v50h-105z" />
        <text fill="#000" transform="translate(7310.5 1370.38)">
          <tspan x={30.336} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Oreste"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1901-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M7610.5 1220.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M7610.5 1220.38h105v50h-105z" />
        <text fill="#000" transform="translate(7610.5 1220.38)">
          <tspan x={30.336} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Oreste"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1885-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M7835.5 1370.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M7835.5 1370.38h105v50h-105z" />
        <text fill="#000" transform="translate(7835.5 1370.38)">
          <tspan x={25.016} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Calmino"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1904-)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M6015.5 970.38h1590M6005.5 955.38q11 0 11 15M5995.5 970.38q0-15 10-15M4214.5 955.38q11 0 11 15M4204.5 970.38q0-15 10-15M4225.5 970.38h1770"
    />
    <path d="M7640.5 880.38h140v30h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M7640.5 880.38h140v30h-140z" />
      <text fill="#000" transform="translate(7640.5 880.38)">
        <tspan x={25.621} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={19.62}>
          {" Garrone Clara"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M7410.5 1070.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M7410.5 1070.38h100v50h-100z" />
        <text fill="#000" transform="translate(7410.5 1070.38)">
          <tspan x={29.656} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Luigia"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1850-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M7490.5 870.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M7490.5 870.38h100v50h-100z" />
        <text fill="#000" transform="translate(7490.5 870.38)">
          <tspan x={19.055} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Giuseppe"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(before 1833-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M7565.5 1070.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M7565.5 1070.38h100v50h-100z" />
        <text fill="#000" transform="translate(7565.5 1070.38)">
          <tspan x={19.609} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Vincenzo"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1848-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M6558 1220.38v-50h247.5v-10" />
      <path strokeWidth={3} d="M6510.5 1220.38h95v50h-95z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M6510.5 1220.38h95v50h-95z" />
        <text fill="#000" transform="translate(6510.5 1220.38)">
          <tspan x={18.367} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={56.219} y={21.22}>
            {" Pasquale"}
          </tspan>
          <tspan x={47.5} y={38.02}>
            {"(1867-1914)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M7340.5 1245.38h22.5z" />
      <path strokeWidth={3} d="M7385.5 1220.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M7385.5 1220.38h125v50h-125z" />
        <text fill="#000" transform="translate(7385.5 1220.38)">
          <tspan x={37.141} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Ernesta"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1876-1963)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M7210.5 1220.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M7210.5 1220.38h130v50h-130z" />
        <text fill="#000" transform="translate(7210.5 1220.38)">
          <tspan x={44.063} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Emilio"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1875-1939)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M38580.5 1680.38v-60H38393v60" />
    <path d="M38520.5 1680.38h120v30h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M38520.5 1680.38h120v30h-120z" />
      <text fill="#000" transform="translate(38520.5 1680.38)">
        <tspan x={17.809} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={19.62}>
          {" Luca Rosario"}
        </tspan>
      </text>
    </g>
    <path d="M38320.5 1680.38h145v30h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M38320.5 1680.38h145v30h-145z" />
      <text fill="#000" transform="translate(38320.5 1680.38)">
        <tspan x={17.32} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={19.62}>
          {" Agostino Rosario"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M37288 1395.38" />
    <path d="M37670.5 1820.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M37670.5 1820.38h140v50h-140z" />
      <text fill="#000" transform="translate(37670.5 1820.38)">
        <tspan x={18.563} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Thomas Danoot"}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(2009-)"}
        </tspan>
      </text>
    </g>
    <path d="M38140.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M38140.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(38140.5 1670.38)">
        <tspan x={32.168} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Anna"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1975-)"}
        </tspan>
      </text>
    </g>
    <path d="M37960.5 1670.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M37960.5 1670.38h115v50h-115z" />
      <text fill="#000" transform="translate(37960.5 1670.38)">
        <tspan x={20.664} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Alessandro"}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(1971-)"}
        </tspan>
      </text>
    </g>
    <path d="M37755.5 1670.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M37755.5 1670.38h145v50h-145z" />
      <text fill="#000" transform="translate(37755.5 1670.38)">
        <tspan x={13.227} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Marina Bartolomei"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1970-)"}
        </tspan>
      </text>
    </g>
    <path d="M37570.5 1670.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M37570.5 1670.38h140v50h-140z" />
      <text fill="#000" transform="translate(37570.5 1670.38)">
        <tspan x={46.07} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Andrea"}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(1970-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M38455.5 1545.38h45" />
    <path d="M37065.5 1820.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M37065.5 1820.38h140v50h-140z" />
      <text fill="#000" transform="translate(37065.5 1820.38)">
        <tspan x={24.414} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Luca Pangallo"}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(1997-)"}
        </tspan>
      </text>
    </g>
    <path d="M36855.5 1820.38h170v50h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M36855.5 1820.38h170v50h-170z" />
      <text fill="#000" transform="translate(36855.5 1820.38)">
        <tspan x={22.516} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={93.719} y={21.22}>
          {" Roberto Giacomotti"}
        </tspan>
        <tspan x={85} y={38.02}>
          {"(1999-)"}
        </tspan>
      </text>
    </g>
    <path d="M36640.5 1820.38h160v50h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M36640.5 1820.38h160v50h-160z" />
      <text fill="#000" transform="translate(36640.5 1820.38)">
        <tspan x={18.828} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={88.719} y={21.22}>
          {" Claudia Giacomotti"}
        </tspan>
        <tspan x={80} y={38.02}>
          {"(1994-)"}
        </tspan>
      </text>
    </g>
    <path d="M36465.5 1820.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M36465.5 1820.38h140v50h-140z" />
      <text fill="#000" transform="translate(36465.5 1820.38)">
        <tspan x={14.52} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Paola Giacomotti"}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(2003-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M37288 1395.38" />
    <path d="M37360.5 1670.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M37360.5 1670.38h140v50h-140z" />
      <text fill="#000" transform="translate(37360.5 1670.38)">
        <tspan x={14.73} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Laura Giacomotti"}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(1974-)"}
        </tspan>
      </text>
    </g>
    <path d="M37160.5 1680.38h145v30h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M37160.5 1680.38h145v30h-145z" />
      <text fill="#000" transform="translate(37160.5 1680.38)">
        <tspan x={12.652} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={19.62}>
          {" Giuseppe Pangallo"}
        </tspan>
      </text>
    </g>
    <path d="M36950.5 1670.38h165v50h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M36950.5 1670.38h165v50h-165z" />
      <text fill="#000" transform="translate(36950.5 1670.38)">
        <tspan x={16.57} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={91.219} y={21.22}>
          {" Nicoletta Giacomotti"}
        </tspan>
        <tspan x={82.5} y={38.02}>
          {"(1963-)"}
        </tspan>
      </text>
    </g>
    <path d="M36750.5 1680.38h145v30h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M36750.5 1680.38h145v30h-145z" />
      <text fill="#000" transform="translate(36750.5 1680.38)">
        <tspan x={14.836} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={19.62}>
          {" Ivana Guglielmetti"}
        </tspan>
      </text>
    </g>
    <path d="M36555.5 1670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M36555.5 1670.38h150v50h-150z" />
      <text fill="#000" transform="translate(36555.5 1670.38)">
        <tspan x={15.141} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Sandro Giacomotti"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1961-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M37120.5 1370.38v-150h215v-125M38358 1520.38v-125h-2.5"
    />
    <path d="M38500.5 1530.38h145v30h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M38500.5 1530.38h145v30h-145z" />
      <text fill="#000" transform="translate(38500.5 1530.38)">
        <tspan x={12.93} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={19.62}>
          {" Francesco Rosario"}
        </tspan>
      </text>
    </g>
    <path d="M38260.5 1520.38h195v50h-195z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M38260.5 1520.38h195v50h-195z" />
      <text fill="#000" transform="translate(38260.5 1520.38)">
        <tspan x={18.75} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={106.219} y={21.22}>
          {" Pierangela Gambertoglio"}
        </tspan>
        <tspan x={97.5} y={38.02}>
          {"(1941-)"}
        </tspan>
      </text>
    </g>
    <path d="M37915.5 1520.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M37915.5 1520.38h145v50h-145z" />
      <text fill="#000" transform="translate(37915.5 1520.38)">
        <tspan x={17.566} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Luciana Mazzurri"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1950-)"}
        </tspan>
      </text>
    </g>
    <path d="M37730.5 1520.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M37730.5 1520.38h125v50h-125z" />
      <text fill="#000" transform="translate(37730.5 1520.38)">
        <tspan x={31.559} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Giuseppe"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1939-)"}
        </tspan>
      </text>
    </g>
    <path d="M37045.5 1520.38h185v50h-185z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M37045.5 1520.38h185v50h-185z" />
      <text fill="#000" transform="translate(37045.5 1520.38)">
        <tspan x={26.645} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={101.219} y={21.22}>
          {" Giacomo Giacomotti"}
        </tspan>
        <tspan x={92.5} y={38.02}>
          {"(1935-1997)"}
        </tspan>
      </text>
    </g>
    <path d="M36860.5 1520.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M36860.5 1520.38h125v50h-125z" />
      <text fill="#000" transform="translate(36860.5 1520.38)">
        <tspan x={20.398} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Maria Teresa"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1936-2005)"}
        </tspan>
      </text>
    </g>
    <path d="M36690.5 1530.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M36690.5 1530.38h125v30h-125z" />
      <text fill="#000" transform="translate(36690.5 1530.38)">
        <tspan x={17.633} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Marisa Petrini"}
        </tspan>
      </text>
    </g>
    <path d="M36510.5 1520.38h130v50h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M36510.5 1520.38h130v50h-130z" />
      <text fill="#000" transform="translate(36510.5 1520.38)">
        <tspan x={22.027} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={73.719} y={21.22}>
          {" Elio Cuniberti"}
        </tspan>
        <tspan x={65} y={38.02}>
          {"(1931-)"}
        </tspan>
      </text>
    </g>
    <path d="M36340.5 1530.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M36340.5 1530.38h125v30h-125z" />
      <text fill="#000" transform="translate(36340.5 1530.38)">
        <tspan x={12.516} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Adriano Grosso"}
        </tspan>
      </text>
    </g>
    <path d="M36075.5 1530.38h205v30h-205z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M36075.5 1530.38h205v30h-205z" />
      <text fill="#000" transform="translate(36075.5 1530.38)">
        <tspan x={24.238} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={111.219} y={19.62}>
          {" Enrichetta Tina Cuniberti"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M38335.5 1395.38h50" />
    <path d="M38385.5 1370.38h165v50h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M38385.5 1370.38h165v50h-165z" />
      <text fill="#000" transform="translate(38385.5 1370.38)">
        <tspan x={20.195} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={91.219} y={21.22}>
          {" Carlo Gambertoglio"}
        </tspan>
        <tspan x={82.5} y={38.02}>
          {"(1912-1986)"}
        </tspan>
      </text>
    </g>
    <path d="M38225.5 1370.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M38225.5 1370.38h110v50h-110z" />
      <text fill="#000" transform="translate(38225.5 1370.38)">
        <tspan x={35.473} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Maria"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1916-2005)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M37635.5 1370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M37635.5 1370.38h150v50h-150z" />
        <text fill="#000" transform="translate(37635.5 1370.38)">
          <tspan x={17.234} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Gemma Rampone"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1912-1992)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M37445.5 1370.38h120v50h-120z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M37445.5 1370.38h120v50h-120z" />
        <text fill="#000" fontSize={14} transform="translate(37445.5 1370.38)">
          <tspan x={40.941} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={68.719} y={21.22}>
            {" Paolo"}
          </tspan>
          <tspan x={60} y={38.02}>
            {"(1912-1993)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M37225.5 1370.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M37225.5 1370.38h125v50h-125z" />
        <text fill="#000" transform="translate(37225.5 1370.38)">
          <tspan x={12.082} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Adeline Caldera"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1913-1989)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M36480.5 1370.38h145v50h-145z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M36480.5 1370.38h145v50h-145z" />
        <text fill="#000" fontSize={14} transform="translate(36480.5 1370.38)">
          <tspan x={20.391} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={81.219} y={21.22}>
            {" Dorino Cuniberti"}
          </tspan>
          <tspan x={72.5} y={38.02}>
            {"(1901-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M36310.5 1370.38h120v50h-120z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M36310.5 1370.38h120v50h-120z" />
        <text fill="#000" transform="translate(36310.5 1370.38)">
          <tspan x={23.566} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={68.719} y={21.22}>
            {" Maddalena"}
          </tspan>
          <tspan x={60} y={38.02}>
            {"(1902-1965)"}
          </tspan>
        </text>
      </g>
    <path d="M35735.5 1680.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M35735.5 1680.38h100v30h-100z" />
      <text fill="#000" transform="translate(35735.5 1680.38)">
        <tspan x={24.379} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Cristina"}
        </tspan>
      </text>
    </g>
    <path d="M35360.5 1820.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M35360.5 1820.38h100v50h-100z" />
      <text fill="#000" transform="translate(35360.5 1820.38)">
        <tspan x={26.074} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Matteo"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1989-)"}
        </tspan>
      </text>
    </g>
    <path d="M35205.5 1820.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M35205.5 1820.38h100v50h-100z" />
      <text fill="#000" transform="translate(35205.5 1820.38)">
        <tspan x={24.023} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Stefano"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1994-)"}
        </tspan>
      </text>
    </g>
    <path d="M35560.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M35560.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(35560.5 1670.38)">
        <tspan x={24.488} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Olimpia"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1963-)"}
        </tspan>
      </text>
    </g>
    <path d="M35360.5 1680.38h135v30h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M35360.5 1680.38h135v30h-135z" />
      <text fill="#000" transform="translate(35360.5 1680.38)">
        <tspan x={13.133} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={19.62}>
          {" Marilisa Romano"}
        </tspan>
      </text>
    </g>
    <path d="M35210.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M35210.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(35210.5 1670.38)">
        <tspan x={28.387} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Marco"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1963-)"}
        </tspan>
      </text>
    </g>
    <path d="M36075.5 1370.38h165v50h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M36075.5 1370.38h165v50h-165z" />
      <text fill="#000" transform="translate(36075.5 1370.38)">
        <tspan x={27.516} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={91.219} y={21.22}>
          {" Rosa Martinengo"}
        </tspan>
        <tspan x={82.5} y={38.02}>
          {"(1914-1992)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M35905.5 1370.38h120v50h-120z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M35905.5 1370.38h120v50h-120z" />
        <text fill="#000" transform="translate(35905.5 1370.38)">
          <tspan x={37.836} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={68.719} y={21.22}>
            {" Oreste"}
          </tspan>
          <tspan x={60} y={38.02}>
            {"(1910-1987)"}
          </tspan>
        </text>
      </g>
    <path d="M35810.5 1530.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M35810.5 1530.38h100v30h-100z" />
      <text fill="#000" transform="translate(35810.5 1530.38)">
        <tspan x={18.492} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Carla Moi"}
        </tspan>
      </text>
    </g>
    <path d="M35660.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M35660.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(35660.5 1520.38)">
        <tspan x={30.285} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Mario"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1944-)"}
        </tspan>
      </text>
    </g>
    <path d="M35460.5 1520.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M35460.5 1520.38h135v50h-135z" />
      <text fill="#000" transform="translate(35460.5 1520.38)">
        <tspan x={12.297} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Angela Balazzino"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1932)"}
        </tspan>
      </text>
    </g>
    <path d="M35310.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M35310.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(35310.5 1520.38)">
        <tspan x={30.395} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Paolo"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1935-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M35510.5 1395.38h50" />
      <path strokeWidth={4} d="M35560.5 1370.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M35560.5 1370.38h125v50h-125z" />
        <text fill="#000" transform="translate(35560.5 1370.38)">
          <tspan x={16.699} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Delfina Illengo"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1914-2010)"}
          </tspan>
        </text>
      </g>
    <path d="M35150.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M35150.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(35150.5 1520.38)">
        <tspan x={25.555} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Vittorio"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1942-)"}
        </tspan>
      </text>
    </g>
    <path d="M34995.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M34995.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(34995.5 1520.38)">
        <tspan x={13.398} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Giuseppina"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1936-)"}
        </tspan>
      </text>
    </g>
    <path d="M34845.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M34845.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(34845.5 1520.38)">
        <tspan x={30.473} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Maria"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1930-)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M35070.5 1370.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M35070.5 1370.38h125v50h-125z" />
        <text fill="#000" transform="translate(35070.5 1370.38)">
          <tspan x={20.227} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Rita Zabellan"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1914-2010)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M34900.5 1370.38h120v50h-120z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M34900.5 1370.38h120v50h-120z" />
        <text fill="#000" transform="translate(34900.5 1370.38)">
          <tspan x={39.863} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={68.719} y={21.22}>
            {" Pietro"}
          </tspan>
          <tspan x={60} y={38.02}>
            {"(1905-1977)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M34540.5 1095.38h92.5z" />
    <path d="M34660.5 1520.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M34660.5 1520.38h120v50h-120z" />
      <text fill="#000" transform="translate(34660.5 1520.38)">
        <tspan x={12.031} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Vittorio Chiarla"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1935-)"}
        </tspan>
      </text>
    </g>
    <path d="M34460.5 1520.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M34460.5 1520.38h145v50h-145z" />
      <text fill="#000" transform="translate(34460.5 1520.38)">
        <tspan x={22.785} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Olimpia Amerio"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1934-2018)"}
        </tspan>
      </text>
    </g>
    <path d="M34260.5 1520.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M34260.5 1520.38h145v50h-145z" />
      <text fill="#000" transform="translate(34260.5 1520.38)">
        <tspan x={15.828} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Giuseppe Calamo"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1922-2005)"}
        </tspan>
      </text>
    </g>
    <path d="M34060.5 1520.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M34060.5 1520.38h145v50h-145z" />
      <text fill="#000" transform="translate(34060.5 1520.38)">
        <tspan x={11.695} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Giuseppina Amerio"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1923-2018)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M34435.5 1370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M34435.5 1370.38h150v50h-150z" />
        <text fill="#000" transform="translate(34435.5 1370.38)">
          <tspan x={19.855} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Giuseppe Amerio"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1899-1974)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M34265.5 1370.38h120v50h-120z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M34265.5 1370.38h120v50h-120z" />
        <text fill="#000" transform="translate(34265.5 1370.38)">
          <tspan x={40.473} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={68.719} y={21.22}>
            {" Maria"}
          </tspan>
          <tspan x={60} y={38.02}>
            {"(1901-1982)"}
          </tspan>
        </text>
      </g>
    <path d="M33910.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M33910.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(33910.5 1520.38)">
        <tspan x={19.418} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Pasquale"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1923-1999)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M33580.5 1220.38h85z" />
    <path d="M33705.5 1520.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M33705.5 1520.38h145v50h-145z" />
      <text fill="#000" transform="translate(33705.5 1520.38)">
        <tspan x={27.152} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Mario Ravizza"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1922-1985)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M33540.5 1520.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M33540.5 1520.38h100v50h-100z" />
        <text fill="#000" transform="translate(33540.5 1520.38)">
          <tspan x={24.488} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Olimpia"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1928-2013)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M33765.5 1395.38h45" />
      <path strokeWidth={3} d="M33810.5 1370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M33810.5 1370.38h150v50h-150z" />
        <text fill="#000" transform="translate(33810.5 1370.38)">
          <tspan x={17.148} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Giuseppina Rosso"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1899-1974)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M33560.5 1220.38" />
      <path strokeWidth={3} d="M34990.5 1070.38h140v50h-140z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M34990.5 1070.38h140v50h-140z" />
        <text fill="#000" transform="translate(34990.5 1070.38)">
          <tspan x={50.473} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={78.719} y={21.22}>
            {" Maria"}
          </tspan>
          <tspan x={70} y={38.02}>
            {"(1879-1879)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M34540.5 1070.38h180v50h-180z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M34540.5 1070.38h180v50h-180z" />
        <text fill="#000" transform="translate(34540.5 1070.38)">
          <tspan x={25.684} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={98.719} y={21.22}>
            {" Giuseppe Domenico"}
          </tspan>
          <tspan x={90} y={38.02}>
            {"(1874-1874)"}
          </tspan>
        </text>
      </g>
    <path strokeDasharray="2 3" d="M33960.5 1070.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M33960.5 1070.38h110v50h-110z" />
      <text fill="#000" transform="translate(33960.5 1070.38)">
        <tspan x={55} y={21.22}>
          {"See Pasquale "}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1867-1914)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M33760.5 1070.38h140v50h-140z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M33760.5 1070.38h140v50h-140z" />
        <text fill="#000" transform="translate(33760.5 1070.38)">
          <tspan x={48.703} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={78.719} y={21.22}>
            {" Albina"}
          </tspan>
          <tspan x={70} y={38.02}>
            {"(1868-1941)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M33560.5 1070.38h140v50h-140z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M33560.5 1070.38h140v50h-140z" />
        <text fill="#000" transform="translate(33560.5 1070.38)">
          <tspan x={49.863} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={78.719} y={21.22}>
            {" Pietro"}
          </tspan>
          <tspan x={70} y={38.02}>
            {"(1865-1895)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M39665.5 1395.38h35" />
      <path strokeWidth={3} d="M39515.5 1370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M39515.5 1370.38h150v50h-150z" />
        <text fill="#000" transform="translate(39515.5 1370.38)">
          <tspan x={13.375} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Adelina Giuseppina"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1913-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M39953 1370.38v-125h2.5" />
      <path strokeWidth={3} d="M39700.5 1370.38h155v50h-155z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M39700.5 1370.38h155v50h-155z" />
        <text fill="#000" fontSize={14} transform="translate(39700.5 1370.38)">
          <tspan x={24.18} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={86.219} y={21.22}>
            {" Giuseppe Berruti"}
          </tspan>
          <tspan x={77.5} y={38.02}>
            {"(1911-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M39895.5 1370.38h115v50h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M39895.5 1370.38h115v50h-115z" />
        <text fill="#000" transform="translate(39895.5 1370.38)">
          <tspan x={26.582} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={21.22}>
            {" Ernestina"}
          </tspan>
          <tspan x={57.5} y={38.02}>
            {"(1915-)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M39185.5 1370.38v-62.5h0v-62.5M39285.5 1520.38v-62.5h0v-62.5M39335.5 1545.38h50"
    />
    <path d="M39385.5 1520.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M39385.5 1520.38h145v50h-145z" />
      <text fill="#000" transform="translate(39385.5 1520.38)">
        <tspan x={28.781} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Mario Grosso"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1930-)"}
        </tspan>
      </text>
    </g>
    <path d="M39235.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M39235.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(39235.5 1520.38)">
        <tspan x={30.473} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Vilma"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1938-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M39260.5 1395.38h55" />
      <path strokeWidth={3} d="M39315.5 1370.38h165v50h-165z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M39315.5 1370.38h165v50h-165z" />
        <text fill="#000" fontSize={14} transform="translate(39315.5 1370.38)">
          <tspan x={32.797} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={91.219} y={21.22}>
            {" Palmina Cerruti"}
          </tspan>
          <tspan x={82.5} y={38.02}>
            {"(1916-1966)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M39110.5 1370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M39110.5 1370.38h150v50h-150z" />
        <text fill="#000" transform="translate(39110.5 1370.38)">
          <tspan x={25.305} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Giacomo Attilio"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1908-1976)"}
          </tspan>
        </text>
      </g>
    <path d="M39005.5 1820.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M39005.5 1820.38h100v50h-100z" />
      <text fill="#000" transform="translate(39005.5 1820.38)">
        <tspan x={12.559} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Durga Irene"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(2009-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M38975.5 1670.38v-87.5h0v-37.5M39025.5 1695.38h50" />
    <path d="M39075.5 1670.38h195v50h-195z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M39075.5 1670.38h195v50h-195z" />
      <text fill="#000" fontSize={14} transform="translate(39075.5 1670.38)">
        <tspan x={30.492} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF3"}
        </tspan>
        <tspan x={106.219} y={21.22}>
          {" Parvathi Devi Pandari"}
        </tspan>
        <tspan x={97.5} y={38.02}>
          {"(1980-)"}
        </tspan>
      </text>
    </g>
    <path d="M38925.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M38925.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(38925.5 1670.38)">
        <tspan x={26.07} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Andrea"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1972-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M38895.5 1520.38v-50h0v-75M38945.5 1545.38h50" />
    <path d="M38995.5 1520.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M38995.5 1520.38h145v50h-145z" />
      <text fill="#000" transform="translate(38995.5 1520.38)">
        <tspan x={12.48} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Giacomina Plebani"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1939-)"}
        </tspan>
      </text>
    </g>
    <path d="M38845.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M38845.5 1520.38h100v50h-100z" />
      <text fill="#000" fontSize={14} transform="translate(38845.5 1520.38)">
        <tspan x={33.465} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Luigi"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1936-2022)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M38865.5 1395.38h60" />
      <path strokeWidth={3} d="M38925.5 1370.38h155v50h-155z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M38925.5 1370.38h155v50h-155z" />
        <text fill="#000" transform="translate(38925.5 1370.38)">
          <tspan x={14.813} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={86.219} y={21.22}>
            {" Elvira Gambertoglio"}
          </tspan>
          <tspan x={77.5} y={38.02}>
            {"(1903-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M40260.5 1070.38v-100h275M13710.5 1220.38" />
    <path d="M11225.5 1970.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M11225.5 1970.38h140v50h-140z" />
      <text fill="#000" transform="translate(11225.5 1970.38)">
        <tspan x={24.75} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Mia Elizabeth "}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(2006-)"}
        </tspan>
      </text>
    </g>
    <path d="M11020.5 1970.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M11020.5 1970.38h140v50h-140z" />
      <text fill="#000" transform="translate(11020.5 1970.38)">
        <tspan x={17.348} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Nicholas Winter "}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(2003-)"}
        </tspan>
      </text>
    </g>
    <path d="M10820.5 1970.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M10820.5 1970.38h140v50h-140z" />
      <text fill="#000" transform="translate(10820.5 1970.38)">
        <tspan x={18.035} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Dominic James "}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(2001-)"}
        </tspan>
      </text>
    </g>
    <path d="M11420.5 1970.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M11420.5 1970.38h140v50h-140z" />
      <text fill="#000" transform="translate(11420.5 1970.38)">
        <tspan x={25.113} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Colton Danile "}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(2002-)"}
        </tspan>
      </text>
    </g>
    <path d="M10955.5 1820.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M10955.5 1820.38h110v50h-110z" />
      <text fill="#000" transform="translate(10955.5 1820.38)">
        <tspan x={35.703} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Wade"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1973-)"}
        </tspan>
      </text>
    </g>
    <path d="M11115.5 1820.38h190v50h-190z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M11115.5 1820.38h190v50h-190z" />
      <text fill="#000" transform="translate(11115.5 1820.38)">
        <tspan x={10.82} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={103.719} y={21.22}>
          {" Stacy Elizabeth Rommack "}
        </tspan>
        <tspan x={95} y={38.02}>
          {"(1974-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M11665.5 1545.38h-150 150" />
    <path d="M11360.5 1820.38h105v50h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M11360.5 1820.38h105v50h-105z" />
      <text fill="#000" transform="translate(11360.5 1820.38)">
        <tspan x={34.383} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={21.22}>
          {" Scott"}
        </tspan>
        <tspan x={52.5} y={38.02}>
          {"(1975-)"}
        </tspan>
      </text>
    </g>
    <path d="M11515.5 1820.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M11515.5 1820.38h140v50h-140z" />
      <text fill="#000" transform="translate(11515.5 1820.38)">
        <tspan x={20.254} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Tiffany Pollock "}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(1979-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M11728 1545.38" />
    <path d="M11600.5 1970.38h180v50h-180z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M11600.5 1970.38h180v50h-180z" />
      <text fill="#000" transform="translate(11600.5 1970.38)">
        <tspan x={11.699} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={98.719} y={21.22}>
          {" Christopher Allen Inglett "}
        </tspan>
        <tspan x={90} y={38.02}>
          {"(2007-)"}
        </tspan>
      </text>
    </g>
    <path d="M11810.5 1970.38h180v50h-180z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M11810.5 1970.38h180v50h-180z" />
      <text fill="#000" transform="translate(11810.5 1970.38)">
        <tspan x={12.965} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={98.719} y={21.22}>
          {" Natalie Elizabeth Inglett "}
        </tspan>
        <tspan x={90} y={38.02}>
          {"(2011-)"}
        </tspan>
      </text>
    </g>
    <path d="M12025.5 1970.38h155v50h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M12025.5 1970.38h155v50h-155z" />
      <text fill="#000" transform="translate(12025.5 1970.38)">
        <tspan x={13.621} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={86.219} y={21.22}>
          {" Nicole Dawn Inglett "}
        </tspan>
        <tspan x={77.5} y={38.02}>
          {"(2011-)"}
        </tspan>
      </text>
    </g>
    <path d="M12930.5 1970.38h160v50h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M12930.5 1970.38h160v50h-160z" />
      <text fill="#000" transform="translate(12930.5 1970.38)">
        <tspan x={15.238} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={88.719} y={21.22}>
          {" Katharine Grace Gill "}
        </tspan>
        <tspan x={80} y={38.02}>
          {"(2014-)"}
        </tspan>
      </text>
    </g>
    <path d="M12220.5 1970.38h165v50h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M12220.5 1970.38h165v50h-165z" />
      <text fill="#000" transform="translate(12220.5 1970.38)">
        <tspan x={21.391} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={91.219} y={21.22}>
          {" Rebecca Dawn Gill "}
        </tspan>
        <tspan x={82.5} y={38.02}>
          {"(2004-)"}
        </tspan>
      </text>
    </g>
    <path d="M12420.5 1970.38h130v50h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M12420.5 1970.38h130v50h-130z" />
      <text fill="#000" transform="translate(12420.5 1970.38)">
        <tspan x={11.902} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={73.719} y={21.22}>
          {" Robert Allen Gill "}
        </tspan>
        <tspan x={65} y={38.02}>
          {"(2016-)"}
        </tspan>
      </text>
    </g>
    <path d="M12585.5 1970.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M12585.5 1970.38h135v50h-135z" />
      <text fill="#000" transform="translate(12585.5 1970.38)">
        <tspan x={18.078} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Ryan David Gill "}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(2009-)"}
        </tspan>
      </text>
    </g>
    <path d="M12750.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M12750.5 1970.38h150v50h-150z" />
      <text fill="#000" transform="translate(12750.5 1970.38)">
        <tspan x={12.637} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Gabriel Richard Gill "}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(2010-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M11790.5 1545.38h220z" />
    <path d="M11855.5 1820.38h155v50h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M11855.5 1820.38h155v50h-155z" />
      <text fill="#000" transform="translate(11855.5 1820.38)">
        <tspan x={20.637} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={86.219} y={21.22}>
          {" Jenny Dawn Allen"}
        </tspan>
        <tspan x={77.5} y={38.02}>
          {"(1978-)"}
        </tspan>
      </text>
    </g>
    <path d="M12055.5 1820.38h105v50h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M12055.5 1820.38h105v50h-105z" />
      <text fill="#000" transform="translate(12055.5 1820.38)">
        <tspan x={13.469} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={21.22}>
          {" Kent Inglett "}
        </tspan>
        <tspan x={52.5} y={38.02}>
          {"(1978-)"}
        </tspan>
      </text>
    </g>
    <path d="M12190.5 1820.38h130v50h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M12190.5 1820.38h130v50h-130z" />
      <text fill="#000" transform="translate(12190.5 1820.38)">
        <tspan x={11.734} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={73.719} y={21.22}>
          {" Aaron Seth Allen"}
        </tspan>
        <tspan x={65} y={38.02}>
          {"(1979-)"}
        </tspan>
      </text>
    </g>
    <path d="M12365.5 1820.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M12365.5 1820.38h135v50h-135z" />
      <text fill="#000" transform="translate(12365.5 1820.38)">
        <tspan x={14.484} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Karen Beth Allen"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1979-)"}
        </tspan>
      </text>
    </g>
    <path d="M12545.5 1820.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M12545.5 1820.38h145v50h-145z" />
      <text fill="#000" transform="translate(12545.5 1820.38)">
        <tspan x={14.254} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Brock Richard Gill "}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1978-)"}
        </tspan>
      </text>
    </g>
    <path d="M12745.5 1820.38h155v50h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M12745.5 1820.38h155v50h-155z" />
      <text fill="#000" transform="translate(12745.5 1820.38)">
        <tspan x={15.09} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={86.219} y={21.22}>
          {" Cassandra Jo More"}
        </tspan>
        <tspan x={77.5} y={38.02}>
          {"(1983-)"}
        </tspan>
      </text>
    </g>
    <path d="M12930.5 1820.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M12930.5 1820.38h140v50h-140z" />
      <text fill="#000" transform="translate(12930.5 1820.38)">
        <tspan x={17.211} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Jake Tyler More "}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(1985-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M10760.5 1670.38v-50h-130v-40M10348 1670.38v-50h282.5v-75M11053 1520.38v-150h-157.5v-80M10533 1520.38v-150h362.5v-125M10840.5 1695.38h50"
    />
    <path d="M10890.5 1670.38h160v50h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M10890.5 1670.38h160v50h-160z" />
      <text fill="#000" transform="translate(10890.5 1670.38)">
        <tspan x={19.074} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={88.719} y={21.22}>
          {" Susie Louse Foster"}
        </tspan>
        <tspan x={80} y={38.02}>
          {"(1964-)"}
        </tspan>
      </text>
    </g>
    <path d="M10680.5 1670.38h160v50h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M10680.5 1670.38h160v50h-160z" />
      <text fill="#000" transform="translate(10680.5 1670.38)">
        <tspan x={16.43} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={88.719} y={21.22}>
          {" William Ouellette Jr."}
        </tspan>
        <tspan x={80} y={38.02}>
          {"(1958-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M10440.5 1695.38h40" />
    <path d="M10480.5 1680.38h155v30h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M10480.5 1680.38h155v30h-155z" />
      <text fill="#000" transform="translate(10480.5 1680.38)">
        <tspan x={32.66} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={86.219} y={19.62}>
          {" Evan G. Smith"}
        </tspan>
      </text>
    </g>
    <path d="M10255.5 1670.38h185v50h-185z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M10255.5 1670.38h185v50h-185z" />
      <text fill="#000" transform="translate(10255.5 1670.38)">
        <tspan x={22.207} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={101.219} y={21.22}>
          {" Theresa Ann Quellette"}
        </tspan>
        <tspan x={92.5} y={38.02}>
          {"(1953-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M11120.5 1545.38h40" />
    <path d="M11160.5 1520.38h170v50h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M11160.5 1520.38h170v50h-170z" />
      <text fill="#000" transform="translate(11160.5 1520.38)">
        <tspan x={15.711} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={93.719} y={21.22}>
          {" Edward Norman Elton"}
        </tspan>
        <tspan x={85} y={38.02}>
          {"(1920-2003)"}
        </tspan>
      </text>
    </g>
    <path d="M10985.5 1520.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M10985.5 1520.38h135v50h-135z" />
      <text fill="#000" transform="translate(10985.5 1520.38)">
        <tspan x={26.195} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Santina Nina"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1927-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M10610.5 1545.38h40" />
    <path d="M10650.5 1520.38h155v50h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M10650.5 1520.38h155v50h-155z" />
      <text fill="#000" transform="translate(10650.5 1520.38)">
        <tspan x={15.879} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={86.219} y={21.22}>
          {" William J. Ouellette"}
        </tspan>
        <tspan x={77.5} y={38.02}>
          {"(1920-1953)"}
        </tspan>
      </text>
    </g>
    <path d="M10455.5 1520.38h155v50h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M10455.5 1520.38h155v50h-155z" />
      <text fill="#000" transform="translate(10455.5 1520.38)">
        <tspan x={35.965} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={86.219} y={21.22}>
          {" Rosalie Jane"}
        </tspan>
        <tspan x={77.5} y={38.02}>
          {"(1922-1999)"}
        </tspan>
      </text>
    </g>
    <path d="M17605.5 1970.38h220v50h-220z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M17605.5 1970.38h220v50h-220z" />
      <text fill="#000" transform="translate(17605.5 1970.38)">
        <tspan x={20.148} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={118.719} y={21.22}>
          {" Phoebe Wynn Denise Severe"}
        </tspan>
        <tspan x={110} y={38.02}>
          {"(2019-)"}
        </tspan>
      </text>
    </g>
    <path d="M19825.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M19825.5 1970.38h150v50h-150z" />
      <text fill="#000" transform="translate(19825.5 1970.38)">
        <tspan x={27.34} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Iain Mac Nevin"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(2009-)"}
        </tspan>
      </text>
    </g>
    <path d="M19640.5 1970.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M19640.5 1970.38h135v50h-135z" />
      <text fill="#000" transform="translate(19640.5 1970.38)">
        <tspan x={12.191} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Emilie Mac Nevin"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(2007-)"}
        </tspan>
      </text>
    </g>
    <path d="M19410.5 1970.38h195v50h-195z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M19410.5 1970.38h195v50h-195z" />
      <text fill="#000" transform="translate(19410.5 1970.38)">
        <tspan x={15.266} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={106.219} y={21.22}>
          {" Joshua James Mac Nevin"}
        </tspan>
        <tspan x={97.5} y={38.02}>
          {"(2001-2003)"}
        </tspan>
      </text>
    </g>
    <path d="M19225.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M19225.5 1970.38h150v50h-150z" />
      <text fill="#000" fontSize={14} transform="translate(19225.5 1970.38)">
        <tspan x={19.352} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Jacob Mac Nevin"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(2001-)"}
        </tspan>
      </text>
    </g>
    <path d="M19015.5 1970.38h160v50h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M19015.5 1970.38h160v50h-160z" />
      <text fill="#000" transform="translate(19015.5 1970.38)">
        <tspan x={24.828} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={88.719} y={21.22}>
          {" Taylor Mac Nevin"}
        </tspan>
        <tspan x={80} y={38.02}>
          {"(1998-)"}
        </tspan>
      </text>
    </g>
    <path d="M19840.5 1830.38h130v30h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M19840.5 1830.38h130v30h-130z" />
      <text fill="#000" transform="translate(19840.5 1830.38)">
        <tspan x={44.516} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={73.719} y={19.62}>
          {" Alexis"}
        </tspan>
      </text>
    </g>
    <path d="M19625.5 1820.38h165v50h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M19625.5 1820.38h165v50h-165z" />
      <text fill="#000" transform="translate(19625.5 1820.38)">
        <tspan x={22.578} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={91.219} y={21.22}>
          {" Brian J. Mac Nevin"}
        </tspan>
        <tspan x={82.5} y={38.02}>
          {"(1970-)"}
        </tspan>
      </text>
    </g>
    <path d="M19355.5 1830.38h130v30h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M19355.5 1830.38h130v30h-130z" />
      <text fill="#000" transform="translate(19355.5 1830.38)">
        <tspan x={37.117} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={73.719} y={19.62}>
          {" Anmarie"}
        </tspan>
      </text>
    </g>
    <path d="M19135.5 1820.38h170v50h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M19135.5 1820.38h170v50h-170z" />
      <text fill="#000" transform="translate(19135.5 1820.38)">
        <tspan x={17.992} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={93.719} y={21.22}>
          {" Edward J. Mac Nevin"}
        </tspan>
        <tspan x={85} y={38.02}>
          {"(1966-)"}
        </tspan>
      </text>
    </g>
    <path d="M14105.5 2120.38h185v50h-185z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M14105.5 2120.38h185v50h-185z" />
      <text fill="#000" transform="translate(14105.5 2120.38)">
        <tspan x={13.262} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={101.219} y={21.22}>
          {" McKenna Rhae Bellenger"}
        </tspan>
        <tspan x={92.5} y={38.02}>
          {"(2009-)"}
        </tspan>
      </text>
    </g>
    <path d="M14345.5 2120.38h230v50h-230z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M14345.5 2120.38h230v50h-230z" />
      <text fill="#000" transform="translate(14345.5 2120.38)">
        <tspan x={19.91} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={123.719} y={21.22}>
          {" Christian Joseph CJ Bellenger"}
        </tspan>
        <tspan x={115} y={38.02}>
          {"(2012-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M14145.5 1695.38h155z" />
    <path d="M14325.5 1970.38h155v50h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M14325.5 1970.38h155v50h-155z" />
      <text fill="#000" transform="translate(14325.5 1970.38)">
        <tspan x={17.25} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={86.219} y={21.22}>
          {" Christian Bellenger"}
        </tspan>
        <tspan x={77.5} y={38.02}>
          {"(1983-)"}
        </tspan>
      </text>
    </g>
    <path d="M17440.5 1970.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M17440.5 1970.38h115v50h-115z" />
      <text fill="#000" transform="translate(17440.5 1970.38)">
        <tspan x={13.039} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Parker Severe"}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(2014-)"}
        </tspan>
      </text>
    </g>
    <path d="M17610.5 1820.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M17610.5 1820.38h120v50h-120z" />
      <text fill="#000" transform="translate(17610.5 1820.38)">
        <tspan x={13.234} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Sean P. Severe"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1983-)"}
        </tspan>
      </text>
    </g>
    <path d="M17435.5 1820.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M17435.5 1820.38h125v50h-125z" />
      <text fill="#000" transform="translate(17435.5 1820.38)">
        <tspan x={17.852} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Katy Lumbara"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1984-)"}
        </tspan>
      </text>
    </g>
    <path d="M13465.5 2120.38h160v50h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13465.5 2120.38h160v50h-160z" />
      <text fill="#000" transform="translate(13465.5 2120.38)">
        <tspan x={13.801} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={88.719} y={21.22}>
          {" Parker Robert Bolton"}
        </tspan>
        <tspan x={80} y={38.02}>
          {"(2009-)"}
        </tspan>
      </text>
    </g>
    <path d="M13670.5 2120.38h170v50h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13670.5 2120.38h170v50h-170z" />
      <text fill="#000" transform="translate(13670.5 2120.38)">
        <tspan x={11.629} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={93.719} y={21.22}>
          {" Sawyer Douglas Bolton"}
        </tspan>
        <tspan x={85} y={38.02}>
          {"(2013-)"}
        </tspan>
      </text>
    </g>
    <path d="M13890.5 2120.38h155v50h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13890.5 2120.38h155v50h-155z" />
      <text fill="#000" transform="translate(13890.5 2120.38)">
        <tspan x={14.84} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={86.219} y={21.22}>
          {" Saylor Lynne Bolton"}
        </tspan>
        <tspan x={77.5} y={38.02}>
          {"(2017-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M20190.5 1520.38" />
    <path d="M20824.5 1830.38h135v30h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M20824.5 1830.38h135v30h-135z" />
      <text fill="#000" transform="translate(20824.5 1830.38)">
        <tspan x={13.43} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={76.219} y={19.62}>
          {" John R Giovanne"}
        </tspan>
      </text>
    </g>
    <path d="M20600.5 1820.38h194v50h-194z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M20600.5 1820.38h194v50h-194z" />
      <text fill="#000" transform="translate(20600.5 1820.38)">
        <tspan x={16.215} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={105.719} y={21.22}>
          {" Lauren Louise Nungesser"}
        </tspan>
        <tspan x={97} y={38.02}>
          {"(1979-)"}
        </tspan>
      </text>
    </g>
    <path d="M21019.5 1820.38h130v50h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M21019.5 1820.38h130v50h-130z" />
      <text fill="#000" transform="translate(21019.5 1820.38)">
        <tspan x={12.945} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={73.719} y={21.22}>
          {" Brett Nungesser"}
        </tspan>
        <tspan x={65} y={38.02}>
          {"(1984-)"}
        </tspan>
      </text>
    </g>
    <path d="M20425.5 1820.38h139v50h-139z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M20425.5 1820.38h139v50h-139z" />
      <text fill="#000" transform="translate(20425.5 1820.38)">
        <tspan x={17.148} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.219} y={21.22}>
          {" Ryan Nungesser"}
        </tspan>
        <tspan x={69.5} y={38.02}>
          {"(1979-)"}
        </tspan>
      </text>
    </g>
    <path d="M14535.5 1970.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M14535.5 1970.38h125v50h-125z" />
      <text fill="#000" transform="translate(14535.5 1970.38)">
        <tspan x={17.18} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Carol Brobeck"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1990-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M14845.5 1545.38h-240 240M13730.5 1220.38h20z" />
    <path d="M13525.5 1970.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13525.5 1970.38h200v50h-200z" />
      <text fill="#000" transform="translate(13525.5 1970.38)">
        <tspan x={27.852} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Brandon Robert Bolton"}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(1985-)"}
        </tspan>
      </text>
    </g>
    <path d="M14460.5 1820.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M14460.5 1820.38h120v50h-120z" />
      <text fill="#000" transform="translate(14460.5 1820.38)">
        <tspan x={13.781} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Terry Brobeck "}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1965-)"}
        </tspan>
      </text>
    </g>
    <path d="M14623 1820.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M14623 1820.38h125v50h-125z" />
      <text fill="#000" transform="translate(14623 1820.38)">
        <tspan x={11.039} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Heather Brokaw"}
        </tspan>
        <tspan x={37.066} y={38.02}>
          {"and "}
        </tspan>
        <tspan x={59.137} y={38.02} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={84.57} y={38.02}>
          {" Judy"}
        </tspan>
      </text>
    </g>
    <path d="M13770.5 1970.38h165v50h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13770.5 1970.38h165v50h-165z" />
      <text fill="#000" transform="translate(13770.5 1970.38)">
        <tspan x={12.426} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={91.219} y={21.22}>
          {" Shannon Lynne Doney"}
        </tspan>
        <tspan x={82.5} y={38.02}>
          {"(1988-)"}
        </tspan>
      </text>
    </g>
    <path d="M14110.5 1970.38h165v50h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M14110.5 1970.38h165v50h-165z" />
      <text fill="#000" transform="translate(14110.5 1970.38)">
        <tspan x={12.484} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={91.219} y={21.22}>
          {" Michelle Rhae Doney"}
        </tspan>
        <tspan x={82.5} y={38.02}>
          {"(1985-)"}
        </tspan>
      </text>
    </g>
    <path d="M13785.5 1820.38h155v50h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13785.5 1820.38h155v50h-155z" />
      <text fill="#000" transform="translate(13785.5 1820.38)">
        <tspan x={12.723} y={21.22} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={43.301} y={21.22} fontSize={14}>
          {" Tanya "}
        </tspan>
        <tspan x={80.844} y={21.22}>
          {"Rhae"}
        </tspan>
        <tspan x={123.762} y={21.22} fontSize={14}>
          {" Brobeck"}
        </tspan>
        <tspan x={77.5} y={38.02} fontSize={14}>
          {"(1961-)"}
        </tspan>
      </text>
    </g>
    <path d="M13970.5 1830.38h115v30h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13970.5 1830.38h115v30h-115z" />
      <text fill="#000" transform="translate(13970.5 1830.38)">
        <tspan x={18.242} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={66.219} y={19.62}>
          {" Doug Doney"}
        </tspan>
      </text>
    </g>
    <path d="M17930.5 1820.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M17930.5 1820.38h120v50h-120z" />
      <text fill="#000" transform="translate(17930.5 1820.38)">
        <tspan x={13.078} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Jessica White "}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1978-)"}
        </tspan>
      </text>
    </g>
    <path d="M17765.5 1820.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M17765.5 1820.38h125v50h-125z" />
      <text fill="#000" transform="translate(17765.5 1820.38)">
        <tspan x={18.109} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Justin Stepan"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1977-)"}
        </tspan>
      </text>
    </g>
    <path d="M17425.5 1680.38h195v30h-195z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M17425.5 1680.38h195v30h-195z" />
      <text fill="#000" transform="translate(17425.5 1680.38)">
        <tspan x={31.516} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={106.219} y={19.62}>
          {" Kevin Eugene Severe"}
        </tspan>
      </text>
    </g>
    <path d="M15085.5 1970.38h160v50h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M15085.5 1970.38h160v50h-160z" />
      <text fill="#000" transform="translate(15085.5 1970.38)">
        <tspan x={14.758} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={88.719} y={21.22}>
          {" Elizabeth Anne King "}
        </tspan>
        <tspan x={80} y={38.02}>
          {"(2002-)"}
        </tspan>
      </text>
    </g>
    <path d="M14900.5 1970.38h160v50h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M14900.5 1970.38h160v50h-160z" />
      <text fill="#000" transform="translate(14900.5 1970.38)">
        <tspan x={13.82} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={88.719} y={21.22}>
          {" Janie Elizabeth King "}
        </tspan>
        <tspan x={80} y={38.02}>
          {"(1999-)"}
        </tspan>
      </text>
    </g>
    <path d="M14700.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M14700.5 1970.38h150v50h-150z" />
      <text fill="#000" transform="translate(14700.5 1970.38)">
        <tspan x={11.625} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Robert Brooks King "}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1998-)"}
        </tspan>
      </text>
    </g>
    <path d="M15200.5 1820.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M15200.5 1820.38h140v50h-140z" />
      <text fill="#000" transform="translate(15200.5 1820.38)">
        <tspan x={23.387} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Brian Leo Rud "}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(1972-)"}
        </tspan>
      </text>
    </g>
    <path d="M15015.5 1820.38h130v50h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M15015.5 1820.38h130v50h-130z" />
      <text fill="#000" transform="translate(15015.5 1820.38)">
        <tspan x={14.957} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={73.719} y={21.22}>
          {" Sonja Jane Rud"}
        </tspan>
        <tspan x={65} y={38.02}>
          {"(1968-)"}
        </tspan>
      </text>
    </g>
    <path d="M14855.5 1830.38h95v30h-95z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M14855.5 1830.38h95v30h-95z" />
      <text fill="#000" transform="translate(14855.5 1830.38)">
        <tspan x={14.059} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={56.219} y={19.62}>
          {" Brian King"}
        </tspan>
      </text>
    </g>
    <path d="M13415.5 1820.38h185v50h-185z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13415.5 1820.38h185v50h-185z" />
      <text fill="#000" transform="translate(13415.5 1820.38)">
        <tspan x={14.215} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={101.219} y={21.22}>
          {" Douglas Richard Bondon"}
        </tspan>
        <tspan x={92.5} y={38.02}>
          {"(1962-)"}
        </tspan>
      </text>
    </g>
    <path d="M13640.5 1820.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13640.5 1820.38h125v50h-125z" />
      <text fill="#000" transform="translate(13640.5 1820.38)">
        <tspan x={14.992} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Dana Anderon "}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1970-)"}
        </tspan>
      </text>
    </g>
    <path d="M27320.5 1830.38h210v30h-210z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27320.5 1830.38h210v30h-210z" />
      <text fill="#000" transform="translate(27320.5 1830.38)">
        <tspan x={31.438} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEA\uD83C\uDDF8"}
        </tspan>
        <tspan x={113.719} y={19.62}>
          {" Yasmin Shawi Sanchez"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M26035.5 395.38h100M26820.5 1520.38v-200h-615v-30" />
    <path fill="none" d="M26148 1520.38v-200h447.5" />
    <path d="M26995.5 1820.38h130v50h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26995.5 1820.38h130v50h-130z" />
      <text fill="#000" transform="translate(26995.5 1820.38)">
        <tspan x={22.043} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={73.719} y={21.22}>
          {" Tiziana Travo"}
        </tspan>
        <tspan x={65} y={38.02}>
          {"(1970-)"}
        </tspan>
      </text>
    </g>
    <path d="M27160.5 1820.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27160.5 1820.38h115v50h-115z" />
      <text fill="#000" transform="translate(27160.5 1820.38)">
        <tspan x={11.961} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Eugenio Travo"}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(1978-)"}
        </tspan>
      </text>
    </g>
    <path d="M26715.5 1670.38h130v50h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26715.5 1670.38h130v50h-130z" />
      <text fill="#000" transform="translate(26715.5 1670.38)">
        <tspan x={15.223} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={73.719} y={21.22}>
          {" Giuseppe Travo"}
        </tspan>
        <tspan x={65} y={38.02}>
          {"(1950-1951)"}
        </tspan>
      </text>
    </g>
    <path d="M27155.5 1670.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27155.5 1670.38h135v50h-135z" />
      <text fill="#000" transform="translate(27155.5 1670.38)">
        <tspan x={15.203} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Rosalba Zerbino"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1946-)"}
        </tspan>
      </text>
    </g>
    <path d="M27005.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27005.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(27005.5 1670.38)">
        <tspan x={11.715} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Giulio Travo"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1947-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M26420.5 1670.38v-125h-5" />
    <path d="M26540.5 1680.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26540.5 1680.38h125v30h-125z" />
      <text fill="#000" transform="translate(26540.5 1680.38)">
        <tspan x={19.309} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Carlo Oliviero"}
        </tspan>
      </text>
    </g>
    <path d="M26355.5 1670.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26355.5 1670.38h140v50h-140z" />
      <text fill="#000" transform="translate(26355.5 1670.38)">
        <tspan x={25.43} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Rosetta Travo"}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(1943-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M26870.5 1545.38h35" />
    <path d="M26905.5 1520.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26905.5 1520.38h110v50h-110z" />
      <text fill="#000" transform="translate(26905.5 1520.38)">
        <tspan x={17.371} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Zita Ferrero"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1918-1983)"}
        </tspan>
      </text>
    </g>
    <path d="M26760.5 1520.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26760.5 1520.38h110v50h-110z" />
      <text fill="#000" transform="translate(26760.5 1520.38)">
        <tspan x={15.141} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Renzo Travo"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1918-1983)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M26390.5 1545.38h110" />
    <path d="M26470.5 1530.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26470.5 1530.38h150v30h-150z" />
      <text fill="#000" transform="translate(26470.5 1530.38)">
        <tspan x={14.023} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Giuseppina Cravevi"}
        </tspan>
      </text>
    </g>
    <path d="M26280.5 1520.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26280.5 1520.38h110v50h-110z" />
      <text fill="#000" transform="translate(26280.5 1520.38)">
        <tspan x={13.211} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Pericle Travo"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1912-1990)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M26075.5 1520.38h145v50h-145z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M26075.5 1520.38h145v50h-145z" />
        <text fill="#000" transform="translate(26075.5 1520.38)">
          <tspan x={25.543} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={81.219} y={21.22}>
            {" Vittorina Travo"}
          </tspan>
          <tspan x={72.5} y={38.02}>
            {"(1909-1976)"}
          </tspan>
        </text>
      </g>
    <path d="M13125.5 1970.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13125.5 1970.38h125v50h-125z" />
      <text fill="#000" transform="translate(13125.5 1970.38)">
        <tspan x={24.934} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Miles Rowe"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(2002-)"}
        </tspan>
      </text>
    </g>
    <path d="M13300.5 1970.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13300.5 1970.38h125v50h-125z" />
      <text fill="#000" transform="translate(13300.5 1970.38)">
        <tspan x={16.137} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Addison Rowe"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(2004-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M16555.5 1695.38" />
    <path d="M17300.5 1970.38h105v50h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M17300.5 1970.38h105v50h-105z" />
      <text fill="#000" transform="translate(17300.5 1970.38)">
        <tspan x={15.113} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={21.22}>
          {" Ayla Amber"}
        </tspan>
        <tspan x={52.5} y={38.02}>
          {"(2010-)"}
        </tspan>
      </text>
    </g>
    <path d="M17160.5 1970.38h105v50h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M17160.5 1970.38h105v50h-105z" />
      <text fill="#000" transform="translate(17160.5 1970.38)">
        <tspan x={17.02} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={21.22}>
          {" Giana Gray"}
        </tspan>
        <tspan x={52.5} y={38.02}>
          {"(2008-)"}
        </tspan>
      </text>
    </g>
    <path d="M17015.5 1970.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M17015.5 1970.38h115v50h-115z" />
      <text fill="#000" transform="translate(17015.5 1970.38)">
        <tspan x={15.211} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Cade Gregor "}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(2005-)"}
        </tspan>
      </text>
    </g>
    <path d="M16875.5 1970.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M16875.5 1970.38h110v50h-110z" />
      <text fill="#000" transform="translate(16875.5 1970.38)">
        <tspan x={10.957} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Jules Ashton "}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(2003-)"}
        </tspan>
      </text>
    </g>
    <path d="M17135.5 1820.38h205v50h-205z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M17135.5 1820.38h205v50h-205z" />
      <text fill="#000" transform="translate(17135.5 1820.38)">
        <tspan x={28.125} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={111.219} y={21.22}>
          {" Amber Kimberly Pierce "}
        </tspan>
        <tspan x={102.5} y={38.02}>
          {"(1979-)"}
        </tspan>
      </text>
    </g>
    <path d="M16970.5 1820.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M16970.5 1820.38h100v50h-100z" />
      <text fill="#000" transform="translate(16970.5 1820.38)">
        <tspan x={22.641} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Ian Gary"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1979-)"}
        </tspan>
      </text>
    </g>
    <path d="M16705.5 1970.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M16705.5 1970.38h125v50h-125z" />
      <text fill="#000" transform="translate(16705.5 1970.38)">
        <tspan x={19.184} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Grayson Gary"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(2010-)"}
        </tspan>
      </text>
    </g>
    <path d="M16555.5 1970.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M16555.5 1970.38h120v50h-120z" />
      <text fill="#000" transform="translate(16555.5 1970.38)">
        <tspan x={18.027} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Keegan Tate "}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(2009-)"}
        </tspan>
      </text>
    </g>
    <path d="M16420.5 1970.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M16420.5 1970.38h110v50h-110z" />
      <text fill="#000" transform="translate(16420.5 1970.38)">
        <tspan x={16.41} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Abby Marie "}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(2006-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M16455.5 1695.38h165z" />
    <path d="M16640.5 1820.38h165v50h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M16640.5 1820.38h165v50h-165z" />
      <text fill="#000" transform="translate(16640.5 1820.38)">
        <tspan x={14.578} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={91.219} y={21.22}>
          {" Katherine Ann Bybee "}
        </tspan>
        <tspan x={82.5} y={38.02}>
          {"(1979-)"}
        </tspan>
      </text>
    </g>
    <path d="M16475.5 1820.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M16475.5 1820.38h100v50h-100z" />
      <text fill="#000" transform="translate(16475.5 1820.38)">
        <tspan x={19.875} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Tate Leo "}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1978-)"}
        </tspan>
      </text>
    </g>
    <path d="M16210.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M16210.5 1970.38h150v50h-150z" />
      <text fill="#000" transform="translate(16210.5 1970.38)">
        <tspan x={19.352} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Alexander Xavier "}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(2009-)"}
        </tspan>
      </text>
    </g>
    <path d="M16050.5 1970.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M16050.5 1970.38h115v50h-115z" />
      <text fill="#000" transform="translate(16050.5 1970.38)">
        <tspan x={14.387} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Aimee Quinn "}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(2000-)"}
        </tspan>
      </text>
    </g>
    <path d="M15860.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M15860.5 1970.38h150v50h-150z" />
      <text fill="#000" transform="translate(15860.5 1970.38)">
        <tspan x={12.375} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Cody Jack Whitlow "}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1997-)"}
        </tspan>
      </text>
    </g>
    <path d="M15660.5 1970.38h170v50h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M15660.5 1970.38h170v50h-170z" />
      <text fill="#000" transform="translate(15660.5 1970.38)">
        <tspan x={18.758} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={93.719} y={21.22}>
          {" Anastazia Macalynn "}
        </tspan>
        <tspan x={85} y={38.02}>
          {"(2010-)"}
        </tspan>
      </text>
    </g>
    <path d="M15450.5 1970.38h175v50h-175z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M15450.5 1970.38h175v50h-175z" />
      <text fill="#000" transform="translate(15450.5 1970.38)">
        <tspan x={22.008} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={96.219} y={21.22}>
          {" Madalynn Suzanne "}
        </tspan>
        <tspan x={87.5} y={38.02}>
          {"(2007-)"}
        </tspan>
      </text>
    </g>
    <path d="M16325.5 1820.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M16325.5 1820.38h100v50h-100z" />
      <text fill="#000" transform="translate(16325.5 1820.38)">
        <tspan x={34.766} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Tara"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1976-1994)"}
        </tspan>
      </text>
    </g>
    <path d="M16075.5 1820.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M16075.5 1820.38h200v50h-200z" />
      <text fill="#000" transform="translate(16075.5 1820.38)">
        <tspan x={26.746} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Jama Sherise Andress "}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(1974-)"}
        </tspan>
      </text>
    </g>
    <path d="M15890.5 1820.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M15890.5 1820.38h145v50h-145z" />
      <text fill="#000" transform="translate(15890.5 1820.38)">
        <tspan x={15.57} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Christopher John "}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1974-)"}
        </tspan>
      </text>
    </g>
    <path d="M15675.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M15675.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(15675.5 1820.38)">
        <tspan x={13.555} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Jessica Lynn Hauk "}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1974-)"}
        </tspan>
      </text>
    </g>
    <path d="M15375.5 1820.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M15375.5 1820.38h100v50h-100z" />
      <text fill="#000" transform="translate(15375.5 1820.38)">
        <tspan x={32.52} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Amy "}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1970-1974)"}
        </tspan>
      </text>
    </g>
    <path d="M15525.5 1820.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M15525.5 1820.38h100v50h-100z" />
      <text fill="#000" transform="translate(15525.5 1820.38)">
        <tspan x={14.684} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Heath Leo "}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1972-)"}
        </tspan>
      </text>
    </g>
    <path d="M20255.5 1820.38h114v50h-114z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M20255.5 1820.38h114v50h-114z" />
      <text fill="#000" transform="translate(20255.5 1820.38)">
        <tspan x={12.5} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={65.719} y={21.22}>
          {" Theresa Anne"}
        </tspan>
        <tspan x={57} y={38.02}>
          {"(1986-)"}
        </tspan>
      </text>
    </g>
    <path d="M20055.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M20055.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(20055.5 1820.38)">
        <tspan x={18.238} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Katherine Nichole"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1984-)"}
        </tspan>
      </text>
    </g>
    <path d="M19920.5 1680.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M19920.5 1680.38h150v30h-150z" />
      <text fill="#000" transform="translate(19920.5 1680.38)">
        <tspan x={17.797} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Susan D. Vavrinek"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M13730.5 1220.38h30v-50h4620M11790.5 1545.38h20z" />
    <path d="M11830.5 1520.38h190v50h-190z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M11830.5 1520.38h190v50h-190z" />
      <text fill="#000" transform="translate(11830.5 1520.38)">
        <tspan x={22.793} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={103.719} y={21.22}>
          {" Honolu (Tootsie) Lovin"}
        </tspan>
        <tspan x={95} y={38.02}>
          {"(1932-1990)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M11665.5 1545.38h-25 25" />
    <path d="M12770.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M12770.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(12770.5 1670.38)">
        <tspan x={12.84} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Anne Marie"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1951-)"}
        </tspan>
      </text>
    </g>
    <path d="M12920.5 1680.38h180v30h-180z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M12920.5 1680.38h180v30h-180z" />
      <text fill="#000" transform="translate(12920.5 1680.38)">
        <tspan x={36.344} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={98.719} y={19.62}>
          {" Lawrence Moore"}
        </tspan>
      </text>
    </g>
    <path d="M12135.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M12135.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(12135.5 1670.38)">
        <tspan x={29.02} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Peggy"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1948-2021)"}
        </tspan>
      </text>
    </g>
    <path d="M12280.5 1670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M12280.5 1670.38h150v50h-150z" />
      <text fill="#000" transform="translate(12280.5 1670.38)">
        <tspan x={17.156} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Arthur Oliver Allen"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1946-)"}
        </tspan>
      </text>
    </g>
    <path d="M11195.5 1670.38h105v50h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M11195.5 1670.38h105v50h-105z" />
      <text fill="#000" transform="translate(11195.5 1670.38)">
        <tspan x={29.641} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={21.22}>
          {" James"}
        </tspan>
        <tspan x={52.5} y={38.02}>
          {"(1947-1993)"}
        </tspan>
      </text>
    </g>
    <path d="M11350.5 1670.38h170v50h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M11350.5 1670.38h170v50h-170z" />
      <text fill="#000" transform="translate(11350.5 1670.38)">
        <tspan x={27.457} y={21.22} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={93.719} y={21.22} fontSize={14}>
          {" Jacquelyn Trotter"}
        </tspan>
        <tspan x={85} y={38.02} fontSize={14}>
          {"(1945-2025)"}
        </tspan>
      </text>
    </g>
    <path d="M11460.5 1520.38h155v50h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M11460.5 1520.38h155v50h-155z" />
      <text fill="#000" transform="translate(11460.5 1520.38)">
        <tspan x={17.781} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={86.219} y={21.22}>
          {" Betty Louise Kruse"}
        </tspan>
        <tspan x={77.5} y={38.02}>
          {"(1926-1989)"}
        </tspan>
      </text>
    </g>
    <path d="M11665.5 1520.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M11665.5 1520.38h125v50h-125z" />
      <text fill="#000" transform="translate(11665.5 1520.38)">
        <tspan x={21.473} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Mark Sylvins"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1916-1998)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M17120.5 1545.38h50" />
    <path d="M16965.5 1520.38h155v50h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M16965.5 1520.38h155v50h-155z" />
      <text fill="#000" transform="translate(16965.5 1520.38)">
        <tspan x={41.73} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={86.219} y={21.22}>
          {" Eda Louise"}
        </tspan>
        <tspan x={77.5} y={38.02}>
          {"(1917-2006)"}
        </tspan>
      </text>
    </g>
    <path d="M17170.5 1520.38h165v50h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M17170.5 1520.38h165v50h-165z" />
      <text fill="#000" transform="translate(17170.5 1520.38)">
        <tspan x={12.859} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={91.219} y={21.22}>
          {" Francis Pierson Smith"}
        </tspan>
        <tspan x={82.5} y={38.02}>
          {"(1914-1942)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M13508 1820.38v-50h-337.5v45" />
    <path d="M13100.5 1820.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13100.5 1820.38h140v50h-140z" />
      <text fill="#000" transform="translate(13100.5 1820.38)">
        <tspan x={11.512} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Stephanie Bondon"}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(1966-)"}
        </tspan>
      </text>
    </g>
    <path d="M13290.5 1820.38h95v50h-95z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13290.5 1820.38h95v50h-95z" />
      <text fill="#000" transform="translate(13290.5 1820.38)">
        <tspan x={10.914} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={56.219} y={21.22}>
          {" Keith Rowe"}
        </tspan>
        <tspan x={47.5} y={38.02}>
          {"(1970-)"}
        </tspan>
      </text>
    </g>
    <path d="M17705.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M17705.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(17705.5 1670.38)">
        <tspan x={33.594} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Sally"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1954-)"}
        </tspan>
      </text>
    </g>
    <path d="M17855.5 1680.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M17855.5 1680.38h150v30h-150z" />
      <text fill="#000" transform="translate(17855.5 1680.38)">
        <tspan x={15.293} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Louis Mark Stepan"}
        </tspan>
      </text>
    </g>
    <path d="M16305.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M16305.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(16305.5 1670.38)">
        <tspan x={20.746} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Gary Leo"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1948-1990)"}
        </tspan>
      </text>
    </g>
    <path d="M16455.5 1670.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M16455.5 1670.38h200v50h-200z" />
      <text fill="#000" transform="translate(16455.5 1670.38)">
        <tspan x={20.625} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Suzanne Deborah Fornes"}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(1950-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M14845.5 1545.38h-25 25" />
    <path d="M15010.5 1670.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M15010.5 1670.38h135v50h-135z" />
      <text fill="#000" transform="translate(15010.5 1670.38)">
        <tspan x={27.445} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Betty Louise"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1942-)"}
        </tspan>
      </text>
    </g>
    <path d="M15190.5 1670.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M15190.5 1670.38h200v50h-200z" />
      <text fill="#000" transform="translate(15190.5 1670.38)">
        <tspan x={46.188} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" KennRussell Rud"}
        </tspan>
        <tspan x={27.121} y={38.02}>
          {"and "}
        </tspan>
        <tspan x={49.191} y={38.02} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={122.07} y={38.02}>
          {" Derald Francis Grow"}
        </tspan>
      </text>
    </g>
    <path d="M13995.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13995.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(13995.5 1670.38)">
        <tspan x={23.957} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Barbara"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1940-2021)"}
        </tspan>
      </text>
    </g>
    <path d="M14145.5 1670.38h190v50h-190z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M14145.5 1670.38h190v50h-190z" />
      <text fill="#000" transform="translate(14145.5 1670.38)">
        <tspan x={40.449} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={103.719} y={21.22}>
          {" Kenneth Brobeck"}
        </tspan>
        <tspan x={95} y={38.02}>
          {"(1936-)"}
        </tspan>
      </text>
    </g>
    <path d="M13265.5 1670.38h105v50h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13265.5 1670.38h105v50h-105z" />
      <text fill="#000" transform="translate(13265.5 1670.38)">
        <tspan x={35.105} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={21.22}>
          {" Mary"}
        </tspan>
        <tspan x={52.5} y={38.02}>
          {"(1939-2007)"}
        </tspan>
      </text>
    </g>
    <path d="M13420.5 1670.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13420.5 1670.38h125v50h-125z" />
      <text fill="#000" transform="translate(13420.5 1670.38)">
        <tspan x={11.43} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Richard Bondon"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1935-2016)"}
        </tspan>
      </text>
    </g>
    <path d="M14605.5 1520.38h185v50h-185z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M14605.5 1520.38h185v50h-185z" />
      <text fill="#000" transform="translate(14605.5 1520.38)">
        <tspan x={24.934} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={101.219} y={21.22}>
          {" Anne Elizabeth Kruse"}
        </tspan>
        <tspan x={92.5} y={38.02}>
          {"(1917-1995)"}
        </tspan>
      </text>
    </g>
    <path d="M14845.5 1520.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M14845.5 1520.38h125v50h-125z" />
      <text fill="#000" transform="translate(14845.5 1520.38)">
        <tspan x={30.934} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Leo Silvio"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1914-1968)"}
        </tspan>
      </text>
    </g>
    <path d="M13510.5 1220.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13510.5 1220.38h125v50h-125z" />
      <text fill="#000" transform="translate(13510.5 1220.38)">
        <tspan x={18.969} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Maria Grosso"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1890-1919)"}
        </tspan>
      </text>
    </g>
    <path d="M13870.5 1220.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M13870.5 1220.38h125v50h-125z" />
      <text fill="#000" transform="translate(13870.5 1220.38)">
        <tspan x={16.832} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Della Shurbert"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1887-1992)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M13710.5 1220.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M13710.5 1220.38h100v50h-100z" />
        <text fill="#000" transform="translate(13710.5 1220.38)">
          <tspan x={30.012} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Dante"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1888-1965)"}
          </tspan>
        </text>
      </g>
    <path d="M18091.5 2120.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M18091.5 2120.38h140v50h-140z" />
      <text fill="#000" transform="translate(18091.5 2120.38)">
        <tspan x={51.902} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Elyee"}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(2007-)"}
        </tspan>
      </text>
    </g>
    <path d="M18091.5 1980.38h140v30h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M18091.5 1980.38h140v30h-140z" />
      <text fill="#000" transform="translate(18091.5 1980.38)">
        <tspan x={49.258} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.719} y={19.62}>
          {" Leann"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M18439 1570.38v-25h-67.5" />
    <path d="M18086.5 1820.38h154v50h-154z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M18086.5 1820.38h154v50h-154z" />
      <text fill="#000" transform="translate(18086.5 1820.38)">
        <tspan x={17.047} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={85.719} y={21.22}>
          {" Arlene Claudia Bell"}
        </tspan>
        <tspan x={77} y={38.02}>
          {"(1958-)"}
        </tspan>
      </text>
    </g>
    <path d="M18476.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M18476.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(18476.5 1820.38)">
        <tspan x={30.527} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Erica Ann Bell"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1967-)"}
        </tspan>
      </text>
    </g>
    <path d="M18256.5 1820.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M18256.5 1820.38h140v50h-140z" />
      <text fill="#000" transform="translate(18256.5 1820.38)">
        <tspan x={14.934} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Diana Louise Bell"}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(1960-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M19415.5 1520.38v-150h5640v-50M19365.5 1545.38h56.757v25"
    />
    <path d="M18935.5 1820.38h185v50h-185z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M18935.5 1820.38h185v50h-185z" />
      <text fill="#000" transform="translate(18935.5 1820.38)">
        <tspan x={15.672} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={101.219} y={21.22}>
          {" Anthony Ian Sepulveda"}
        </tspan>
        <tspan x={92.5} y={38.02}>
          {"(1977-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M18436.5 1520.38v-275h-25" />
    <path d="M19055.5 1680.38h115v30h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M19055.5 1680.38h115v30h-115z" />
      <text fill="#000" transform="translate(19055.5 1680.38)">
        <tspan x={16.91} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={66.219} y={19.62}>
          {" Victoria Laid"}
        </tspan>
      </text>
    </g>
    <path d="M18845.5 1670.38h170v50h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M18845.5 1670.38h170v50h-170z" />
      <text fill="#000" transform="translate(18845.5 1670.38)">
        <tspan x={13.406} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={93.719} y={21.22}>
          {" Ray Libero Sepulveda"}
        </tspan>
        <tspan x={85} y={38.02}>
          {"(1945-2001)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M18506.5 1545.38h-120 120" />
    <path d="M18401.5 1670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M18401.5 1670.38h150v50h-150z" />
      <text fill="#000" transform="translate(18401.5 1670.38)">
        <tspan x={34.5} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Arlen W. Bell"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1934-2010)"}
        </tspan>
      </text>
    </g>
    <path d="M18189 1670.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M18189 1670.38h140v50h-140z" />
      <text fill="#000" transform="translate(18189 1670.38)">
        <tspan x={13.563} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Helen Sepulveda"}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(1935-2021)"}
        </tspan>
      </text>
    </g>
    <path d="M18561.5 1520.38h209v50h-209z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M18561.5 1520.38h209v50h-209z" />
      <text fill="#000" transform="translate(18561.5 1520.38)">
        <tspan x={16.68} y={21.22} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={113.219} y={21.22} fontSize={14}>
          {" Sabina Celestina Stredella "}
        </tspan>
        <tspan x={104.5} y={38.02} fontSize={14}>
          {"(1912-2008)"}
        </tspan>
      </text>
    </g>
    <path d="M18371.5 1520.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M18371.5 1520.38h135v50h-135z" />
      <text fill="#000" transform="translate(18371.5 1520.38)">
        <tspan x={12.484} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Libero Sepulveda"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1908-1988)"}
        </tspan>
      </text>
    </g>
    <path d="M20590.5 1670.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M20590.5 1670.38h200v50h-200z" />
      <text fill="#000" transform="translate(20590.5 1670.38)">
        <tspan x={26.281} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Kendall Earl Nungesser"}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(1947-)"}
        </tspan>
      </text>
    </g>
    <path d="M20440.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M20440.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(20440.5 1670.38)">
        <tspan x={29.023} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Allene"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1948-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M20210.5 1520.38h40z" />
    <path d="M20265.5 1680.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M20265.5 1680.38h125v30h-125z" />
      <text fill="#000" transform="translate(20265.5 1680.38)">
        <tspan x={13.84} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Debra A Gilbert"}
        </tspan>
      </text>
    </g>
    <path d="M20105.5 1670.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M20105.5 1670.38h120v50h-120z" />
      <text fill="#000" transform="translate(20105.5 1670.38)">
        <tspan x={20.234} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Allen Robert"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1945-2014)"}
        </tspan>
      </text>
    </g>
    <path d="M19635.5 1670.38h180v50h-180z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M19635.5 1670.38h180v50h-180z" />
      <text fill="#000" transform="translate(19635.5 1670.38)">
        <tspan x={12.754} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={98.719} y={21.22}>
          {" Olga K. (Cookie) Lederer"}
        </tspan>
        <tspan x={90} y={38.02}>
          {"(1944-2009)"}
        </tspan>
      </text>
    </g>
    <path d="M19365.5 1670.38h220v50h-220z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M19365.5 1670.38h220v50h-220z" />
      <text fill="#000" transform="translate(19365.5 1670.38)">
        <tspan x={23.141} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={118.719} y={21.22}>
          {" Lawrence Alfred Mac Nevin"}
        </tspan>
        <tspan x={110} y={38.02}>
          {"(1942-)"}
        </tspan>
      </text>
    </g>
    <path d="M20340.5 1520.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M20340.5 1520.38h150v50h-150z" />
      <text fill="#000" transform="translate(20340.5 1520.38)">
        <tspan x={12.266} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Louisa Pagliassotti "}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1914-2013)"}
        </tspan>
      </text>
    </g>
    <path d="M20190.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M20190.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(20190.5 1520.38)">
        <tspan x={28.402} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Arthur"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1910-1982)"}
        </tspan>
      </text>
    </g>
    <path d="M19515.5 1520.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M19515.5 1520.38h150v50h-150z" />
      <text fill="#000" transform="translate(19515.5 1520.38)">
        <tspan x={12.168} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Federick Mac Nevin"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1901-1991)"}
        </tspan>
      </text>
    </g>
    <path d="M19365.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M19365.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(19365.5 1520.38)">
        <tspan x={22.387} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Augusta"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1903-1993)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M9960.5 1695.38h70M10865.5 1245.38h60" />
    <path d="M10030.5 1675.38h140v40h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M10030.5 1675.38h140v40h-140z" />
      <text fill="#000" transform="translate(10030.5 1675.38)">
        <tspan x={19.18} y={24.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={80.637} y={24.62}>
          {" William Gillespie"}
        </tspan>
      </text>
    </g>
    <path d="M9860.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9860.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(9860.5 1670.38)">
        <tspan x={19.215} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Julie Orsi"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1965-)"}
        </tspan>
      </text>
    </g>
    <path d="M9490.5 1680.38H9603v30h-112.5z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9490.5 1680.38H9603v30h-112.5z" />
      <text fill="#000" transform="translate(9490.5 1680.38)">
        <tspan x={11.875} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={64.969} y={19.62}>
          {" Sharon Richie"}
        </tspan>
      </text>
    </g>
    <path d="M9340.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9340.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(9340.5 1670.38)">
        <tspan x={20.301} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Paul Orsi"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1963-)"}
        </tspan>
      </text>
    </g>
    <path d="M9190.5 1680.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9190.5 1680.38h100v30h-100z" />
      <text fill="#000" transform="translate(9190.5 1680.38)">
        <tspan x={11.484} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Sheree Lum"}
        </tspan>
      </text>
    </g>
    <path d="M9040.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9040.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(9040.5 1670.38)">
        <tspan x={18.473} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" John Orsi"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1959-)"}
        </tspan>
      </text>
    </g>
    <path d="M8840.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M8840.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(8840.5 1670.38)">
        <tspan x={11.301} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Julie Mielke"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1958-)"}
        </tspan>
      </text>
    </g>
    <path d="M8690.5 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M8690.5 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(8690.5 1670.38)">
        <tspan x={11.09} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Joseph Orsi"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1958-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M9485.5 1520.38v-125" />
    <path d="M9405.5 1520.38h155v50h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9405.5 1520.38h155v50h-155z" />
      <text fill="#000" transform="translate(9405.5 1520.38)">
        <tspan x={15.102} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={86.219} y={21.22}>
          {" Francis (Frank) Orsi"}
        </tspan>
        <tspan x={77.5} y={38.02}>
          {"(1930-2016)"}
        </tspan>
      </text>
    </g>
    <path d="M9178 1520.38h192.5v50H9178z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9178 1520.38h192.5v50H9178z" />
      <text fill="#000" transform="translate(9178 1520.38)">
        <tspan x={13.945} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={104.969} y={21.22}>
          {"Alexandra (Sandy) Q Miller"}
        </tspan>
        <tspan x={96.25} y={38.02}>
          {"(1933-1994)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M9465.5 1395.38h40" />
    <path d="M9505.5 1370.38h155v50h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9505.5 1370.38h155v50h-155z" />
      <text fill="#000" transform="translate(9505.5 1370.38)">
        <tspan x={30.594} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={86.219} y={21.22}>
          {" Mary Vallicella"}
        </tspan>
        <tspan x={77.5} y={38.02}>
          {"(1908-1989)"}
        </tspan>
      </text>
    </g>
    <path d="M24585.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M24585.5 1970.38h150v50h-150z" />
      <text fill="#000" transform="translate(24585.5 1970.38)">
        <tspan x={17.762} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Connor Alexander"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(2008-)"}
        </tspan>
      </text>
    </g>
    <path d="M24185.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M24185.5 1970.38h150v50h-150z" />
      <text fill="#000" transform="translate(24185.5 1970.38)">
        <tspan x={34.926} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Vivian Marie"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(2004-)"}
        </tspan>
      </text>
    </g>
    <path d="M24385.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M24385.5 1970.38h150v50h-150z" />
      <text fill="#000" transform="translate(24385.5 1970.38)">
        <tspan x={24.672} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Anthony James"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(2005-)"}
        </tspan>
      </text>
    </g>
    <path d="M24485.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M24485.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(24485.5 1820.38)">
        <tspan x={16.977} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Laura Ann Chaney"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1981-)"}
        </tspan>
      </text>
    </g>
    <path d="M24285.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M24285.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(24285.5 1820.38)">
        <tspan x={28.879} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Kevin Anthony"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1979-)"}
        </tspan>
      </text>
    </g>
    <path d="M24080.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M24080.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(24080.5 1820.38)">
        <tspan x={40.383} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Lisa (Alex)"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1968-2007)"}
        </tspan>
      </text>
    </g>
    <path d="M24485.5 1670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M24485.5 1670.38h150v50h-150z" />
      <text fill="#000" transform="translate(24485.5 1670.38)">
        <tspan x={29.516} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Jean Hawkins"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1952-)"}
        </tspan>
      </text>
    </g>
    <path d="M24285.5 1670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M24285.5 1670.38h150v50h-150z" />
      <text fill="#000" transform="translate(24285.5 1670.38)">
        <tspan x={29.008} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Ronald Philips"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1943-)"}
        </tspan>
      </text>
    </g>
    <path d="M24085.5 1670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M24085.5 1670.38h150v50h-150z" />
      <text fill="#000" transform="translate(24085.5 1670.38)">
        <tspan x={14.684} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Marsha Ann Steele"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1943-2008)"}
        </tspan>
      </text>
    </g>
    <path d="M23845.5 1970.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M23845.5 1970.38h200v50h-200z" />
      <text fill="#000" transform="translate(23845.5 1970.38)">
        <tspan x={24.375} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Kylie Marie Schmiedeke"}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(2000-)"}
        </tspan>
      </text>
    </g>
    <path d="M23645.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M23645.5 1970.38h150v50h-150z" />
      <text fill="#000" transform="translate(23645.5 1970.38)">
        <tspan x={19.836} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Alec Schmiedeke"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1997-)"}
        </tspan>
      </text>
    </g>
    <path d="M23845.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M23845.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(23845.5 1820.38)">
        <tspan x={37.852} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Heidi Toma"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1967-)"}
        </tspan>
      </text>
    </g>
    <path d="M23645.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M23645.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(23645.5 1820.38)">
        <tspan x={19.73} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Paul Schmiedeke"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1964-)"}
        </tspan>
      </text>
    </g>
    <path d="M23445.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M23445.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(23445.5 1820.38)">
        <tspan x={36.184} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Mark Ragus"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1957-)"}
        </tspan>
      </text>
    </g>
    <path d="M23240.5 1820.38h160v50h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M23240.5 1820.38h160v50h-160z" />
      <text fill="#000" transform="translate(23240.5 1820.38)">
        <tspan x={14.938} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={88.719} y={21.22}>
          {" Pamela Schmiedeke"}
        </tspan>
        <tspan x={80} y={38.02}>
          {"(1963-)"}
        </tspan>
      </text>
    </g>
    <path d="M23645.5 1670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M23645.5 1670.38h150v50h-150z" />
      <text fill="#000" transform="translate(23645.5 1670.38)">
        <tspan x={11.855} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Ronald Schmiedeke"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1935-)"}
        </tspan>
      </text>
    </g>
    <path d="M23435.5 1670.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M23435.5 1670.38h140v50h-140z" />
      <text fill="#000" transform="translate(23435.5 1670.38)">
        <tspan x={26.289} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Rena Gemma"}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(1937-)"}
        </tspan>
      </text>
    </g>
    <path d="M22925.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M22925.5 1970.38h150v50h-150z" />
      <text fill="#000" transform="translate(22925.5 1970.38)">
        <tspan x={36.223} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Ryan Mauro"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1999-)"}
        </tspan>
      </text>
    </g>
    <path d="M22650.5 2120.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M22650.5 2120.38h110v50h-110z" />
      <text fill="#000" transform="translate(22650.5 2120.38)">
        <tspan x={14.328} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Gianni Keola"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(2017-)"}
        </tspan>
      </text>
    </g>
    <path d="M22740.5 1970.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M22740.5 1970.38h135v50h-135z" />
      <text fill="#000" transform="translate(22740.5 1970.38)">
        <tspan x={32.242} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Jade Kurtz"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1996-)"}
        </tspan>
      </text>
    </g>
    <path d="M22525.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M22525.5 1970.38h150v50h-150z" />
      <text fill="#000" transform="translate(22525.5 1970.38)">
        <tspan x={39.488} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Joel Taylor"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1993-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M22060.5 1665.38" />
    <path d="M22235.5 2120.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M22235.5 2120.38h120v50h-120z" />
      <text fill="#000" transform="translate(22235.5 2120.38)">
        <tspan x={11.852} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Sonia Annalina"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(2017-)"}
        </tspan>
      </text>
    </g>
    <path d="M22060.5 2120.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M22060.5 2120.38h150v50h-150z" />
      <text fill="#000" transform="translate(22060.5 2120.38)">
        <tspan x={12.754} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Savanna Antoinette"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(2009-)"}
        </tspan>
      </text>
    </g>
    <path d="M21885.5 2120.38h160v50h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M21885.5 2120.38h160v50h-160z" />
      <text fill="#000" transform="translate(21885.5 2120.38)">
        <tspan x={27.879} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={88.719} y={21.22}>
          {" Travis Da Peters"}
        </tspan>
        <tspan x={80} y={38.02}>
          {"(2003-)"}
        </tspan>
      </text>
    </g>
    <path d="M22355.5 1970.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M22355.5 1970.38h135v50h-135z" />
      <text fill="#000" transform="translate(22355.5 1970.38)">
        <tspan x={30.957} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Akira Coley"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1989-)"}
        </tspan>
      </text>
    </g>
    <path d="M22125.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M22125.5 1970.38h150v50h-150z" />
      <text fill="#000" transform="translate(22125.5 1970.38)">
        <tspan x={26.617} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Justin Anthony"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1987-)"}
        </tspan>
      </text>
    </g>
    <path d="M21910.5 1970.38h165v50h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M21910.5 1970.38h165v50h-165z" />
      <text fill="#000" transform="translate(21910.5 1970.38)">
        <tspan x={17.746} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={91.219} y={21.22}>
          {" Tiffany Nowakowski"}
        </tspan>
        <tspan x={82.5} y={38.02}>
          {"(1987-)"}
        </tspan>
      </text>
    </g>
    <path d="M21720.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M21720.5 1970.38h150v50h-150z" />
      <text fill="#000" transform="translate(21720.5 1970.38)">
        <tspan x={27.141} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Elena Veronica"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(2013-)"}
        </tspan>
      </text>
    </g>
    <path d="M21520.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M21520.5 1970.38h150v50h-150z" />
      <text fill="#000" transform="translate(21520.5 1970.38)">
        <tspan x={31.512} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Gabriel Lewis"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(2011-)"}
        </tspan>
      </text>
    </g>
    <path d="M21235.5 1970.38h170v50h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M21235.5 1970.38h170v50h-170z" />
      <text fill="#000" transform="translate(21235.5 1970.38)">
        <tspan x={14.723} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={93.719} y={21.22}>
          {" Evelyn Paloma Canela"}
        </tspan>
        <tspan x={85} y={38.02}>
          {"(2007-)"}
        </tspan>
      </text>
    </g>
    <path d="M21720.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M21720.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(21720.5 1820.38)">
        <tspan x={16.848} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Dena Marie Renzo"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1976-)"}
        </tspan>
      </text>
    </g>
    <path d="M21520.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M21520.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(21520.5 1820.38)">
        <tspan x={20.355} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Thomas Anthony"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1974-)"}
        </tspan>
      </text>
    </g>
    <path d="M21350.5 1820.38h114v50h-114z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M21350.5 1820.38h114v50h-114z" />
      <text fill="#000" transform="translate(21350.5 1820.38)">
        <tspan x={14.301} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={65.719} y={21.22}>
          {" Robin Canela"}
        </tspan>
        <tspan x={57} y={38.02}>
          {"(1973-)"}
        </tspan>
      </text>
    </g>
    <path d="M21189.5 1820.38h111v50h-111z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M21189.5 1820.38h111v50h-111z" />
      <text fill="#000" transform="translate(21189.5 1820.38)">
        <tspan x={19.242} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={64.219} y={21.22}>
          {" Paula Jean"}
        </tspan>
        <tspan x={55.5} y={38.02}>
          {"(1972-)"}
        </tspan>
      </text>
    </g>
    <path d="M23025.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M23025.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(23025.5 1820.38)">
        <tspan x={40.215} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Robin Rich"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1960-)"}
        </tspan>
      </text>
    </g>
    <path d="M22825.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M22825.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(22825.5 1820.38)">
        <tspan x={25.031} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Robert Anthony"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1962-)"}
        </tspan>
      </text>
    </g>
    <path d="M22325.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M22325.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(22325.5 1820.38)">
        <tspan x={17.906} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Patricia Anderson"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1962-)"}
        </tspan>
      </text>
    </g>
    <path d="M22125.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M22125.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(22125.5 1820.38)">
        <tspan x={24.672} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" James Anthony"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1959-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M22080.5 1665.38h-30 30" />
    <path d="M21865.5 1670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M21865.5 1670.38h150v50h-150z" />
      <text fill="#000" transform="translate(21865.5 1670.38)">
        <tspan x={14.41} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Janet Evelyn Lewis"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1940-)"}
        </tspan>
      </text>
    </g>
    <path d="M22285.5 1670.38h175v50h-175z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M22285.5 1670.38h175v50h-175z" />
      <text fill="#000" transform="translate(22285.5 1670.38)">
        <tspan x={17.301} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={96.219} y={21.22}>
          {" Barbara Ann Whelchel"}
        </tspan>
        <tspan x={87.5} y={38.02}>
          {"(1938-)"}
        </tspan>
      </text>
    </g>
    <path d="M22060.5 1670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M22060.5 1670.38h150v50h-150z" />
      <text fill="#000" transform="translate(22060.5 1670.38)">
        <tspan x={24.559} y={21.22} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22} fontSize={14}>
          {" Mauro Anthony"}
        </tspan>
        <tspan x={75} y={38.02} fontSize={14}>
          {"(1936-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M25485.5 1270.38v50h-240M24985.5 1270.38v50h240" />
    <path
      fill="none"
      d="M25235 1305.38q11 1 11 15M25225 1320.38q0-15 10-15M23265.5 1520.38v-100h2435v100M25185.5 1245.38h100M26730.5 1820.38v-50h-620v-75"
    />
    <path fill="none" d="M26360.5 1820.38v-50h-400v50" />
    <path d="M26680.5 1820.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26680.5 1820.38h100v50h-100z" />
      <text fill="#000" transform="translate(26680.5 1820.38)">
        <tspan x={18.621} y={21.22} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22} fontSize={14}>
          {" Kevin Eric"}
        </tspan>
        <tspan x={50} y={38.02} fontSize={14}>
          {"(1992-)"}
        </tspan>
      </text>
    </g>
    <path d="M26310.5 1820.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26310.5 1820.38h100v50h-100z" />
      <text fill="#000" transform="translate(26310.5 1820.38)">
        <tspan x={15.457} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Ryan Mark"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1990-)"}
        </tspan>
      </text>
    </g>
    <path d="M25885.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25885.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(25885.5 1820.38)">
        <tspan x={19.805} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Brandon Edmund"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1988-)"}
        </tspan>
      </text>
    </g>
    <path d="M25355.5 1970.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25355.5 1970.38h200v50h-200z" />
      <text fill="#000" transform="translate(25355.5 1970.38)">
        <tspan x={21.605} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Luca Reuben Finneburgh"}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(2017-)"}
        </tspan>
      </text>
    </g>
    <path d="M25105.5 1970.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25105.5 1970.38h200v50h-200z" />
      <text fill="#000" transform="translate(25105.5 1970.38)">
        <tspan x={19.75} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Gemma Rose Finneburgh"}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(2014-)"}
        </tspan>
      </text>
    </g>
    <path d="M25735.5 1820.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25735.5 1820.38h110v50h-110z" />
      <text fill="#000" transform="translate(25735.5 1820.38)">
        <tspan x={14.078} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" David Mauro"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1986-)"}
        </tspan>
      </text>
    </g>
    <path d="M25575.5 1820.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25575.5 1820.38h120v50h-120z" />
      <text fill="#000" transform="translate(25575.5 1820.38)">
        <tspan x={17.09} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Michael Evan"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1983-)"}
        </tspan>
      </text>
    </g>
    <path d="M25345.5 1830.38h205v30h-205z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25345.5 1830.38h205v30h-205z" />
      <text fill="#000" transform="translate(25345.5 1830.38)">
        <tspan x={16.73} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={111.219} y={19.62}>
          {" Noah Koloddny Finneburgh"}
        </tspan>
      </text>
    </g>
    <path d="M25185.5 1820.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25185.5 1820.38h100v50h-100z" />
      <text fill="#000" transform="translate(25185.5 1820.38)">
        <tspan x={10.883} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Sarah Maria"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1982-)"}
        </tspan>
      </text>
    </g>
    <path d="M25025.5 1820.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25025.5 1820.38h110v50h-110z" />
      <text fill="#000" transform="translate(25025.5 1820.38)">
        <tspan x={13.781} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Emma Marie"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1990-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M24885.5 1695.38h-75 75" />
    <path d="M24835.5 1830.38h155v30h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M24835.5 1830.38h155v30h-155z" />
      <text fill="#000" transform="translate(24835.5 1830.38)">
        <tspan x={14.184} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={86.219} y={19.62}>
          {" John Marshal Miller"}
        </tspan>
      </text>
    </g>
    <path d="M24675.5 1820.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M24675.5 1820.38h110v50h-110z" />
      <text fill="#000" transform="translate(24675.5 1820.38)">
        <tspan x={21.121} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Anna Ruth"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1988-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M26135.5 1695.38h-40 0-5" />
    <path d="M26135.5 1670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26135.5 1670.38h150v50h-150z" />
      <text fill="#000" transform="translate(26135.5 1670.38)">
        <tspan x={31.203} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDE8\uD83C\uDDE6"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Alvina Labate"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1957-)"}
        </tspan>
      </text>
    </g>
    <path d="M25940.5 1670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25940.5 1670.38h150v50h-150z" />
      <text fill="#000" transform="translate(25940.5 1670.38)">
        <tspan x={30.031} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Mark Edmund"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1957-)"}
        </tspan>
      </text>
    </g>
    <path d="M25535.5 1670.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25535.5 1670.38h200v50h-200z" />
      <text fill="#000" transform="translate(25535.5 1670.38)">
        <tspan x={24.16} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Geraldine Louse Pannor"}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(1955-)"}
        </tspan>
      </text>
    </g>
    <path d="M25335.5 1670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25335.5 1670.38h150v50h-150z" />
      <text fill="#000" transform="translate(25335.5 1670.38)">
        <tspan x={26.301} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Eric (Rick) Paul"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1955-)"}
        </tspan>
      </text>
    </g>
    <path d="M24935.5 1670.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M24935.5 1670.38h140v50h-140z" />
      <text fill="#000" transform="translate(24935.5 1670.38)">
        <tspan x={17.707} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Lisa Marie Hahn"}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(1955-)"}
        </tspan>
      </text>
    </g>
    <path d="M24775.5 1670.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M24775.5 1670.38h110v50h-110z" />
      <text fill="#000" transform="translate(24775.5 1670.38)">
        <tspan x={11.121} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Edward Frank"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1953-)"}
        </tspan>
      </text>
    </g>
    <path d="M25830.5 1520.38h180v50h-180z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25830.5 1520.38h180v50h-180z" />
      <text fill="#000" transform="translate(25830.5 1520.38)">
        <tspan x={18.332} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={98.719} y={21.22}>
          {" Mafalda Rufina Mulieri"}
        </tspan>
        <tspan x={90} y={38.02}>
          {"(1922-2010)"}
        </tspan>
      </text>
    </g>
    <path d="M25630.5 1520.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25630.5 1520.38h150v50h-150z" />
      <text fill="#000" transform="translate(25630.5 1520.38)">
        <tspan x={22.586} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Edmund Edward"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1916-2005)"}
        </tspan>
      </text>
    </g>
    <path d="M23365.5 1520.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M23365.5 1520.38h200v50h-200z" />
      <text fill="#000" transform="translate(23365.5 1520.38)">
        <tspan x={33.867} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Antoinette Falappino"}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(1911-1996)"}
        </tspan>
      </text>
    </g>
    <path d="M23215.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M23215.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(23215.5 1520.38)">
        <tspan x={27.738} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Mauro"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1908-1985)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M4015.5 670.38v-50h-1075v-40M1978 670.38v-50h962.5v-75M3198 1220.38v-125h7.5M3858 870.38v-100h452.5M28560.5 1395.38v75h-150v60"
    />
    <path d="M28320.5 1530.38h180v30h-180z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M28320.5 1530.38h180v30h-180z" />
      <text fill="#000" transform="translate(28320.5 1530.38)">
        <tspan x={30.281} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={98.719} y={19.62}>
          {" Giuseppe Pogliano"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M24475.5 1070.38v-100h290v-10M25720.5 1070.38v-100h-955v-75M28540.5 1395.38h40M29270.5 1370.38v-50h-435v-75"
    />
    <path fill="none" d="M28953 1370.38v-50h-117.5v-55" />
      <path strokeWidth={3} d="M28580.5 1370.38h145v50h-145z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28580.5 1370.38h145v50h-145z" />
        <text fill="#000" transform="translate(28580.5 1370.38)">
          <tspan x={18.652} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={81.219} y={21.22}>
            {" Camillo Pogliano"}
          </tspan>
          <tspan x={72.5} y={38.02}>
            {"(1900-)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M28488 1370.38v-50h347.5v-70M29108 1370.38v-50h-272.5v-75"
    />
    <path fill="none" d="M28803 1370.38v-50h32.5v-75" />
      <path strokeWidth={3} d="M29055.5 1370.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M29055.5 1370.38h105v50h-105z" />
        <text fill="#000" transform="translate(29055.5 1370.38)">
          <tspan x={26.574} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Antonio"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1903-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M28900.5 1370.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28900.5 1370.38h105v50h-105z" />
        <text fill="#000" transform="translate(28900.5 1370.38)">
          <tspan x={14.016} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Tommasina"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1901-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M28750.5 1370.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28750.5 1370.38h105v50h-105z" />
        <text fill="#000" transform="translate(28750.5 1370.38)">
          <tspan x={26.758} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Antonia"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1899-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M29215.5 1370.38h110v50h-110z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M29215.5 1370.38h110v50h-110z" />
        <text fill="#000" transform="translate(29215.5 1370.38)">
          <tspan x={32.008} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={63.719} y={21.22}>
            {" Sabina"}
          </tspan>
          <tspan x={55} y={38.02}>
            {"(1909-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M28435.5 1370.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28435.5 1370.38h105v50h-105z" />
        <text fill="#000" transform="translate(28435.5 1370.38)">
          <tspan
            x={31.305}
            y={21.22}
            fontFamily="Noto Color Emoji"
            fontSize={14}
          >
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22} fontSize={14}>
            {" Teresa"}
          </tspan>
          <tspan x={52.5} y={38.02} fontSize={14}>
            {"(1905-1983)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M10220.5 1070.38v-100h14280M26135.5 1220.38v-50h-480"
    />
    <path
      fill="none"
      d="M25850.5 1220.38v-50h-255v-75M25485.5 1220.38v-50h110v-35"
    />
    <path
      fill="none"
      d="M25335.5 1220.38v-50h260v-55M24985.5 1220.38v-50h-75"
    />
    <path fill="none" d="M25135.5 1220.38v-50h-565M18361.5 1220.38v-50h5819" />
    <path
      fill="none"
      d="M24175.5 1220.38v-50h400v-75M18411.5 1245.38h55M24035.5 1245.38h50M10815.5 1220.38v-50h-670v-75M10145.5 1220.38v-42.5h0v-42.5M9470.5 1220.38v-50h675v-55M9340.5 1245.38h80M6838 1220.38v-50h-32.5v-75M6415.5 1220.38v-50h390v-70M6765.5 1095.38h95M41215.5 1845.38h80v-5M41035.5 1695.38v37.5h0v37.5M41160.5 1770.38v25h0v25M40945.5 1770.38h215M41075.5 1690.38v5h-90M41280.5 1095.38h-67.5v25"
    />
    <path d="M40850.5 1670.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40850.5 1670.38h135v50h-135z" />
      <text fill="#000" transform="translate(40850.5 1670.38)">
        <tspan x={21.867} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Ilaria Beccaris"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1956)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(40830.5 1650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"155"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M41075.5 1670.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M41075.5 1670.38h145v50h-145z" />
      <text fill="#000" transform="translate(41075.5 1670.38)">
        <tspan x={45.691} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Pierluigi"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1953)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(41055.5 1650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"154"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M41295.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M41295.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(41295.5 1820.38)">
        <tspan x={25.41} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Fabio Cassiano"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1985)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(41275.5 1800.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"160"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M41095.5 1820.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M41095.5 1820.38h120v50h-120z" />
      <text fill="#000" transform="translate(41095.5 1820.38)">
        <tspan x={42.98} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Ilaria"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1985)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(41075.5 1800.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"159"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M40750.5 1970.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40750.5 1970.38h145v50h-145z" />
      <text fill="#000" transform="translate(40750.5 1970.38)">
        <tspan x={48.57} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Andrea"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(2018)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(40730.5 1950.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"158"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M40550.5 1820.38h215v50h-215z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40550.5 1820.38h215v50h-215z" />
      <text fill="#000" transform="translate(40550.5 1820.38)">
        <tspan x={29.441} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={116.219} y={21.22}>
          {" Sebastiana Michela Cilio"}
        </tspan>
        <tspan x={107.5} y={38.02}>
          {"(1982)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(40530.5 1800.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"157"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M40875.5 1820.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40875.5 1820.38h145v50h-145z" />
      <text fill="#000" transform="translate(40875.5 1820.38)">
        <tspan x={35.664} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Alessandro"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1980)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(40855.5 1800.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"156"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M41195.5 1520.38h160v50h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M41195.5 1520.38h160v50h-160z" />
      <text fill="#000" transform="translate(41195.5 1520.38)">
        <tspan x={23.461} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={88.719} y={21.22}>
          {" Vilma Cornacchia"}
        </tspan>
        <tspan x={80} y={38.02}>
          {"(1931-2019)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(41175.5 1500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"153"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M1673 1370.38v-25h0v-25" />
      <path strokeWidth={3} d="M1615.5 1370.38h115v50h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1615.5 1370.38h115v50h-115z" />
        <text fill="#000" transform="translate(1615.5 1370.38)">
          <tspan x={21.25} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={21.22}>
            {" Luigi Mario"}
          </tspan>
          <tspan x={57.5} y={38.02}>
            {"(1910-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M9375.5 1245.38v62.5h0v62.5" />
    <path d="M40345.5 1820.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40345.5 1820.38h135v50h-135z" />
      <text fill="#000" transform="translate(40345.5 1820.38)">
        <tspan x={42.207} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Claudio"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1991)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(40325.5 1800.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"151"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M40200.5 1670.38h175v50h-175z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40200.5 1670.38h175v50h-175z" />
      <text fill="#000" transform="translate(40200.5 1670.38)">
        <tspan x={23.953} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={96.219} y={21.22}>
          {" Gabriella Bortolato"}
        </tspan>
        <tspan x={87.5} y={38.02}>
          {"(1963)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(40180.5 1650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"150"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M40440.5 1670.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40440.5 1670.38h135v50h-135z" />
      <text fill="#000" transform="translate(40440.5 1670.38)">
        <tspan x={30.016} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Gian Marco"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1962)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(40420.5 1650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"149"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M40525.5 1520.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40525.5 1520.38h135v50h-135z" />
      <text fill="#000" transform="translate(40525.5 1520.38)">
        <tspan x={36.688} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Pia Zanin"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1935-2018)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M40395.5 1520.38v-65h0v-60" />
    <path d="M40335.5 1520.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40335.5 1520.38h135v50h-135z" />
      <text fill="#000" transform="translate(40335.5 1520.38)">
        <tspan x={26.066} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Enrico Pietro"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1932-2011)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(40315.5 1500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"148"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M40365.5 1395.38h60" />
    <path d="M40425.5 1370.38h175v50h-175z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40425.5 1370.38h175v50h-175z" />
      <text fill="#000" transform="translate(40425.5 1370.38)">
        <tspan x={21.746} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={96.219} y={21.22}>
          {" Antonia Del Messier "}
        </tspan>
        <tspan x={87.5} y={38.02}>
          {"(1911-1984)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(40405.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"147"}
          </tspan>
        </text>
      </g>
    </g>
    <path
      fill="none"
      d="M40935.5 1095.38h-30 0-40M40890 1245.38h-369.5 0-165M41390.5 1245.38H41221h0-310M40900 1230.38q11 1 11 15M40890 1245.38q0-15 10-15"
    />
    <path d="M40945.5 1520.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M40945.5 1520.38h145v50h-145z" />
      <text fill="#000" transform="translate(40945.5 1520.38)">
        <tspan x={49.656} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Tonino"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1924-2017)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(40925.5 1500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"146"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M40900.5 1370.38v-275h-10M40940.5 1395.38h115" />
    <path d="M41055.5 1370.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M41055.5 1370.38h145v50h-145z" />
      <text fill="#000" transform="translate(41055.5 1370.38)">
        <tspan x={23.188} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Anna Rampone"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1904-1993)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M40830.5 1370.38h110v50h-110z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M40830.5 1370.38h110v50h-110z" />
        <text fill="#000" transform="translate(40830.5 1370.38)">
          <tspan x={38.465} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={63.719} y={21.22}>
            {" Luigi"}
          </tspan>
          <tspan x={55} y={38.02}>
            {"(1900-1994)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(40810.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"145"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M40793 1070.38v-100h-312.5v-75" />
      <path strokeWidth={3} d="M40935.5 1070.38h135v50h-135z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M40935.5 1070.38h135v50h-135z" />
        <text fill="#000" transform="translate(40935.5 1070.38)">
          <tspan x={26.426} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={76.219} y={21.22}>
            {" Claudina Bre"}
          </tspan>
          <tspan x={67.5} y={38.02}>
            {"(1878-1948)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M40720.5 1070.38h145v50h-145z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M40720.5 1070.38h145v50h-145z" />
        <text fill="#000" transform="translate(40720.5 1070.38)">
          <tspan x={26.438} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={81.219} y={21.22}>
            {" Antonio Pietro"}
          </tspan>
          <tspan x={72.5} y={38.02}>
            {"(1876-1940)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(40700.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"144"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M370.5 1370.38v-50h-100v-50" />
    <path d="M320.5 1370.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M320.5 1370.38h100v50h-100z" />
      <text fill="#000" transform="translate(320.5 1370.38)">
        <tspan x={24.68} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Camillo"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1901-1971)"}
        </tspan>
      </text>
    </g>
    <g transform="translate(300.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"143"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(1595.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"110"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(13690.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"54"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M26590.5 870.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M26590.5 870.38h150v50h-150z" />
        <text fill="#000" transform="translate(26590.5 870.38)">
          <tspan x={57.547} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Rosa"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1818-1901)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M26990.5 870.38h145v50h-145z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M26990.5 870.38h145v50h-145z" />
        <text fill="#000" transform="translate(26990.5 870.38)">
          <tspan x={40.805} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={81.219} y={21.22}>
            {" Tommaso"}
          </tspan>
          <tspan x={72.5} y={38.02}>
            {"(1818-1894)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M26740.5 895.38h250M26665.5 870.38v-50h155" />
      <path strokeWidth={3} d="M27230.5 1070.38h140v50h-140z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M27230.5 1070.38h140v50h-140z" />
        <text fill="#000" transform="translate(27230.5 1070.38)">
          <tspan x={40.949} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={78.719} y={21.22}>
            {" Giovanni"}
          </tspan>
          <tspan x={70} y={38.02}>
            {"(1845-1899)"}
          </tspan>
        </text>
      </g>
    <path strokeDasharray="3 4" d="M27440.5 1070.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27440.5 1070.38h100v50h-100z" />
      <text fill="#000" transform="translate(27440.5 1070.38)">
        <tspan x={50} y={21.22}>
          {"See Emilia"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1851-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M27370.5 1095.38h70" />
      <path strokeWidth={3} d="M31055.5 870.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M31055.5 870.38h150v50h-150z" />
        <text fill="#000" transform="translate(31055.5 870.38)">
          <tspan x={42.727} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Ambrogio"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1823-1889)"}
          </tspan>
        </text>
      </g>
    <path d="M30810.5 880.38h165v30h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M30810.5 880.38h165v30h-165z" />
      <text fill="#000" transform="translate(30810.5 880.38)">
        <tspan x={17.531} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={91.219} y={19.62}>
          {" Archangela Mazzola"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M31055.5 895.38h-42.5 0-37.5M30920.5 1070.38v-100h182.5v100"
    />
      <path strokeWidth={3} d="M31680.5 870.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M31680.5 870.38h150v50h-150z" />
        <text fill="#000" transform="translate(31680.5 870.38)">
          <tspan x={55.395} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Paolo"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1817-1885)"}
          </tspan>
        </text>
      </g>
    <path d="M31930.5 880.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M31930.5 880.38h150v30h-150z" />
      <text fill="#000" transform="translate(31930.5 880.38)">
        <tspan x={23.305} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Rosa Valenzano"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M31830.5 895.38h100" />
      <path strokeWidth={3} d="M31660.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M31660.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(31660.5 1070.38)">
          <tspan x={54.242} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Emilia"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1851-)"}
          </tspan>
        </text>
      </g>
    <path strokeDasharray="3 4" d="M31430.5 1070.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M31430.5 1070.38h100v50h-100z" />
      <text fill="#000" transform="translate(31430.5 1070.38)">
        <tspan x={50} y={21.22}>
          {"See Giovanni"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1845-1899)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M31530.5 1095.38h130" />
      <path strokeWidth={3} d="M31525.5 1220.38h155v50h-155z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M31525.5 1220.38h155v50h-155z" />
        <text fill="#000" transform="translate(31525.5 1220.38)">
          <tspan x={26.34} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={86.219} y={21.22}>
            {" Ettore Giuseppe"}
          </tspan>
          <tspan x={77.5} y={38.02}>
            {"(1884-1966)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M31735.5 1220.38h140v50h-140z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M31735.5 1220.38h140v50h-140z" />
        <text fill="#000" transform="translate(31735.5 1220.38)">
          <tspan x={12.973} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={78.719} y={21.22}>
            {" Carolina Casalone"}
          </tspan>
          <tspan x={70} y={38.02}>
            {"(1886-1954)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M31680.5 1245.38h55M31603 1220.38v-125h2.5" />
    <g transform="translate(31505.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"161"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M31630.5 1370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M31630.5 1370.38h150v50h-150z" />
        <text fill="#000" transform="translate(31630.5 1370.38)">
          <tspan x={50.555} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Vittorio"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1912-1993)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M31705.5 1370.38v-62.5h0v-62.5" />
      <path strokeWidth={3} d="M31280.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M31280.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(31280.5 670.38)">
          <tspan x={54.863} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Pietro"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1781-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M31505.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M31505.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(31505.5 670.38)">
          <tspan x={25.133} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Orsula Luparia"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1789-1850)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M31430.5 695.38h75M31130.5 870.38v-50h340v-20M31755.5 870.38v-50h-285v-125M31460.5 770.38q0-10 10-10"
    />
    <path fill="none" d="M31480.5 770.38q0-10-10-10M31460.5 770.38h-1040" />
      <path strokeWidth={3} d="M31160.5 520.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M31160.5 520.38h150v50h-150z" />
        <text fill="#000" transform="translate(31160.5 520.38)">
          <tspan x={50.309} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Joseph"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1757-)"}
          </tspan>
        </text>
      </g>
    <path d="M31390.5 530.38h140v30h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M31390.5 530.38h140v30h-140z" />
      <text fill="#000" transform="translate(31390.5 530.38)">
        <tspan x={20.699} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={19.62}>
          {" Vittoria Guazzo"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M31355.5 670.38v-62.5h0v-62.5" />
    <path d="M31290.5 380.38h140v30h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M31290.5 380.38h140v30h-140z" />
      <text fill="#000" fontSize={14} transform="translate(31290.5 380.38)">
        <tspan x={28.473} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={19.62}>
          {" Teresie Cajo"}
        </tspan>
      </text>
    </g>
    <path d="M31040.5 380.38h140v30h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M31040.5 380.38h140v30h-140z" />
      <text fill="#000" transform="translate(31040.5 380.38)">
        <tspan x={53.832} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={19.62}>
          {" Petri"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M31180.5 395.38h110M31235.5 520.38v-62.5h0v-62.5" />
      <path strokeWidth={3} d="M28550.5 1070.38h115v50h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28550.5 1070.38h115v50h-115z" />
        <text fill="#000" transform="translate(28550.5 1070.38)">
          <tspan x={34.969} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={21.22}>
            {" Sabina"}
          </tspan>
          <tspan x={57.5} y={38.02}>
            {"(1844-1926)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M28665.5 1095.38h40M28860.5 1095.38h50M28690.5 1220.38v-125h-17.692"
    />
      <path strokeWidth={3} d="M28210.5 870.38h115v50h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28210.5 870.38h115v50h-115z" />
        <text fill="#000" transform="translate(28210.5 870.38)">
          <tspan x={40.047} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={21.22}>
            {" Rosa"}
          </tspan>
          <tspan x={57.5} y={38.02}>
            {"(1814-1889)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M28390.5 870.38h115v50h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28390.5 870.38h115v50h-115z" />
        <text fill="#000" transform="translate(28390.5 870.38)">
          <tspan x={37.895} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={21.22}>
            {" Paolo"}
          </tspan>
          <tspan x={57.5} y={38.02}>
            {"(1813-1887)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M28325.5 895.38h65M28608 1070.38v-50h-630v50" />
      <path strokeWidth={3} d="M27250.5 670.38h155v50h-155z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M27250.5 670.38h155v50h-155z" />
        <text fill="#000" transform="translate(27250.5 670.38)">
          <tspan x={20.164} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={86.219} y={21.22}>
            {" Giovanni Battista"}
          </tspan>
          <tspan x={77.5} y={38.02}>
            {"(1792-1850)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M27490.5 670.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M27490.5 670.38h130v50h-130z" />
        <text fill="#000" transform="translate(27490.5 670.38)">
          <tspan x={24.684} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Luigia Testa"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1794-1845)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M27140.5 520.38h145v50h-145z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M27140.5 520.38h145v50h-145z" />
        <text fill="#000" transform="translate(27140.5 520.38)">
          <tspan x={32.867} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={81.219} y={21.22}>
            {" Petri Thome"}
          </tspan>
          <tspan x={72.5} y={38.02}>
            {"(1769-after 1804)"}
          </tspan>
        </text>
      </g>
    <path d="M27050.5 380.38h105v30h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27050.5 380.38h105v30h-105z" />
      <text fill="#000" transform="translate(27050.5 380.38)">
        <tspan x={26.113} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={61.219} y={19.62}>
          {" Josephi"}
        </tspan>
      </text>
    </g>
    <path d="M27345.5 530.38h180v30h-180z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27345.5 530.38h180v30h-180z" />
      <text fill="#000" transform="translate(27345.5 530.38)">
        <tspan x={17.531} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={98.719} y={19.62}>
          {" Catherine De Magistris"}
        </tspan>
      </text>
    </g>
    <path d="M27255.5 380.38h157.5v30h-157.5z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27255.5 380.38h157.5v30h-157.5z" />
      <text fill="#000" transform="translate(27255.5 380.38)">
        <tspan x={22.121} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={87.469} y={19.62}>
          {" Francisca Mariae"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M27405.5 695.38h85M27320.5 670.38v-60h0v-65M27285.5 545.38h60M27155.5 395.38h100M27205.5 520.38v-125h50"
    />
      <path strokeWidth={3} d="M28250.5 520.38h165v50h-165z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28250.5 520.38h165v50h-165z" />
        <text fill="#000" fontSize={14} transform="translate(28250.5 520.38)">
          <tspan x={38.121} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={91.219} y={21.22}>
            {" Josephi Maria"}
          </tspan>
          <tspan x={82.5} y={38.02}>
            {"(1757-)"}
          </tspan>
        </text>
      </g>
    <path d="M28465.5 530.38h130v30h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M28465.5 530.38h130v30h-130z" />
      <text fill="#000" transform="translate(28465.5 530.38)">
        <tspan x={18.945} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={73.719} y={19.62}>
          {" Angela Bilione"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M28415.5 545.38h50M27450.5 695.38v75h0v75M28445.5 545.38v15h0v310M28435.5 820.38q0-10 10-10M28455.5 820.38q0-10-10-10M28435.5 770.38q0-10 10-10M28455.5 770.38q0-10-10-10M28435.5 732.88q0-10 10-10M28455.5 732.88q0-10-10-10M27440.5 732.88q0-10 10-10M27460.5 732.88q0-10-10-10M27440.5 770.38q0-10 10-10M27460.5 770.38q0-10-10-10M27440.5 820.38q0-10 10-10M27460.5 820.38q0-10-10-10M26485.5 720.38v12.5h955v-2.5M27460.5 732.88h975M28455.5 732.88h1080M29535.5 720.38v12.5"
    />
    <path
      fill="none"
      d="M26200.5 720.38v50h1240M27460.5 770.38h975M28455.5 770.38h545M28780.5 820.38h-325M28435.5 820.38h-975M27440.5 820.38h-2570M24870.5 870.38v-50"
    />
      <path strokeWidth={3} d="M5600.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M5600.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(5600.5 1070.38)">
          <tspan x={23.625} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Pietro Bonifacio"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1855-1911)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(5575.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"162"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M5800.5 1070.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M5800.5 1070.38h125v50h-125z" />
        <text fill="#000" transform="translate(5800.5 1070.38)">
          <tspan x={14.977} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Luigia Macario"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1857-1940)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M5920.5 1220.38h115v50h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M5920.5 1220.38h115v50h-115z" />
        <text fill="#000" transform="translate(5920.5 1220.38)">
          <tspan x={34.109} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={21.22}>
            {" Marina"}
          </tspan>
          <tspan x={57.5} y={38.02}>
            {"(1882-1966)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M6350.5 1245.38H6328h0-12.5" />
    <path strokeDasharray="4 5" d="M6060.5 1220.38h95v50h-95z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M6060.5 1220.38h95v50h-95z" />
      <text fill="#000" transform="translate(6060.5 1220.38)">
        <tspan x={47.5} y={21.22}>
          {"See Umberto"}
        </tspan>
        <tspan x={47.5} y={38.02}>
          {"(1881-1959)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M5800.5 1095.38h-25 0-25M6038 1245.38h22.5" />
    <g transform="translate(5905.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"163"}
          </tspan>
        </text>
      </g>
    </g>
    <path fill="none" d="M5675.5 1070.38v-25h0v-25" />
      <path strokeWidth={3} d="M39445.5 1070.38h145v50h-145z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M39445.5 1070.38h145v50h-145z" />
        <text fill="#000" transform="translate(39445.5 1070.38)">
          <tspan x={43.707} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={81.219} y={21.22}>
            {" Umberto"}
          </tspan>
          <tspan x={72.5} y={38.02}>
            {"(1881-1959)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(39425.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"164"}
          </tspan>
        </text>
      </g>
    </g>
    <path strokeDasharray="2 3" d="M39640.5 1070.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M39640.5 1070.38h110v50h-110z" />
      <text fill="#000" transform="translate(39640.5 1070.38)">
        <tspan x={55} y={21.22}>
          {"See  Marina "}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1882-1966)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M39590.5 1095.38h50" />
      <path strokeWidth={3} d="M39270.5 1070.38h110v50h-110z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M39270.5 1070.38h110v50h-110z" />
        <text fill="#000" transform="translate(39270.5 1070.38)">
          <tspan x={15.262} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={63.719} y={21.22}>
            {" Pietro Paolo"}
          </tspan>
          <tspan x={55} y={38.02}>
            {"(1876-1958)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M39325.5 1070.38v-100h215v-2.5M39515.5 1070.38v-50h0v-50"
    />
      <path strokeWidth={3} d="M45770.5 1070.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M45770.5 1070.38h100v50h-100z" />
        <text fill="#000" transform="translate(45770.5 1070.38)">
          <tspan x={29.863} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Pietro"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1877-1949)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M45915.5 1070.38h155v50h-155z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M45915.5 1070.38h155v50h-155z" />
        <text fill="#000" transform="translate(45915.5 1070.38)">
          <tspan x={13.5} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={86.219} y={21.22}>
            {" Maddalena Bossotti"}
          </tspan>
          <tspan x={77.5} y={38.02}>
            {"(1884-1974)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M45870.5 1095.38h45M45820.5 1070.38v-50h0v-50" />
      <path strokeWidth={3} d="M45730.5 1370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M45730.5 1370.38h150v50h-150z" />
        <text fill="#000" transform="translate(45730.5 1370.38)">
          <tspan x={23.402} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Mauro Giacomo"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1906-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M45920.5 1370.38h205v50h-205z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M45920.5 1370.38h205v50h-205z" />
        <text fill="#000" transform="translate(45920.5 1370.38)">
          <tspan x={22.57} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={111.219} y={21.22}>
            {" Luigia Adelaide Prassede"}
          </tspan>
          <tspan x={102.5} y={38.02}>
            {"(1906-)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(45900.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"165"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M46180.5 1370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M46180.5 1370.38h150v50h-150z" />
        <text fill="#000" transform="translate(46180.5 1370.38)">
          <tspan x={19.234} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Angelo Piccaluga"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1906-1993)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M45805.5 1370.38v-150h90v-125M46023 1370.38v-150h-127.5v-100M46125.5 1395.38h55M53805.5 1670.38v-50h65v-75"
    />
      <path strokeWidth={3} d="M31915.5 1070.38h165v50h-165z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M31915.5 1070.38h165v50h-165z" />
        <text fill="#000" transform="translate(31915.5 1070.38)">
          <tspan x={21.172} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={91.219} y={21.22}>
            {" Carolina Francesca"}
          </tspan>
          <tspan x={82.5} y={38.02}>
            {"(1859-1944)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M31735.5 1070.38v-100h145v-75M31998 1070.38v-100h-117.5v-75"
    />
      <path strokeWidth={3} d="M32180.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M32180.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(32180.5 1070.38)">
          <tspan x={37.879} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Maggiorino"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1852-1935)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M32080.5 1095.38h100" />
      <path strokeWidth={3} d="M32590.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M32590.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(32590.5 1070.38)">
          <tspan x={48.363} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Lorenzo"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1850-1910)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M32840.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M32840.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(32840.5 1070.38)">
          <tspan x={23.758} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Teresa Maiocco"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1854-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M32740.5 1095.38h100" />
      <path strokeWidth={3} d="M32435.5 870.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M32435.5 870.38h150v50h-150z" />
        <text fill="#000" transform="translate(32435.5 870.38)">
          <tspan x={26.484} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Angela Capello"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1826-1900)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M32330.5 895.38h105" />
      <path strokeWidth={3} d="M32180.5 870.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M32180.5 870.38h150v50h-150z" />
        <text fill="#000" transform="translate(32180.5 870.38)">
          <tspan x={44.059} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Giuseppe"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1821-1892)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M32255.5 1070.38v-100h125v-75M32665.5 1070.38v-100h-285v-75M31480.5 770.38h1975v100"
    />
      <path strokeWidth={3} d="M32540.5 1220.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M32540.5 1220.38h130v50h-130z" />
        <text fill="#000" transform="translate(32540.5 1220.38)">
          <tspan x={35.879} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Riccardo"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1882-1942)"}
          </tspan>
        </text>
      </g>
    <path d="M32735.5 1220.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M32735.5 1220.38h120v50h-120z" />
      <text fill="#000" transform="translate(32735.5 1220.38)">
        <tspan x={32.664} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Beatrice"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1888-1931)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M32670.5 1245.38h65M32545.5 1520.38" />
      <path strokeWidth={3} d="M31920.5 1220.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M31920.5 1220.38h100v50h-100z" />
        <text fill="#000" transform="translate(31920.5 1220.38)">
          <tspan x={24.789} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Santina"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1879-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M32050.5 1220.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M32050.5 1220.38h125v50h-125z" />
        <text fill="#000" transform="translate(32050.5 1220.38)">
          <tspan x={23.738} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Baldassarre"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1889-1973)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M32350.5 1220.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M32350.5 1220.38h100v50h-100z" />
        <text fill="#000" transform="translate(32350.5 1220.38)">
          <tspan x={26.984} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Rosina"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1882-1974)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M32210.5 1220.38h115v50h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M32210.5 1220.38h115v50h-115z" />
        <text fill="#000" transform="translate(32210.5 1220.38)">
          <tspan x={12.465} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={21.22}>
            {" Luigia Zanello"}
          </tspan>
          <tspan x={57.5} y={38.02}>
            {"(1890-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M31970.5 1220.38v-50h160v-75" />
    <path fill="none" d="M32113 1220.38v-50h17.5v-35" />
    <path fill="none" d="M32400.5 1220.38v-50h-280M32175.5 1245.38h35" />
      <path strokeWidth={3} d="M32075.5 1370.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M32075.5 1370.38h105v50h-105z" />
        <text fill="#000" transform="translate(32075.5 1370.38)">
          <tspan x={30.59} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Ermite"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1910-2003)"}
          </tspan>
        </text>
      </g>
    <path d="M31880.5 1380.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M31880.5 1380.38h125v30h-125z" />
      <text fill="#000" transform="translate(31880.5 1380.38)">
        <tspan x={16.449} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Maria Rissone"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M32230.5 1370.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M32230.5 1370.38h105v50h-105z" />
        <text fill="#000" transform="translate(32230.5 1370.38)">
          <tspan x={28.754} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Evelina"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1920-2014)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M32005.5 1395.38h70M32283 1370.38v-50h-87.5v-10" />
    <path d="M31925.5 1520.38h105v50h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M31925.5 1520.38h105v50h-105z" />
      <text fill="#000" transform="translate(31925.5 1520.38)">
        <tspan x={31.09} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={61.219} y={21.22}>
          {" Ivelise"}
        </tspan>
        <tspan x={52.5} y={38.02}>
          {"(1949-)"}
        </tspan>
      </text>
    </g>
    <path d="M32080.5 1520.38h105v50h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M32080.5 1520.38h105v50h-105z" />
      <text fill="#000" transform="translate(32080.5 1520.38)">
        <tspan x={31.91} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={61.219} y={21.22}>
          {" Eliana"}
        </tspan>
        <tspan x={52.5} y={38.02}>
          {"(1954-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M31978 1520.38v-50h62.5v-75M32133 1520.38v-50h-92.5v-35"
    />
    <path d="M32650.5 1370.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M32650.5 1370.38h115v50h-115z" />
      <text fill="#000" transform="translate(32650.5 1370.38)">
        <tspan x={29.859} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Edoardo"}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(1909-1966)"}
        </tspan>
      </text>
    </g>
    <path d="M32385.5 1370.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M32385.5 1370.38h200v50h-200z" />
      <text fill="#000" transform="translate(32385.5 1370.38)">
        <tspan x={24.543} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Evelyn (Tootie) May Lee"}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(1915-2007)"}
        </tspan>
      </text>
    </g>
    <path d="M32545.5 1520.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M32545.5 1520.38h150v50h-150z" />
      <text fill="#000" transform="translate(32545.5 1520.38)">
        <tspan x={24.746} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Edward Charles"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1941-2004)"}
        </tspan>
      </text>
    </g>
    <path d="M32300.5 1520.38h165v50h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M32300.5 1520.38h165v50h-165z" />
      <text fill="#000" transform="translate(32300.5 1520.38)">
        <tspan x={28.707} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={91.219} y={21.22}>
          {" Janice Mckinney"}
        </tspan>
        <tspan x={82.5} y={38.02}>
          {"(1942-2002)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M32465.5 1545.38h80M32625.5 1395.38h-5v125" />
    <path d="M32305.5 1670.38h105v50h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M32305.5 1670.38h105v50h-105z" />
      <text fill="#000" transform="translate(32305.5 1670.38)">
        <tspan x={16.613} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={21.22}>
          {" Karen Lynn"}
        </tspan>
        <tspan x={52.5} y={38.02}>
          {"(1964-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M32358 1670.38v-50h295v50M32128 1370.38v-50h67.5v-75M32585.5 1395.38h65"
    />
      <path strokeWidth={3} d="M33100.5 1070.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M33100.5 1070.38h130v50h-130z" />
        <text fill="#000" transform="translate(33100.5 1070.38)">
          <tspan x={37.867} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {"Annibale"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1847-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M33330.5 1070.38h180v50h-180z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M33330.5 1070.38h180v50h-180z" />
        <text fill="#000" transform="translate(33330.5 1070.38)">
          <tspan x={19.969} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={98.719} y={21.22}>
            {" Marcellina Germanino"}
          </tspan>
          <tspan x={90} y={38.02}>
            {"(1852-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M33165.5 1070.38v-100h-700" />
      <path strokeWidth={3} d="M33110.5 1220.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M33110.5 1220.38h105v50h-105z" />
        <text fill="#000" transform="translate(33110.5 1220.38)">
          <tspan x={29.195} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Angela"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1875-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M33260.5 1220.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M33260.5 1220.38h105v50h-105z" />
        <text fill="#000" transform="translate(33260.5 1220.38)">
          <tspan x={26.879} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Aristide"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1878-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M33410.5 1220.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M33410.5 1220.38h105v50h-105z" />
        <text fill="#000" transform="translate(33410.5 1220.38)">
          <tspan x={25.293} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Remigio"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1881-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M33230.5 1095.38h100" />
      <path strokeWidth={3} d="M33560.5 1220.38h105v50h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M33560.5 1220.38h105v50h-105z" />
        <text fill="#000" transform="translate(33560.5 1220.38)">
          <tspan x={35.965} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={21.22}>
            {" Luigi"}
          </tspan>
          <tspan x={52.5} y={38.02}>
            {"(1884-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M33163 1220.38v-50h117.5v-75M33313 1220.38v-50h-2.5" />
    <path fill="none" d="M33463 1220.38v-50h-182.5v-40" />
    <path
      fill="none"
      d="M33613 1220.38v-50h-155M28253 845.38h182.5M28435.5 845.38q0-10 10-10M28455.5 845.38q0-10-10-10M28770.5 845.38q0-10 10-10M28790.5 845.38q0-10-10-10M29240.5 845.38q0-10 10-10M29260.5 845.38q0-10-10-10M29945.5 845.38q0-10 10-10M29965.5 845.38q0-10-10-10M30485.5 845.38q0-10 10-10M30505.5 845.38q0-10-10-10M31120.5 845.38q0-10 10-10M31140.5 845.38q0-10-10-10M31745.5 845.38q0-10 10-10M31765.5 845.38q0-10-10-10M28455.5 845.38h315M29261.5 845.38h684M29965.5 845.38h520M30505.5 845.38h615M31140.5 845.38h605M31765.5 845.38h490M32255.5 870.38v-12.5h0v-12.5"
    />
    <path d="M41560.5 1370.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M41560.5 1370.38h120v50h-120z" />
      <text fill="#000" transform="translate(41560.5 1370.38)">
        <tspan x={38.699} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Enrico"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1920-2007)"}
        </tspan>
      </text>
    </g>
    <path d="M41775.5 1370.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M41775.5 1370.38h100v50h-100z" />
      <text fill="#000" transform="translate(41775.5 1370.38)">
        <tspan x={30.637} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Adele"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1921-2015)"}
        </tspan>
      </text>
    </g>
    <path d="M41925.5 1370.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M41925.5 1370.38h120v50h-120z" />
      <text fill="#000" transform="translate(41925.5 1370.38)">
        <tspan x={10.852} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Michele Bignoli"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1915-2000)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M41875.5 1395.38h50" />
    <path d="M42105.5 1370.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42105.5 1370.38h100v50h-100z" />
      <text fill="#000" transform="translate(42105.5 1370.38)">
        <tspan x={30.473} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Maria"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1924-2015)"}
        </tspan>
      </text>
    </g>
    <path d="M42255.5 1370.38h130v50h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42255.5 1370.38h130v50h-130z" />
      <text fill="#000" transform="translate(42255.5 1370.38)">
        <tspan x={15.008} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={73.719} y={21.22}>
          {" Giglio Signorelli"}
        </tspan>
        <tspan x={65} y={38.02}>
          {"(1922-1968)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M42205.5 1395.38h50" />
    <path d="M42610.5 1370.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42610.5 1370.38h100v50h-100z" />
      <text fill="#000" transform="translate(42610.5 1370.38)">
        <tspan x={26.07} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Andrea"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1927-2001)"}
        </tspan>
      </text>
    </g>
    <path d="M42760.5 1370.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42760.5 1370.38h150v50h-150z" />
      <text fill="#000" transform="translate(42760.5 1370.38)">
        <tspan x={11.973} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Giuliana Spagnolini "}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1930-2007)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M42710.5 1395.38h50" />
    <path d="M43180.5 1370.38h160v50h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43180.5 1370.38h160v50h-160z" />
      <text fill="#000" transform="translate(43180.5 1370.38)">
        <tspan x={18.426} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={88.719} y={21.22}>
          {" Catterina Marchetti"}
        </tspan>
        <tspan x={80} y={38.02}>
          {"(1930-)"}
        </tspan>
      </text>
    </g>
    <path d="M43020.5 1370.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43020.5 1370.38h120v50h-120z" />
      <text fill="#000" transform="translate(43020.5 1370.38)">
        <tspan x={34.023} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Stefano"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1929-2009)"}
        </tspan>
      </text>
    </g>
    <path d="M44390.5 1370.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44390.5 1370.38h120v50h-120z" />
      <text fill="#000" transform="translate(44390.5 1370.38)">
        <tspan x={25.945} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Francesco"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1933-)"}
        </tspan>
      </text>
    </g>
    <path d="M44560.5 1370.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44560.5 1370.38h100v50h-100z" />
      <text fill="#000" transform="translate(44560.5 1370.38)">
        <tspan x={27.426} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Teresa"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1935-)"}
        </tspan>
      </text>
    </g>
    <path d="M44710.5 1370.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44710.5 1370.38h120v50h-120z" />
      <text fill="#000" transform="translate(44710.5 1370.38)">
        <tspan x={11.625} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Franco Galbani"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1934-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M44660.5 1395.38h50" />
    <path d="M44910.5 1370.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44910.5 1370.38h100v50h-100z" />
      <text fill="#000" transform="translate(44910.5 1370.38)">
        <tspan x={34.059} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Aldo"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1938-)"}
        </tspan>
      </text>
    </g>
    <path d="M45068 1370.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M45068 1370.38h145v50h-145z" />
      <text fill="#000" transform="translate(45068 1370.38)">
        <tspan x={11.852} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Gabriella Proverbio"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1942-2014)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M44185.5 1395.38h40" />
    <path d="M44225.5 1370.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44225.5 1370.38h140v50h-140z" />
      <text fill="#000" transform="translate(44225.5 1370.38)">
        <tspan x={22.918} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Franca Beretta"}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(1936-)"}
        </tspan>
      </text>
    </g>
    <path d="M44075.5 1370.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44075.5 1370.38h110v50h-110z" />
      <text fill="#000" transform="translate(44075.5 1370.38)">
        <tspan x={36.844} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Carlo"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1930-2016)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M43320.5 695.38h75M41920.5 670.38v-50h1130M44530.5 870.38v-50h0v-50M43360.5 770.38v-40h0v-35M42695.5 870.38v-50h0v-50M41620.5 1370.38v-150h3340v150M41825.5 1370.38v-75h0v-75M42155.5 1370.38v-75h0v-75M42660.5 1370.38v-75h0v-75M43080.5 1370.38v-75h0v-75"
    />
    <path
      fill="none"
      d="M44130.5 1370.38v-150h-30M44450.5 1370.38v-75h0v-75M44610.5 1370.38v-75h0v-75M43140.5 1095.38v62.5h0v62.5"
    />
    <path d="M41765.5 1520.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M41765.5 1520.38h110v50h-110z" />
      <text fill="#000" transform="translate(41765.5 1520.38)">
        <tspan x={14.199} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Anna Bignoli"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1957-)"}
        </tspan>
      </text>
    </g>
    <path d="M41925.5 1520.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M41925.5 1520.38h115v50h-115z" />
      <text fill="#000" transform="translate(41925.5 1520.38)">
        <tspan x={11.008} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Aurelio Bignoli"}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(1960-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M41825.5 1520.38v-50h157.5v50M41900.5 1470.38v-37.5h0v-37.5"
    />
    <path d="M42170.5 1520.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42170.5 1520.38h125v50h-125z" />
      <text fill="#000" transform="translate(42170.5 1520.38)">
        <tspan x={12.816} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Laura Signorelli"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1953-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M42230.5 1395.38v62.5h0v62.5" />
    <path d="M42685.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42685.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(42685.5 1520.38)">
        <tspan x={33.32} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Luca"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1964-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M42735.5 1520.38v-62.5h0v-62.5" />
    <path d="M43690.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43690.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(43690.5 1520.38)">
        <tspan x={26.695} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Angela"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1970-)"}
        </tspan>
      </text>
    </g>
    <path d="M43410.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43410.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(43410.5 1520.38)">
        <tspan x={25.555} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Vittorio"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1968-)"}
        </tspan>
      </text>
    </g>
    <path d="M43110.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43110.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(43110.5 1520.38)">
        <tspan x={25.613} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Alberto"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1964-)"}
        </tspan>
      </text>
    </g>
    <path d="M42808 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42808 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(42808 1520.38)">
        <tspan x={30.395} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Paolo"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1962-)"}
        </tspan>
      </text>
    </g>
    <path d="M44223 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44223 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(44223 1520.38)">
        <tspan x={30.348} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Diego"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1966-)"}
        </tspan>
      </text>
    </g>
    <path d="M44073 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44073 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(44073 1520.38)">
        <tspan x={32.164} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Clara"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1963-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M44123 1520.38v-50h150v50M44205.5 1470.38v-37.5h0v-37.5M45010.5 1395.38h52.5"
    />
    <path d="M44980.5 1520.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44980.5 1520.38h125v50h-125z" />
      <text fill="#000" transform="translate(44980.5 1520.38)">
        <tspan x={33.781} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Marcello"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1969-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M45068 1395.38h-27.5v125" />
      <path strokeWidth={3} d="M42190.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M42190.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(42190.5 670.38)">
          <tspan x={27.641} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Maria Caterina"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1818-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M42560.5 670.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M42560.5 670.38h150v50h-150z" />
        <text fill="#000" transform="translate(42560.5 670.38)">
          <tspan x={15.391} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Francesca Antonia"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1822-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M42265.5 670.38v-25h0v-25M42635.5 670.38v-25h0v-25" />
      <path strokeWidth={3} d="M42780.5 1070.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M42780.5 1070.38h100v50h-100z" />
        <text fill="#000" transform="translate(42780.5 1070.38)">
          <tspan x={29.656} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Luigia"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1879-1961)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M42525.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M42525.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(42525.5 1070.38)">
          <tspan x={49.023} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Stefano"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1877-1932)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M42600.5 1070.38v-100h441.25v100M42830.5 970.38v-37.5h0v-37.5M42830.5 1070.38v-52.5h0v-52.5"
    />
      <path strokeWidth={3} d="M44755.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M44755.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(44755.5 1070.38)">
          <tspan
            x={17.906}
            y={21.22}
            fontFamily="Noto Color Emoji"
            fontSize={14}
          >
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22} fontSize={14}>
            {" Celestina Carolina"}
          </tspan>
          <tspan x={75} y={38.02} fontSize={14}>
            {"(1891-1976)"}
          </tspan>
        </text>
      </g>
    <path d="M44565.5 1080.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44565.5 1080.38h150v30h-150z" />
      <text fill="#000" transform="translate(44565.5 1080.38)">
        <tspan x={19.418} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Giuseppe Groppo"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M44825.5 1070.38v-100h-170v-75" />
      <path strokeWidth={3} d="M41990.5 870.38h145v50h-145z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M41990.5 870.38h145v50h-145z" />
        <text fill="#000" transform="translate(41990.5 870.38)">
          <tspan x={28.926} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={81.219} y={21.22}>
            {" Anna Antonia"}
          </tspan>
          <tspan x={72.5} y={38.02}>
            {"(1860-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M42210.5 870.38h190v50h-190z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M42210.5 870.38h190v50h-190z" />
        <text fill="#000" fontSize={14} transform="translate(42210.5 870.38)">
          <tspan x={33.094} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={103.719} y={21.22}>
            {" Francesco Piccinino"}
          </tspan>
          <tspan x={95} y={38.02}>
            {"(1852-1925)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M42135.5 895.38h75M42063 870.38v-100h-17.5" />
    <path d="M44380.5 1520.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44380.5 1520.38h110v50h-110z" />
      <text fill="#000" transform="translate(44380.5 1520.38)">
        <tspan x={10.922} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Angela Leone"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1969-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M44323 1545.38h57.5" />
    <path d="M44228 1670.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44228 1670.38h100v50h-100z" />
      <text fill="#000" transform="translate(44228 1670.38)">
        <tspan x={19.238} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Valentina"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(2003-)"}
        </tspan>
      </text>
    </g>
    <path d="M44390.5 1670.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44390.5 1670.38h110v50h-110z" />
      <text fill="#000" transform="translate(44390.5 1670.38)">
        <tspan x={27.359} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Edoardo"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(2006-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M44278 1670.38v-50h162.5v50M44355.5 1620.38v-37.5h0v-37.5"
    />
    <path d="M43545.5 1520.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43545.5 1520.38h125v50h-125z" />
      <text fill="#000" transform="translate(43545.5 1520.38)">
        <tspan x={11.148} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEF\uD83C\uDDF5"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Ayumi Moriwaki"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1975-)"}
        </tspan>
      </text>
    </g>
    <path d="M42950.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42950.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(42950.5 1520.38)">
        <tspan x={30.582} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Paola"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1964-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M42908 1545.38h42.5M43510.5 1545.38h35" />
    <path d="M42883 1670.38h87.5v50h-87.5z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42883 1670.38h87.5v50h-87.5z" />
      <text fill="#000" transform="translate(42883 1670.38)">
        <tspan x={29.133} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={52.469} y={21.22}>
          {" Lisa"}
        </tspan>
        <tspan x={43.75} y={38.02}>
          {"(1998-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M42925.5 1670.38v-62.5h0v-62.5M29325.5 895.38h65" />
    <path d="M43250.5 1520.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43250.5 1520.38h140v50h-140z" />
      <text fill="#000" transform="translate(43250.5 1520.38)">
        <tspan x={22.477} y={21.22} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDFA\uD83C\uDDF8\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={87.434} y={21.22} fontSize={14}>
          {" Andrea Koenig"}
        </tspan>
        <tspan x={70} y={38.02} fontSize={14}>
          {"(1964-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M43210.5 1545.38h40" />
    <path d="M43250.5 1670.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43250.5 1670.38h110v50h-110z" />
      <text fill="#000" transform="translate(43250.5 1670.38)">
        <tspan x={34.41} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Eliana"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1996-)"}
        </tspan>
      </text>
    </g>
    <path d="M43133 1670.38h90v50h-90z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43133 1670.38h90v50h-90z" />
      <text fill="#000" transform="translate(43133 1670.38)">
        <tspan x={21.723} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={53.719} y={21.22}>
          {" Serena"}
        </tspan>
        <tspan x={45} y={38.02}>
          {"(1993-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M43173.5 1670.38v-50h143v50" />
    <path d="M43840.5 1520.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43840.5 1520.38h140v50h-140z" />
      <text fill="#000" transform="translate(43840.5 1520.38)">
        <tspan x={16.148} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Marco Parezzani"}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(1964-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M43790.5 1545.38h50" />
    <path d="M43830.5 1670.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43830.5 1670.38h110v50h-110z" />
      <text fill="#000" transform="translate(43830.5 1670.38)">
        <tspan x={32.172} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Davide"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(2007-)"}
        </tspan>
      </text>
    </g>
    <path d="M43690.5 1670.38h105v50h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43690.5 1670.38h105v50h-105z" />
      <text fill="#000" transform="translate(43690.5 1670.38)">
        <tspan x={30.734} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={61.219} y={21.22}>
          {" Mattia"}
        </tspan>
        <tspan x={52.5} y={38.02}>
          {"(2003-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M43737.75 1670.38v-50h158.75v50" />
      <path strokeWidth={3} d="M49090.5 1070.38h145v50h-145z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M49090.5 1070.38h145v50h-145z" />
        <text fill="#000" transform="translate(49090.5 1070.38)">
          <tspan x={29.176} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={81.219} y={21.22}>
            {" Luigi Lorenzo"}
          </tspan>
          <tspan x={72.5} y={38.02}>
            {"(1886-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M49750.5 1070.38h165v50h-165z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M49750.5 1070.38h165v50h-165z" />
        <text fill="#000" transform="translate(49750.5 1070.38)">
          <tspan x={21.324} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={91.219} y={21.22}>
            {" Maddalena Benilde"}
          </tspan>
          <tspan x={82.5} y={38.02}>
            {"(1885-1962)"}
          </tspan>
        </text>
      </g>
    <path d="M49955.5 1070.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M49955.5 1070.38h150v50h-150z" />
      <text fill="#000" transform="translate(49955.5 1070.38)">
        <tspan x={18.75} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Ernesto Casalone"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1881-)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M49285.5 1070.38h185v50h-185z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M49285.5 1070.38h185v50h-185z" />
        <text fill="#000" transform="translate(49285.5 1070.38)">
          <tspan x={33.188} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={101.219} y={21.22}>
            {" Rosa Sabina Luigia"}
          </tspan>
          <tspan x={92.5} y={38.02}>
            {"(1883-)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M49220.5 895.38h70M48940.5 1070.38v-100h892.5v100M49255.5 895.38v37.5h0v37.5M49165.5 1070.38v-50h0v-50M49370.5 970.38v50h0v50M49915.5 1095.38h40"
    />
    <path d="M46470.5 1370.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M46470.5 1370.38h135v50h-135z" />
      <text fill="#000" transform="translate(46470.5 1370.38)">
        <tspan x={42.344} y={21.22} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={76.219} y={21.22} fontSize={14}>
          {" Frances"}
        </tspan>
        <tspan x={67.5} y={38.02} fontSize={14}>
          {"(1914-2013)"}
        </tspan>
      </text>
    </g>
    <path d="M47455.5 1370.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M47455.5 1370.38h135v50h-135z" />
      <text fill="#000" transform="translate(47455.5 1370.38)">
        <tspan x={27.906} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Felix Angelo"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1918-1998)"}
        </tspan>
      </text>
    </g>
    <path d="M48855.5 1370.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M48855.5 1370.38h135v50h-135z" />
      <text fill="#000" transform="translate(48855.5 1370.38)">
        <tspan x={45.953} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Ernest"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1923-2011)"}
        </tspan>
      </text>
    </g>
    <path d="M49480.5 1370.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M49480.5 1370.38h135v50h-135z" />
      <text fill="#000" transform="translate(49480.5 1370.38)">
        <tspan x={35.414} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Eric Harry"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1925-2001)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M46538 1370.38v-150h3010v150M47670.5 1095.38v62.5h0v62.5"
    />
    <path fill="none" d="M47523 1370.38v-150h2.5M48920.5 1370.38v-75h0v-75" />
    <path d="M6640.5 1380.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M6640.5 1380.38h125v30h-125z" />
      <text fill="#000" transform="translate(6640.5 1380.38)">
        <tspan x={14.824} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDE6\uD83C\uDDF7"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Irene Balvantin"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M6765.5 1395.38h100" />
    <path d="M6755.5 1520.38h115v50h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M6755.5 1520.38h115v50h-115z" />
      <text fill="#000" transform="translate(6755.5 1520.38)">
        <tspan x={19.344} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDE6\uD83C\uDDF7"}
        </tspan>
        <tspan x={66.219} y={21.22}>
          {" Louis Angel"}
        </tspan>
        <tspan x={57.5} y={38.02}>
          {"(1946-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M6810.5 1395.38v62.5h0v62.5" />
    <path d="M42065.5 1670.38h155v50h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42065.5 1670.38h155v50h-155z" />
      <text fill="#000" transform="translate(42065.5 1670.38)">
        <tspan x={28.441} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={86.219} y={21.22}>
          {" Matteo Carnelli"}
        </tspan>
        <tspan x={77.5} y={38.02}>
          {"(1983-)"}
        </tspan>
      </text>
    </g>
    <path d="M42270.5 1670.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42270.5 1670.38h135v50h-135z" />
      <text fill="#000" transform="translate(42270.5 1670.38)">
        <tspan x={23.102} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Giulia Carnelli"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1985-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M42143 1670.38v-50h195v50M42233 1570.38v50h2.5" />
    <path d="M26080.5 1820.38h185v50h-185z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26080.5 1820.38h185v50h-185z" />
      <text fill="#000" transform="translate(26080.5 1820.38)">
        <tspan x={13.168} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={101.219} y={21.22}>
          {" Ashley Michelle Whitfield"}
        </tspan>
        <tspan x={92.5} y={38.02}>
          {"(1989-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M26035.5 1845.38h45" />
    <path d="M6030.5 1670.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M6030.5 1670.38h120v50h-120z" />
      <text fill="#000" transform="translate(6030.5 1670.38)">
        <tspan x={16.039} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Franca Osella"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1969-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M5970.5 1695.38h60" />
    <path d="M5940.5 1820.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M5940.5 1820.38h120v50h-120z" />
      <text fill="#000" transform="translate(5940.5 1820.38)">
        <tspan x={35.188} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Daniele"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(2005-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M6000.5 1820.38v-62.5h0v-62.5" />
    <path d="M5535.5 1820.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M5535.5 1820.38h120v50h-120z" />
      <text fill="#000" transform="translate(5535.5 1820.38)">
        <tspan x={40.547} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9\uD83C\uDDFA\uD83C\uDDE6"}
        </tspan>
        <tspan x={77.438} y={21.22}>
          {" Vlada"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(2005-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M5590.5 1695.38v75h0v50" />
    <path d="M32450.5 1670.38h105v50h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M32450.5 1670.38h105v50h-105z" />
      <text fill="#000" transform="translate(32450.5 1670.38)">
        <tspan x={34.93} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={21.22}>
          {" Mark"}
        </tspan>
        <tspan x={52.5} y={38.02}>
          {"(1967-)"}
        </tspan>
      </text>
    </g>
    <path d="M32600.5 1670.38h105v50h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M32600.5 1670.38h105v50h-105z" />
      <text fill="#000" transform="translate(32600.5 1670.38)">
        <tspan x={31.254} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={21.22}>
          {" Judith"}
        </tspan>
        <tspan x={52.5} y={38.02}>
          {"(1969-2017)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M32500.5 1670.38v-87.5h0v-37.5" />
      <path strokeWidth={3} d="M40805.5 870.38h155v50h-155z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M40805.5 870.38h155v50h-155z" />
        <text fill="#000" transform="translate(40805.5 870.38)">
          <tspan x={39.164} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={86.219} y={21.22}>
            {" Giuseppina "}
          </tspan>
          <tspan x={77.5} y={38.02}>
            {"(1861-1907)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M40945.5 1820.38v-25h0v-25M40765.5 1845.38h110M40820.5 1970.38v-62.5h0v-62.5"
    />
    <path d="M41015.5 870.38h165v50h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M41015.5 870.38h165v50h-165z" />
      <text fill="#000" transform="translate(41015.5 870.38)">
        <tspan x={20.633} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={91.219} y={21.22}>
          {" Vincenzo Rampone"}
        </tspan>
        <tspan x={82.5} y={38.02}>
          {"(1850-1927)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M40840.5 770.38h40v100M31310.5 545.38h80" />
      <path strokeWidth={3} d="M31040.5 1070.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M31040.5 1070.38h125v50h-125z" />
        <text fill="#000" transform="translate(31040.5 1070.38)">
          <tspan x={25.898} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Giuseppina"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1861-1936)"}
          </tspan>
        </text>
      </g>
    <path d="M31205.5 1070.38h155v50h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M31205.5 1070.38h155v50h-155z" />
      <text fill="#000" transform="translate(31205.5 1070.38)">
        <tspan x={15.078} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={86.219} y={21.22}>
          {" Giuseppe Rampone"}
        </tspan>
        <tspan x={77.5} y={38.02}>
          {"(1886-1954)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M31015.5 970.38v-37.5h0v-37.5M31165.5 1095.38h40M40960.5 895.38h55"
    />
    <path d="M41145.5 1070.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M41145.5 1070.38h135v50h-135z" />
      <text fill="#000" transform="translate(41145.5 1070.38)">
        <tspan x={11.688} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Salvino Rampone"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1890-1951)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M40990.5 895.38v75h222.5v100" />
    <path d="M31105.5 1220.38h155v50h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M31105.5 1220.38h155v50h-155z" />
      <text fill="#000" transform="translate(31105.5 1220.38)">
        <tspan x={26.496} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={86.219} y={21.22}>
          {" Maria Rampone"}
        </tspan>
        <tspan x={77.5} y={38.02}>
          {"(1891-1950)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M31185.5 1095.38v62.5h0v62.5" />
    <path d="M105.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M105.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(105.5 1520.38)">
        <tspan x={19.055} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Giuseppe"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1942-)"}
        </tspan>
      </text>
    </g>
    <path d="M265.5 1530.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M265.5 1530.38h150v30h-150z" />
      <text fill="#000" transform="translate(265.5 1530.38)">
        <tspan x={27.68} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Carla Zamboni"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M205.5 1545.38h60M155.5 1395.38v62.5h0v62.5" />
    <path d="M185.5 1680.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M185.5 1680.38h100v30h-100z" />
      <text fill="#000" transform="translate(185.5 1680.38)">
        <tspan x={19.234} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Valentina"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M230.5 1545.38h5v135" />
      <path strokeWidth={3} d="M32895.5 1220.38h180v50h-180z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M32895.5 1220.38h180v50h-180z" />
        <text fill="#000" transform="translate(32895.5 1220.38)">
          <tspan x={11.633} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={98.719} y={21.22}>
            {" Giuseppina (Maggiorina)"}
          </tspan>
          <tspan x={90} y={38.02}>
            {"(1885-1971)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M32605.5 1220.38v-50h380v50" />
    <g transform="translate(27230.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"166"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(27470.5 650.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"167"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(26970.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"168"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(28190.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"169"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(32160.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"170"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(32415.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"171"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(31895.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"172"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(32160.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"173"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(32570.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"174"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(32820.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"175"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(33080.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"176"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(33310.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"177"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(32030.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"178"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(32190.5 1195.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"179"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(32520.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"180"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(32715.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"181"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(32055.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"182"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(32365.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"183"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(32630.5 1350.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"184"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(32280.5 1500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"185"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(32525.5 1500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"186"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(33540.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"187"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M5475.5 1220.38h95v50h-95z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M5475.5 1220.38h95v50h-95z" />
        <text fill="#000" transform="translate(5475.5 1220.38)">
          <tspan x={30.961} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={56.219} y={21.22}>
            {" Luigi"}
          </tspan>
          <tspan x={47.5} y={38.02}>
            {"(1879-1966)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M5605.5 1220.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M5605.5 1220.38h100v50h-100z" />
        <text fill="#000" transform="translate(5605.5 1220.38)">
          <tspan x={16.617} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Domenico"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1891-1940)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M5745.5 1220.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M5745.5 1220.38h130v50h-130z" />
        <text fill="#000" transform="translate(5745.5 1220.38)">
          <tspan x={15.156} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Carolina Berruti"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1893-1957)"}
          </tspan>
        </text>
      </g>
    <path strokeDasharray="4 5" d="M5320.5 1220.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M5320.5 1220.38h125v50h-125z" />
      <text fill="#000" fontSize={14} transform="translate(5320.5 1220.38)">
        <tspan x={62.5} y={21.22}>
          {"See Teresa Verrua"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1881-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M5705.5 1245.38h40M5978 1220.38v-50h-207.5v-75M5655.5 1220.38v-50h115v-10"
    />
    <path fill="none" d="M5523 1220.38v-50h247.5v-10M8015.5 1545.38h45" />
      <path strokeWidth={3} d="M8460.5 870.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M8460.5 870.38h125v50h-125z" />
        <text fill="#000" transform="translate(8460.5 870.38)">
          <tspan x={32.707} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Giacomo"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1824-1905)"}
          </tspan>
        </text>
      </g>
    <path d="M8655.5 880.38h175v30h-175z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M8655.5 880.38h175v30h-175z" />
      <text fill="#000" transform="translate(8655.5 880.38)">
        <tspan x={31.594} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={96.219} y={19.62}>
          {" Clementina Testa"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M8585.5 895.38h70" />
      <path strokeWidth={3} d="M8205.5 1070.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M8205.5 1070.38h125v50h-125z" />
        <text fill="#000" transform="translate(8205.5 1070.38)">
          <tspan x={35.352} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Benigno"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1857-1896)"}
          </tspan>
        </text>
      </g>
    <path d="M8400.5 1080.38h175v30h-175z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M8400.5 1080.38h175v30h-175z" />
      <text fill="#000" transform="translate(8400.5 1080.38)">
        <tspan x={20.047} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={96.219} y={19.62}>
          {" Angela Gambertoglio"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M8330.5 1095.38h70" />
      <path strokeWidth={3} d="M8840.5 1070.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M8840.5 1070.38h125v50h-125z" />
        <text fill="#000" transform="translate(8840.5 1070.38)">
          <tspan x={31.914} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Pasquale"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1847-)"}
          </tspan>
        </text>
      </g>
    <path d="M9035.5 1070.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9035.5 1070.38h135v50h-135z" />
      <text fill="#000" transform="translate(9035.5 1070.38)">
        <tspan x={27.512} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Maria Ardito"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1850- )"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M8965.5 1095.38h70" />
      <path strokeWidth={3} d="M8470.5 1370.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M8470.5 1370.38h130v50h-130z" />
        <text fill="#000" transform="translate(8470.5 1370.38)">
          <tspan x={13.344} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Corinna (Carina)"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1912-2004)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M8600.5 1395.38h27.5" />
      <path strokeWidth={3} d="M8300.5 1220.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M8300.5 1220.38h125v50h-125z" />
        <text fill="#000" transform="translate(8300.5 1220.38)">
          <tspan x={32.707} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Giacomo"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1889-1976)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M8480.5 1220.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M8480.5 1220.38h150v50h-150z" />
        <text fill="#000" transform="translate(8480.5 1220.38)">
          <tspan x={24.645} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Clementina Cisi"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1895-1976)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M8310.5 1370.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M8310.5 1370.38h125v50h-125z" />
        <text fill="#000" transform="translate(8310.5 1370.38)">
          <tspan x={39.195} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Angela"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1911-1984)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M8165.5 1370.38h110v50h-110z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M8165.5 1370.38h110v50h-110z" />
        <text fill="#000" transform="translate(8165.5 1370.38)">
          <tspan x={34.863} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={63.719} y={21.22}>
            {" Pietro"}
          </tspan>
          <tspan x={55} y={38.02}>
            {"(1903-1984)"}
          </tspan>
        </text>
      </g>
    <path strokeWidth={3} d="M8720.5 1220.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M8720.5 1220.38h145v50h-145z" />
      <text fill="#000" transform="translate(8720.5 1220.38)">
        <tspan x={18.992} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Marietta Ronfani"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1876-1944)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M8935.5 1220.38h135v50h-135z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M8935.5 1220.38h135v50h-135z" />
        <text fill="#000" transform="translate(8935.5 1220.38)">
          <tspan x={50.965} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={76.219} y={21.22}>
            {" Luigi"}
          </tspan>
          <tspan x={67.5} y={38.02}>
            {"(1870-1952)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M8865.5 1245.38h70" />
      <path strokeWidth={3} d="M9005.5 1370.38h145v50h-145z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M9005.5 1370.38h145v50h-145z" />
        <text fill="#000" transform="translate(9005.5 1370.38)">
          <tspan x={22.258} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={81.219} y={21.22}>
            {" Pierina Imarisio"}
          </tspan>
          <tspan x={72.5} y={38.02}>
            {"(1900-1974)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M8835.5 1370.38h135v50h-135z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M8835.5 1370.38h135v50h-135z" />
        <text fill="#000" transform="translate(8835.5 1370.38)">
          <tspan x={43.977} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={76.219} y={21.22}>
            {" Aurelio"}
          </tspan>
          <tspan x={67.5} y={38.02}>
            {"(1897-1982)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M8970.5 1395.38h35M8523 870.38v-100h-2.5M8268 1070.38v-100h347.5v-75M8903 1070.38v-100h-287.5v-35M8425.5 1245.38h55M8340.5 1095.38h25v125M8373 1370.38v-50h162.5v50M9005.5 1095.38v62.5h0v62.5M8900.5 1245.38v62.5h0v62.5"
    />
      <path strokeWidth={3} d="M8925.5 1520.38h135v50h-135z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M8925.5 1520.38h135v50h-135z" />
        <text fill="#000" transform="translate(8925.5 1520.38)">
          <tspan x={50.965} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={76.219} y={21.22}>
            {" Luigi"}
          </tspan>
          <tspan x={67.5} y={38.02}>
            {"(1932-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M8990.5 1395.38v62.5h0v62.5" />
    <path d="M43003 1670.38h105v50h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43003 1670.38h105v50h-105z" />
      <text fill="#000" transform="translate(43003 1670.38)">
        <tspan x={14.414} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={21.22}>
          {" Miguel Lara"}
        </tspan>
        <tspan x={52.5} y={38.02}>
          {"(1993-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M43108 1695.38h25M3680.5 895.38h120M4215.5 1020.38v-125h0zM4203 970.38h-902.5v100"
    />
      <path strokeWidth={3} d="M1920.5 870.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1920.5 870.38h150v50h-150z" />
        <text fill="#000" transform="translate(1920.5 870.38)">
          <tspan x={41.891} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Tommaso"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1839-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M1995.5 1070.38h110v50h-110z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M1995.5 1070.38h110v50h-110z" />
        <text fill="#000" transform="translate(1995.5 1070.38)">
          <tspan x={33.25} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={63.719} y={21.22}>
            {" Orazio"}
          </tspan>
          <tspan x={55} y={38.02}>
            {"(1879-1955)"}
          </tspan>
        </text>
      </g>
    <g transform="translate(1975.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"122"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M2400.5 1070.38h120v50h-120z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M2400.5 1070.38h120v50h-120z" />
        <text fill="#000" transform="translate(2400.5 1070.38)">
          <tspan x={14.516} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={68.719} y={21.22}>
            {" Felice Cesario"}
          </tspan>
          <tspan x={60} y={38.02}>
            {"(1872-1965)"}
          </tspan>
        </text>
      </g>
    <path d="M2605.5 1070.38h270v50h-270z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2605.5 1070.38h270v50h-270z" />
      <text fill="#000" transform="translate(2605.5 1070.38)">
        <tspan x={43.539} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={143.719} y={21.22}>
          {" Colombina Maria Cavalliero"}
        </tspan>
        <tspan x={135} y={38.02}>
          {"(1881-1965)"}
        </tspan>
      </text>
    </g>
    <path d="M2750.5 1220.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2750.5 1220.38h135v50h-135z" />
      <text fill="#000" transform="translate(2750.5 1220.38)">
        <tspan x={50.398} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Luigi"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1902-1994)"}
        </tspan>
      </text>
    </g>
    <path d="M2970.5 1220.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2970.5 1220.38h125v50h-125z" />
      <text fill="#000" transform="translate(2970.5 1220.38)">
        <tspan x={24.766} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Elisa Bonini"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1913-2007)"}
        </tspan>
      </text>
    </g>
    <path d="M3578 1530.38h105v30h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M3578 1530.38h105v30h-105z" />
      <text fill="#000" fontSize={14} transform="translate(3578 1530.38)">
        <tspan x={34.496} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={19.62}>
          {" Gene"}
        </tspan>
      </text>
    </g>
    <path d="M3320.5 1530.38h185v30h-185z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M3320.5 1530.38h185v30h-185z" />
      <text fill="#000" transform="translate(3320.5 1530.38)">
        <tspan x={30.203} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={101.219} y={19.62}>
          {" Daphinne Ann Race"}
        </tspan>
      </text>
    </g>
    <path d="M3238 1370.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M3238 1370.38h135v50h-135z" />
      <text fill="#000" transform="translate(3238 1370.38)">
        <tspan x={53.336} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Carl"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1938-)"}
        </tspan>
      </text>
    </g>
    <path d="M3475.5 1380.38h165v30h-165z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M3475.5 1380.38h165v30h-165z" />
      <text fill="#000" transform="translate(3475.5 1380.38)">
        <tspan x={31.383} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={91.219} y={19.62}>
          {" Barbara Manker"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M3373 1395.38h102.5" />
    <path d="M2825.5 1380.38h185v30h-185z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2825.5 1380.38h185v30h-185z" />
      <text fill="#000" transform="translate(2825.5 1380.38)">
        <tspan x={31.031} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={101.219} y={19.62}>
          {" Louis Joseph (Joe)"}
        </tspan>
      </text>
    </g>
    <path d="M3048 1380.38h160v30h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M3048 1380.38h160v30h-160z" />
      <text fill="#000" transform="translate(3048 1380.38)">
        <tspan x={16.563} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={88.719} y={19.62}>
          {" Diana L. Wainwright"}
        </tspan>
      </text>
    </g>
    <path d="M3195.5 1530.38h105v30h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M3195.5 1530.38h105v30h-105z" />
      <text fill="#000" transform="translate(3195.5 1530.38)">
        <tspan x={31.203} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={19.62}>
          {" Cheryl"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M3630.5 1530.38v-60H3248v60" />
    <path d="M3418 1680.38h105v30h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M3418 1680.38h105v30h-105z" />
      <text fill="#000" transform="translate(3418 1680.38)">
        <tspan x={14.383} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={19.62}>
          {" Nicola Elisa"}
        </tspan>
      </text>
    </g>
    <path d="M3580.5 1680.38h105v30h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M3580.5 1680.38h105v30h-105z" />
      <text fill="#000" transform="translate(3580.5 1680.38)">
        <tspan x={17.102} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={19.62}>
          {" Gina Maria"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M3470.5 1680.38v-60h160v60M3740.5 895.38v75h0z" />
    <path d="M2893 1530.38h105v30h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2893 1530.38h105v30h-105z" />
      <text fill="#000" transform="translate(2893 1530.38)">
        <tspan x={25.445} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={19.62}>
          {" Timothy"}
        </tspan>
      </text>
    </g>
    <path d="M3055.5 1530.38h105v30h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M3055.5 1530.38h105v30h-105z" />
      <text fill="#000" transform="translate(3055.5 1530.38)">
        <tspan x={25.344} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={19.62}>
          {" Jennifer"}
        </tspan>
      </text>
    </g>
    <path d="M2983 1680.38h105v30h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2983 1680.38h105v30h-105z" />
      <text fill="#000" transform="translate(2983 1680.38)">
        <tspan x={35.883} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={19.62}>
          {" Tyler"}
        </tspan>
      </text>
    </g>
    <path d="M3145.5 1680.38h105v30h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M3145.5 1680.38h105v30h-105z" />
      <text fill="#000" transform="translate(3145.5 1680.38)">
        <tspan x={34.469} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={19.62}>
          {" Alora"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M2945.5 1530.38v-60h165v60M3028 1395.38v37.5h0v37.5M3035.5 1680.38v-60H3198v60M3110.5 1560.38v30h0v30"
    />
    <g transform="translate(2378 1047.88)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"188"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M2215.5 880.38h105v30h-105z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M2215.5 880.38h105v30h-105z" />
        <text fill="#000" transform="translate(2215.5 880.38)">
          <tspan x={15.188} y={19.62} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={61.219} y={19.62}>
            {" Rosa Iviglia"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M2070.5 895.38h145M2055.5 1070.38v-100h405v100M2140.5 970.38v-37.5h0v-37.5M2885.5 1245.38h85M3010.5 1395.38h37.5M2918 1380.38v-60h387.5v50M2930.5 1245.38v37.5h0v37.5M1760.5 870.38v-100h235v100M1860.5 695.38v37.5h0v37.5"
    />
      <path strokeWidth={3} d="M49875.5 870.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M49875.5 870.38h130v50h-130z" />
        <text fill="#000" transform="translate(49875.5 870.38)">
          <tspan x={21.516} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Proba Angela"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1853-1934)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M50185.5 870.38h225v50h-225z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M50185.5 870.38h225v50h-225z" />
        <text fill="#000" transform="translate(50185.5 870.38)">
          <tspan x={35.277} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={121.219} y={21.22}>
            {" Paolo Gennaro Casalone"}
          </tspan>
          <tspan x={112.5} y={38.02}>
            {"(1853-1928)"}
          </tspan>
        </text>
      </g>
    <path d="M49820.5 680.38h95v30h-95z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M49820.5 680.38h95v30h-95z" />
      <text fill="#000" transform="translate(49820.5 680.38)">
        <tspan x={28.441} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={56.219} y={19.62}>
          {" Paolo"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M49940.5 870.38v-175h-25M50005.5 895.38h180M50030.5 1070.38v-100h165v100"
    />
    <path d="M50120.5 1070.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M50120.5 1070.38h150v50h-150z" />
      <text fill="#000" transform="translate(50120.5 1070.38)">
        <tspan x={20.914} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Angela Casalone"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1881-)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M43460.5 870.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M43460.5 870.38h125v50h-125z" />
        <text fill="#000" transform="translate(43460.5 870.38)">
          <tspan x={32.668} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Celestina"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1865-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M43670.5 870.38h120v50h-120z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M43670.5 870.38h120v50h-120z" />
        <text fill="#000" transform="translate(43670.5 870.38)">
          <tspan x={31.289} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={68.719} y={21.22}>
            {" Giovanni"}
          </tspan>
          <tspan x={60} y={38.02}>
            {"(1863-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M43585.5 895.38h85" />
      <path strokeWidth={3} d="M43743 670.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M43743 670.38h125v50h-125z" />
        <text fill="#000" transform="translate(43743 670.38)">
          <tspan x={43.441} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Paolo"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1824-1894)"}
          </tspan>
        </text>
      </g>
    <path d="M43943 680.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43943 680.38h150v30h-150z" />
      <text fill="#000" transform="translate(43943 680.38)">
        <tspan x={27.664} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Luigia Gavazza"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M43868 695.38h75M43912 755.38q11 1 11 15M43902 770.38q0-15 10-15M50115.5 895.38v45h0v30"
    />
      <path strokeWidth={3} d="M43555.5 1070.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M43555.5 1070.38h130v50h-130z" />
        <text fill="#000" transform="translate(43555.5 1070.38)">
          <tspan x={27.879} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Maggiorino"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1884-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M43625.5 895.38v87.5h0v87.5" />
    <path strokeDasharray="3 4" d="M43340.5 1070.38h170v50h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43340.5 1070.38h170v50h-170z" />
      <text fill="#000" transform="translate(43340.5 1070.38)">
        <tspan x={85} y={21.22}>
          {"See Angela Casalone"}
        </tspan>
        <tspan x={85} y={38.02}>
          {"(1887)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M43510.5 1095.38h45" />
    <path strokeDasharray="3 4" d="M50335.5 1070.38h130v50h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M50335.5 1070.38h130v50h-130z" />
      <text fill="#000" transform="translate(50335.5 1070.38)">
        <tspan x={65} y={21.22}>
          {"See Maggiorino"}
        </tspan>
        <tspan x={65} y={38.02}>
          {"(1884)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M50270.5 1095.38h65" />
      <path strokeWidth={3} d="M50225.5 1220.38h155v50h-155z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M50225.5 1220.38h155v50h-155z" />
        <text fill="#000" transform="translate(50225.5 1220.38)">
          <tspan x={29.031} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={86.219} y={21.22}>
            {" Annibale Paolo"}
          </tspan>
          <tspan x={77.5} y={38.02}>
            {"(1909-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M50300.5 1095.38h2.5v125M43540.5 770.38h-17.5v100" />
    <path d="M29875.5 1370.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M29875.5 1370.38h150v50h-150z" />
      <text fill="#000" transform="translate(29875.5 1370.38)">
        <tspan x={27.738} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Maria Gibaudo"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1925-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M29785.5 1395.38h90" />
    <path d="M29625.5 1520.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M29625.5 1520.38h150v50h-150z" />
      <text fill="#000" transform="translate(29625.5 1520.38)">
        <tspan x={51.926} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Franco"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1959-)"}
        </tspan>
      </text>
    </g>
    <path d="M29875.5 1520.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M29875.5 1520.38h150v50h-150z" />
      <text fill="#000" transform="translate(29875.5 1520.38)">
        <tspan x={58.465} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Luigi"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1953-)"}
        </tspan>
      </text>
    </g>
    <path d="M30125.5 1520.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M30125.5 1520.38h150v50h-150z" />
      <text fill="#000" transform="translate(30125.5 1520.38)">
        <tspan x={24.797} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Luciana Revello"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1955-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M30025.5 1545.38h100M29700.5 1520.38v-50h250v50M29825.5 1395.38v37.5h0v37.5"
    />
      <path strokeWidth={3} d="M3780.5 1070.38h115v50h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M3780.5 1070.38h115v50h-115z" />
        <text fill="#000" fontSize={14} transform="translate(3780.5 1070.38)">
          <tspan x={38.219} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={21.22}>
            {" Felice"}
          </tspan>
          <tspan x={57.5} y={38.02}>
            {"(1856-1924)"}
          </tspan>
        </text>
      </g>
    <path strokeDasharray="4 5" d="M3960.5 1070.38h170v50h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M3960.5 1070.38h170v50h-170z" />
      <text fill="#000" transform="translate(3960.5 1070.38)">
        <tspan x={85} y={21.22}>
          {"See Angela Mortarotti"}
        </tspan>
        <tspan x={85} y={38.02}>
          {"(1859-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M3840.5 1070.38v-50h675v50M3895.5 1095.38h65M4023 1370.38v-125h0z"
    />
      <path strokeWidth={3} d="M26125.5 1070.38h160v50h-160z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M26125.5 1070.38h160v50h-160z" />
        <text fill="#000" transform="translate(26125.5 1070.38)">
          <tspan x={32.461} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={88.719} y={21.22}>
            {" Vittoria Regalo"}
          </tspan>
          <tspan x={80} y={38.02}>
            {"(1859-1918)"}
          </tspan>
        </text>
      </g>
    <path d="M26330.5 1080.38h160v30h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26330.5 1080.38h160v30h-160z" />
      <text fill="#000" transform="translate(26330.5 1080.38)">
        <tspan x={34.391} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={88.719} y={19.62}>
          {" Lorenzo Travo"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M26285.5 1095.38h45M25815.5 1095.38h310M26310.5 1095.38v62.5h0v62.5"
    />
      <path strokeWidth={3} d="M44935.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M44935.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(44935.5 1070.38)">
          <tspan x={18.375} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Salvina Morando"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1885-1937)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M45085.5 1095.38h40" />
    <path d="M29390.5 880.38h145v30h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M29390.5 880.38h145v30h-145z" />
      <text fill="#000" transform="translate(29390.5 880.38)">
        <tspan x={15.898} y={19.62} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={19.62} fontSize={14}>
          {" Celestina Piglione"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M44130.5 870.38h115v50h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M44130.5 870.38h115v50h-115z" />
        <text fill="#000" transform="translate(44130.5 870.38)">
          <tspan x={20.898} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={21.22}>
            {" Giuseppina"}
          </tspan>
          <tspan x={57.5} y={38.02}>
            {"(1858-)"}
          </tspan>
        </text>
      </g>
    <path strokeDasharray="3 4" d="M44275.5 870.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44275.5 870.38h100v50h-100z" />
      <text fill="#000" transform="translate(44275.5 870.38)">
        <tspan x={50} y={21.22}>
          {"See Paolo"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1854-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M44245.5 895.38h30M43730.5 870.38v-50h457.5v50M43915.5 820.38h-2.5v-125h30"
    />
      <path strokeWidth={3} d="M6040.5 1070.38h125v50h-125z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M6040.5 1070.38h125v50h-125z" />
        <text fill="#000" transform="translate(6040.5 1070.38)">
          <tspan x={42.895} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={71.219} y={21.22}>
            {" Paolo"}
          </tspan>
          <tspan x={62.5} y={38.02}>
            {"(1854-)"}
          </tspan>
        </text>
      </g>
    <path strokeDasharray="4 5" d="M6235.5 1070.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M6235.5 1070.38h120v50h-120z" />
      <text fill="#000" transform="translate(6235.5 1070.38)">
        <tspan x={60} y={21.22}>
          {"See Giuseppina"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1858-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M6165.5 1095.38h70M6103 1070.38v-50h-2.5" />
    <path d="M1720.5 1070.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M1720.5 1070.38h200v50h-200z" />
      <text fill="#000" transform="translate(1720.5 1070.38)">
        <tspan x={24.75} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Teresa Francesca Gatto"}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(1886-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M1920.5 1095.38h75" />
    <path d="M44250.5 1070.38h140v50h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44250.5 1070.38h140v50h-140z" />
      <text fill="#000" transform="translate(44250.5 1070.38)">
        <tspan x={20.281} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={21.22}>
          {" Pierina Roberto"}
        </tspan>
        <tspan x={70} y={38.02}>
          {"(1895-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M44390.5 1097.38h28" />
      <path strokeWidth={3} d="M4375.5 1370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M4375.5 1370.38h150v50h-150z" />
        <text fill="#000" transform="translate(4375.5 1370.38)">
          <tspan x={27.781} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Luigina Rosina"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1899-)"}
          </tspan>
        </text>
      </g>
    <path d="M4135.5 1370.38h190v50h-190z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M4135.5 1370.38h190v50h-190z" />
      <text fill="#000" transform="translate(4135.5 1370.38)">
        <tspan x={16.406} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={103.719} y={21.22}>
          {" Giovanni Battista Grosso"}
        </tspan>
        <tspan x={95} y={38.02}>
          {"(1894-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M4375.5 1395.38h-25 0-25M4450.5 1370.38v-50h155v-50" />
    <path d="M29265.5 1220.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M29265.5 1220.38h150v50h-150z" />
      <text fill="#000" transform="translate(29265.5 1220.38)">
        <tspan x={16.422} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Giovanna Vergano"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1896-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M29415.5 1245.38h50" />
      <path strokeWidth={3} d="M40040.5 1370.38h155v50h-155z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M40040.5 1370.38h155v50h-155z" />
        <text fill="#000" transform="translate(40040.5 1370.38)">
          <tspan x={23.504} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={86.219} y={21.22}>
            {" Secondo Torchio"}
          </tspan>
          <tspan x={77.5} y={38.02}>
            {"(1902-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M40010.5 1395.38h30" />
    <path d="M44775.5 680.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44775.5 680.38h150v30h-150z" />
      <text fill="#000" transform="translate(44775.5 680.38)">
        <tspan x={20.039} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Pietro Rabezzana"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M44985.5 670.38h110v50h-110z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M44985.5 670.38h110v50h-110z" />
        <text fill="#000" transform="translate(44985.5 670.38)">
          <tspan x={38.465} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={63.719} y={21.22}>
            {" Rosa"}
          </tspan>
          <tspan x={55} y={38.02}>
            {"(1822-1894)"}
          </tspan>
        </text>
      </g>
    <path strokeDasharray="3 4" d="M44860.5 520.38h152.5v50h-152.5z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M44860.5 520.38h152.5v50h-152.5z" />
      <text fill="#000" transform="translate(44860.5 520.38)">
        <tspan x={76.25} y={21.22}>
          {"See Jacobi (Giacomo)"}
        </tspan>
        <tspan x={76.25} y={38.02}>
          {"(1780-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M44925.5 695.38h60M45013 545.38h25v125M44755.5 870.38v-50h460v50M44955.5 695.38v62.5h0v62.5M44955.5 755.38q11 1 11 15M44945.5 770.38q0-15 10-15M43923 770.38h1022.5M45545.5 870.38v-50h0v-50"
    />
      <path strokeWidth={3} d="M52035.5 520.38h235v50h-235z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M52035.5 520.38h235v50h-235z" />
        <text fill="#000" transform="translate(52035.5 520.38)">
          <tspan x={19.383} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={126.219} y={21.22}>
            {" Maddalena Rabelino/Biamino"}
          </tspan>
          <tspan x={117.5} y={38.02}>
            {"(1786-1850)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M51825.5 520.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M51825.5 520.38h100v50h-100z" />
        <text fill="#000" transform="translate(51825.5 520.38)">
          <tspan x={29.82} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Felice"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1777-1852)"}
          </tspan>
        </text>
      </g>
    <path d="M51745.5 380.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M51745.5 380.38h100v30h-100z" />
      <text fill="#000" transform="translate(51745.5 380.38)">
        <tspan x={22.484} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Antonio"}
        </tspan>
      </text>
    </g>
    <path d="M51920.5 380.38h170v30h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M51920.5 380.38h170v30h-170z" />
      <text fill="#000" transform="translate(51920.5 380.38)">
        <tspan x={23.895} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={93.719} y={19.62}>
          {" Margarita Sarocco"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M51845.5 395.38h75M51875.5 520.38v-62.5h0v-62.5M52035.5 545.38h-52.5 0-57.5"
    />
    <path d="M2785.5 530.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2785.5 530.38h100v30h-100z" />
      <text fill="#000" transform="translate(2785.5 530.38)">
        <tspan x={29.984} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Felice"}
        </tspan>
      </text>
    </g>
    <path d="M2785.5 380.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2785.5 380.38h100v30h-100z" />
      <text fill="#000" transform="translate(2785.5 380.38)">
        <tspan x={33.348} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Paoli"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M2835.5 530.38v-60h0v-60" />
    <g transform="translate(2765.5 507.88)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"94"}
          </tspan>
        </text>
      </g>
    </g>
    <path strokeDasharray="3 4" d="M28865.5 870.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M28865.5 870.38h100v50h-100z" />
      <text fill="#000" transform="translate(28865.5 870.38)">
        <tspan x={50} y={21.22}>
          {"See Paolo"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1824-1894)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M28915.5 870.38v-12.5h0v-12.5" />
    <path strokeDasharray="3 4" d="M43748 520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43748 520.38h100v50h-100z" />
      <text fill="#000" transform="translate(43748 520.38)">
        <tspan x={50} y={21.22}>
          {"See Giovanni"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1792-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M43805.5 670.38v-50h0v-50" />
    <path strokeDasharray="3 4" d="M26530.5 1070.38h175v50h-175z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26530.5 1070.38h175v50h-175z" />
      <text fill="#000" transform="translate(26530.5 1070.38)">
        <tspan x={87.5} y={21.22}>
          {"See Giovanna Garavaglia"}
        </tspan>
        <tspan x={87.5} y={38.02}>
          {"(1873-1935)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M26740.5 1070.38h110v50h-110z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M26740.5 1070.38h110v50h-110z" />
        <text fill="#000" transform="translate(26740.5 1070.38)">
          <tspan x={24.102} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={63.719} y={21.22}>
            {" Giuseppe"}
          </tspan>
          <tspan x={55} y={38.02}>
            {"(1857-1925)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M26705.5 1095.38h35M26795.5 1070.38v-100h75v-75M27300.5 1070.38v-100h-430v-60M26495.5 1695.38h45"
    />
    <path d="M45058 530.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M45058 530.38h150v30h-150z" />
      <text fill="#000" transform="translate(45058 530.38)">
        <tspan x={16.098} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Francesca Lasagna"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M45013 545.38h45" />
      <path strokeWidth={3} d="M38880.5 520.38h155v50h-155z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M38880.5 520.38h155v50h-155z" />
        <text fill="#000" fontSize={14} transform="translate(38880.5 520.38)">
          <tspan x={21.348} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={86.219} y={21.22}>
            {" Jacobi (Giacomo)"}
          </tspan>
          <tspan x={77.5} y={38.02}>
            {"(1780-1840)"}
          </tspan>
        </text>
      </g>
    <path strokeDasharray="3 4" d="M38660.5 530.38h170v30h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M38660.5 530.38h170v30h-170z" />
      <text fill="#000" transform="translate(38660.5 530.38)">
        <tspan x={85} y={19.62}>
          {"See Francesca Lasagna"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M38830.5 545.38h50M38985.5 245.38v37.5h0v87.5M38958 520.38v-50h257.5v50M39075.5 395.38v37.5h0v37.5"
    />
      <path strokeDasharray="3 4" d="M3585.5 1070.38h170v50h-170z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M3585.5 1070.38h170v50h-170z" />
        <text fill="#000" fontSize={14} transform="translate(3585.5 1070.38)">
          <tspan x={85} y={21.22}>
            {"See Maddalena Cecilia"}
          </tspan>
          <tspan x={85} y={38.02}>
            {"(1866-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M3385.5 1070.38h160v50h-160z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M3385.5 1070.38h160v50h-160z" />
        <text fill="#000" transform="translate(3385.5 1070.38)">
          <tspan x={16.406} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={88.719} y={21.22}>
            {" Ferdinando Lorenzo"}
          </tspan>
          <tspan x={80} y={38.02}>
            {"(1858-)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M3585.5 1095.38h-7.5 0-32.5M3505.5 1545.38h70M3465.5 1070.38v-50h405"
    />
      <path strokeWidth={3} d="M42975.5 670.38h180v50h-180z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M42975.5 670.38h180v50h-180z" />
        <text fill="#000" transform="translate(42975.5 670.38)">
          <tspan x={22.863} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={98.719} y={21.22}>
            {" Desiderio Maranzana"}
          </tspan>
          <tspan x={90} y={38.02}>
            {"(1821-1897)"}
          </tspan>
        </text>
      </g>
    <path d="M42785.5 670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42785.5 670.38h150v50h-150z" />
      <text fill="#000" transform="translate(42785.5 670.38)">
        <tspan x={14.797} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Pasqualina Cassoni"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1833-1900)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M42965.5 695.38h-10v175M42945.5 770.38q0-10 10-10" />
    <path fill="none" d="M42965.5 770.38q0-10-10-10" />
      <path strokeWidth={3} d="M42855.5 520.38h180v50h-180z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M42855.5 520.38h180v50h-180z" />
        <text fill="#000" fontSize={14} transform="translate(42855.5 520.38)">
          <tspan x={21.535} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={98.719} y={21.22}>
            {" Francesco Maranzana"}
          </tspan>
          <tspan x={90} y={38.02}>
            {"(1792-1878)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M43085.5 520.38h135v50h-135z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M43085.5 520.38h135v50h-135z" />
        <text fill="#000" fontSize={14} transform="translate(43085.5 520.38)">
          <tspan x={44.25} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={76.219} y={21.22}>
            {" Felicita"}
          </tspan>
          <tspan x={67.5} y={38.02}>
            {"(1801-1882)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M42975.5 695.38h-20 0-20M43035.5 545.38h50M43050.5 620.38q0-10 10-10M43070.5 620.38q0-10-10-10M43060.5 545.38v66.25h0v56.25"
    />
      <path strokeWidth={3} d="M42975.5 370.38h135v50h-135z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M42975.5 370.38h135v50h-135z" />
        <text fill="#000" fontSize={14} transform="translate(42975.5 370.38)">
          <tspan x={40.871} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={76.219} y={21.22}>
            {" Antonio"}
          </tspan>
          <tspan x={67.5} y={38.02}>
            {"(1764-)"}
          </tspan>
        </text>
      </g>
    <path d="M43170.5 380.38h115v30h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43170.5 380.38h115v30h-115z" />
      <text fill="#000" transform="translate(43170.5 380.38)">
        <tspan x={25.547} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={19.62}>
          {" Francesca"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M43110.5 395.38h60M43145.5 520.38v-57.5h0v-67.5" />
      <path strokeWidth={3} d="M42870.5 220.38h135v50h-135z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M42870.5 220.38h135v50h-135z" />
        <text fill="#000" fontSize={14} transform="translate(42870.5 220.38)">
          <tspan x={30.926} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={76.219} y={21.22}>
            {" Joes Simon"}
          </tspan>
          <tspan x={67.5} y={38.02}>
            {"(1722-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M43065.5 230.38h115v30h-115z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M43065.5 230.38h115v30h-115z" />
        <text fill="#000" fontSize={14} transform="translate(43065.5 230.38)">
          <tspan x={39.922} y={19.62} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={66.219} y={19.62}>
            {" Rosa"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M43005.5 245.38h60M43040.5 370.38v-62.5h0v-62.5" />
    <path d="M42670.5 80.38h115v30h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42670.5 80.38h115v30h-115z" />
      <text fill="#000" transform="translate(42670.5 80.38)">
        <tspan x={20.094} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={19.62}>
          {" Jois Antonii"}
        </tspan>
      </text>
    </g>
    <path d="M42820.5 80.38h115v30h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42820.5 80.38h115v30h-115z" />
      <text fill="#000" transform="translate(42820.5 80.38)">
        <tspan x={26.297} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={19.62}>
          {" Dominice"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M42785.5 95.38h35M42930.5 220.38v-50h-235v50M43070.5 620.38h187.5v50M42965.5 770.38h936"
    />
      <path strokeDasharray="2 3" d="M49515.5 1080.38h200v30h-200z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M49515.5 1080.38h200v30h-200z" />
        <text fill="#000" transform="translate(49515.5 1080.38)">
          <tspan x={15.734} y={19.62} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={108.719} y={19.62}>
            {" see Florindo Gambertoglio"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M49515.5 1095.38h-22.5 0-22.5" />
    <path d="M39030.5 1080.38h190v30h-190z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M39030.5 1080.38h190v30h-190z" />
      <text fill="#000" fontSize={14} transform="translate(39030.5 1080.38)">
        <tspan x={22.945} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={103.719} y={19.62}>
          {" Florindo Gambertoglio"}
        </tspan>
      </text>
    </g>
    <path strokeDasharray="2 3" d="M38808 1070.38h170v50h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M38808 1070.38h170v50h-170z" />
      <text fill="#000" fontSize={14} transform="translate(38808 1070.38)">
        <tspan x={13.469} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={52.852} y={21.22}>
          {" see Rosa "}
        </tspan>
        <tspan x={106.047} y={21.22}>
          {"Sabina "}
        </tspan>
        <tspan x={146.914} y={21.22}>
          {"Luigia"}
        </tspan>
        <tspan x={85} y={38.02}>
          {"(1883-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M38978 1095.38h52.5M39003 1370.38v-275h2.5" />
    <path
      fill="none"
      d="M39002 1230.38q11 1 11 15M38992 1245.38q0-15 10-15M38993 1245.38h-155 0-155"
    />
      <path strokeWidth={3} d="M43835.5 870.38h120v50h-120z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M43835.5 870.38h120v50h-120z" />
        <text fill="#000" transform="translate(43835.5 870.38)">
          <tspan x={13.488} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={68.719} y={21.22}>
            {" Dorotea Maria"}
          </tspan>
          <tspan x={60} y={38.02}>
            {"(1850-)"}
          </tspan>
        </text>
      </g>
    <path strokeDasharray="3 4" d="M43990.5 870.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43990.5 870.38h100v50h-100z" />
      <text fill="#000" transform="translate(43990.5 870.38)">
        <tspan x={50} y={21.22}>
          {"See Giuseppe"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1844-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M44755.5 1095.38h-20 0-20M43955.5 895.38h35M43900.5 820.38v25h0v25"
    />
      <path strokeWidth={3} d="M29250.5 1070.38h110v50h-110z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M29250.5 1070.38h110v50h-110z" />
        <text fill="#000" transform="translate(29250.5 1070.38)">
          <tspan
            x={24.102}
            y={21.22}
            fontFamily="Noto Color Emoji"
            fontSize={14}
          >
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={63.719} y={21.22} fontSize={14}>
            {" Giuseppe"}
          </tspan>
          <tspan x={55} y={38.02} fontSize={14}>
            {"(1844-)"}
          </tspan>
        </text>
      </g>
    <path strokeDasharray="3 4" d="M29060.5 1070.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M29060.5 1070.38h150v50h-150z" />
      <text fill="#000" transform="translate(29060.5 1070.38)">
        <tspan x={75} y={21.22}>
          {"See Dorotea Maria"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1850-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M29305.5 1070.38v-100h145v100M29360.5 895.38v67.5h0v7.5M29210.5 1095.38h40M8275.5 1395.38h35"
    />
    <path d="M7965.5 1230.38h115v30h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M7965.5 1230.38h115v30h-115z" />
      <text fill="#000" transform="translate(7965.5 1230.38)">
        <tspan x={30.863} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={19.62}>
          {" Lorenzo"}
        </tspan>
      </text>
    </g>
    <path d="M8130.5 1230.38h145v30h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M8130.5 1230.38h145v30h-145z" />
      <text fill="#000" transform="translate(8130.5 1230.38)">
        <tspan x={23.223} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={81.219} y={19.62}>
          {" Camilla Trafano"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M8080.5 1245.38h50M8105.5 1245.38v75h115v50" />
      <path strokeWidth={3} d="M27930.5 1070.38h95v50h-95z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M27930.5 1070.38h95v50h-95z" />
        <text fill="#000" transform="translate(27930.5 1070.38)">
          <tspan x={26.824} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={56.219} y={21.22}>
            {" Emilio"}
          </tspan>
          <tspan x={47.5} y={38.02}>
            {"(1836-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M28105.5 1070.38h110v50h-110z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28105.5 1070.38h110v50h-110z" />
        <text fill="#000" transform="translate(28105.5 1070.38)">
          <tspan x={22.09} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={63.719} y={21.22}>
            {" Rosa Grea"}
          </tspan>
          <tspan x={55} y={38.02}>
            {"(1850-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M28025.5 1095.38h80" />
      <path strokeWidth={3} d="M28020.5 1220.38h110v50h-110z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28020.5 1220.38h110v50h-110z" />
        <text fill="#000" transform="translate(28020.5 1220.38)">
          <tspan x={22.695} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={63.719} y={21.22}>
            {" Gerolamo"}
          </tspan>
          <tspan x={55} y={38.02}>
            {"(1872-1938)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M28220.5 1220.38h145v50h-145z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28220.5 1220.38h145v50h-145z" />
        <text fill="#000" transform="translate(28220.5 1220.38)">
          <tspan x={33.48} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={81.219} y={21.22}>
            {" Rosa Berruti"}
          </tspan>
          <tspan x={72.5} y={38.02}>
            {"(1874-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M28130.5 1245.38h90M28080.5 1095.38h-10v125" />
      <path strokeWidth={3} d="M28120.5 1370.38h110v50h-110z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28120.5 1370.38h110v50h-110z" />
        <text fill="#000" transform="translate(28120.5 1370.38)">
          <tspan x={34.32} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={63.719} y={21.22}>
            {" Emilio"}
          </tspan>
          <tspan x={55} y={38.02}>
            {"(1900-1994)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M27880.5 1370.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M27880.5 1370.38h150v50h-150z" />
        <text fill="#000" transform="translate(27880.5 1370.38)">
          <tspan x={28.688} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Raffaldi Teresa"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1905-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M28020.5 1520.38h110v50h-110z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28020.5 1520.38h110v50h-110z" />
        <text fill="#000" transform="translate(28020.5 1520.38)">
          <tspan x={27.738} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={63.719} y={21.22}>
            {" Carolina"}
          </tspan>
          <tspan x={55} y={38.02}>
            {"(1934-2023)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M28030.5 1395.38h90M28180.5 1245.38v62.5h0v62.5M28070.5 1395.38v62.5h0v62.5M28320.5 1545.38h-20 0-170"
    />
    <path d="M28150.5 1680.38h155v30h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M28150.5 1680.38h155v30h-155z" />
      <text fill="#000" transform="translate(28150.5 1680.38)">
        <tspan x={32.57} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={86.219} y={19.62}>
          {" Paola Pogliani"}
        </tspan>
      </text>
    </g>
    <path d="M28355.5 1680.38h155v30h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M28355.5 1680.38h155v30h-155z" />
      <text fill="#000" transform="translate(28355.5 1680.38)">
        <tspan x={21.824} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={86.219} y={19.62}>
          {" Francesco Lepore"}
        </tspan>
      </text>
    </g>
    <path d="M28255.5 1830.38h155v30h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M28255.5 1830.38h155v30h-155z" />
      <text fill="#000" transform="translate(28255.5 1830.38)">
        <tspan x={30.141} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={86.219} y={19.62}>
          {" Andrea Lepore"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M28225.5 1545.38v67.5h0v67.5M28305.5 1695.38h50M28330.5 1695.38v67.5h0v67.5M28355.5 895.38v62.5h0v62.5"
    />
    <path d="M26450.5 1820.38h185v50h-185z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26450.5 1820.38h185v50h-185z" />
      <text fill="#000" transform="translate(26450.5 1820.38)">
        <tspan x={18.563} y={21.22} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={103.137} y={21.22}>
          {"Madeline Rose Cutrone"}
        </tspan>
        <tspan x={92.5} y={38.02} fontSize={14}>
          {"(1995-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M26410.5 1845.38h40" />
    <path d="M25875.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25875.5 1970.38h150v50h-150z" />
      <text fill="#000" transform="translate(25875.5 1970.38)">
        <tspan x={26.383} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Logan Edmund"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(2003-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M26055.5 1845.38v75" />
      <path strokeWidth={3} d="M27600.5 1070.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M27600.5 1070.38h100v50h-100z" />
        <text fill="#000" transform="translate(27600.5 1070.38)">
          <tspan
            x={30.941}
            y={21.22}
            fontFamily="Noto Color Emoji"
            fontSize={14}
          >
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22} fontSize={14}>
            {" Paolo"}
          </tspan>
          <tspan x={50} y={38.02} fontSize={14}>
            {"(1831-1908)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M27750.5 1070.38h130v50h-130z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M27750.5 1070.38h130v50h-130z" />
        <text fill="#000" transform="translate(27750.5 1070.38)">
          <tspan x={28.543} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={73.719} y={21.22}>
            {" Giuseppina"}
          </tspan>
          <tspan x={65} y={38.02}>
            {"(1842-1930)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M27650.5 820.63v79.75h0v170M27700.5 1095.38h50M27815.5 1070.38v-50h540v-50M27640.5 844.88q0-10 10-10M27660.5 844.88q0-10-10-10M27063 870.38v-25h577.5v-.5M27660.5 845.38h592.5M28265.5 845.38v12.5h0v12.5"
    />
      <path strokeWidth={3} d="M51170.5 1070.38h195v50h-195z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M51170.5 1070.38h195v50h-195z" />
        <text fill="#000" transform="translate(51170.5 1070.38)">
          <tspan
            x={31.695}
            y={21.22}
            fontFamily="Noto Color Emoji"
            fontSize={14}
          >
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={106.219} y={21.22} fontSize={14}>
            {" Giuseppe Luigi (Joe)"}
          </tspan>
          <tspan x={97.5} y={38.02} fontSize={14}>
            {"(1884-1962)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M50950.5 895.38v37.5h0v37.5M29088 395.38v40h0v35M5475.5 1245.38h-15 0-15"
    />
    <path strokeDasharray="4 5" d="M5155.5 1220.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M5155.5 1220.38h135v50h-135z" />
      <text fill="#000" fontSize={14} transform="translate(5155.5 1220.38)">
        <tspan x={67.5} y={21.22}>
          {"See Secondo Verrua"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1871-)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M5025.5 1220.38h95v50h-95z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M5025.5 1220.38h95v50h-95z" />
        <text fill="#000" transform="translate(5025.5 1220.38)">
          <tspan x={25.137} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={56.219} y={21.22}>
            {" Valeria"}
          </tspan>
          <tspan x={47.5} y={38.02}>
            {"(1877-1960)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M5120.5 1245.38h35" />
    <path fill="none" strokeDasharray="5 6" d="M5223 1220.38v-25h160v25" />
    <path fill="none" d="M5073 1220.38v-50h237.5M5305.5 1170.38h230" />
      <path strokeWidth={3} d="M26900.5 1070.38h110v50h-110z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M26900.5 1070.38h110v50h-110z" />
        <text fill="#000" transform="translate(26900.5 1070.38)">
          <tspan x={37.496} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={63.719} y={21.22}>
            {" Clara"}
          </tspan>
          <tspan x={55} y={38.02}>
            {"(1852-1892)"}
          </tspan>
        </text>
      </g>
    <path d="M27045.5 1070.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27045.5 1070.38h125v50h-125z" />
      <text fill="#000" transform="translate(27045.5 1070.38)">
        <tspan x={25.656} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Lino Verrua"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1848-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M27010.5 1095.38h35M26955.5 970.38v50h0v50" />
    <path d="M27470.5 1220.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27470.5 1220.38h150v50h-150z" />
      <text fill="#000" transform="translate(27470.5 1220.38)">
        <tspan x={24.309} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Secondo Verrua"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1871-)"}
        </tspan>
      </text>
    </g>
    <path d="M26870.5 1220.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26870.5 1220.38h150v50h-150z" />
      <text fill="#000" transform="translate(26870.5 1220.38)">
        <tspan x={31.938} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Teresa Verrua"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1881-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M26945.5 1220.38v-50h600v50M27025.5 1095.38v37.5h0v37.5"
    />
    <path strokeDasharray="3 4" d="M27070.5 1220.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27070.5 1220.38h100v50h-100z" />
      <text fill="#000" transform="translate(27070.5 1220.38)">
        <tspan x={50} y={21.22}>
          {"See Luigi"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1879-1966)"}
        </tspan>
      </text>
    </g>
    <path strokeDasharray="3 4" d="M27270.5 1220.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27270.5 1220.38h150v50h-150z" />
      <text fill="#000" transform="translate(27270.5 1220.38)">
        <tspan x={75} y={21.22}>
          {"See Valeria"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1877-1960)"}
        </tspan>
      </text>
    </g>
    <path fill="none" strokeDasharray="3 4" d="M27120.5 1220.38v-30h225v30" />
    <path fill="none" d="M27020.5 1245.38h50M27420.5 1245.38h50" />
    <path d="M27385.5 1380.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27385.5 1380.38h125v30h-125z" />
      <text fill="#000" transform="translate(27385.5 1380.38)">
        <tspan x={23.125} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Clara Verrua"}
        </tspan>
      </text>
    </g>
    <path d="M27575.5 1380.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27575.5 1380.38h125v30h-125z" />
      <text fill="#000" transform="translate(27575.5 1380.38)">
        <tspan x={19.012} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Luigi Barberis"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M27510.5 1395.38h65M27445.5 1245.38v67.5h0v67.5" />
    <path d="M27490.5 1530.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27490.5 1530.38h125v30h-125z" />
      <text fill="#000" transform="translate(27490.5 1530.38)">
        <tspan x={13.336} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Valeria Barberis"}
        </tspan>
      </text>
    </g>
    <path d="M27680.5 1530.38h155v30h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27680.5 1530.38h155v30h-155z" />
      <text fill="#000" transform="translate(27680.5 1530.38)">
        <tspan x={23.977} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={86.219} y={19.62}>
          {" Dino Degiovanni"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M27615.5 1545.38h65M27545.5 1395.38v67.5h0v67.5" />
    <path d="M27570.5 1680.38h185v30h-185z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M27570.5 1680.38h185v30h-185z" />
      <text fill="#000" transform="translate(27570.5 1680.38)">
        <tspan x={15.168} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={101.219} y={19.62}>
          {" Gian Cesare  Degiovanni"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M27650.5 1545.38v67.5h0v67.5M9350.5 1845.38h-25 0-25"
    />
    <path d="M9350.5 1817.88h120v55h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9350.5 1817.88h120v55h-120z" />
      <text fill="#000" transform="translate(9350.5 1817.88)">
        <tspan x={14.539} y={23.72} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={68.719} y={23.72}>
          {" Lisa Tokuyashi"}
        </tspan>
        <tspan x={60} y={40.52}>
          {"(1989-)"}
        </tspan>
      </text>
    </g>
    <path d="M9200.5 1820.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9200.5 1820.38h100v50h-100z" />
      <text fill="#000" transform="translate(9200.5 1820.38)">
        <tspan x={11.734} y={21.22} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22} fontSize={14}>
          {" Samyel Orsi"}
        </tspan>
        <tspan x={50} y={38.02} fontSize={14}>
          {"(1990-)"}
        </tspan>
      </text>
    </g>
    <path d="M9670.5 1675.38h150v40h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9670.5 1675.38h150v40h-150z" />
      <text fill="#000" transform="translate(9670.5 1675.38)">
        <tspan x={15.035} y={24.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={24.62}>
          {" Ronald D Reynolds"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M9860.5 1695.38h-20 0-20" />
    <path d="M9755.5 1820.38h170v50h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9755.5 1820.38h170v50h-170z" />
      <text fill="#000" transform="translate(9755.5 1820.38)">
        <tspan x={28.07} y={21.22} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={93.719} y={21.22} fontSize={14}>
          {" Timothy Reynolds"}
        </tspan>
        <tspan x={85} y={38.02} fontSize={14}>
          {"(1991-)"}
        </tspan>
      </text>
    </g>
    <path d="M9535.5 1830.38h170v30h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9535.5 1830.38h170v30h-170z" />
      <text fill="#000" transform="translate(9535.5 1830.38)">
        <tspan x={39.363} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={93.719} y={19.62}>
          {" Savannah Zito"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M9840.5 1695.38v60h0v65M9705.5 1845.38h50" />
    <path d="M9670.5 1970.38h130v50h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9670.5 1970.38h130v50h-130z" />
      <text fill="#000" transform="translate(9670.5 1970.38)">
        <tspan x={21.277} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={73.719} y={21.22}>
          {" Levi Reynolds"}
        </tspan>
        <tspan x={65} y={38.02}>
          {"(2021-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M9730.5 1845.38v62.5h0v62.5" />
    <path d="M9970.5 1825.38h140v40h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9970.5 1825.38h140v40h-140z" />
      <text fill="#000" transform="translate(9970.5 1825.38)">
        <tspan x={16.367} y={24.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.719} y={24.62}>
          {" Jackson Gillespie"}
        </tspan>
      </text>
    </g>
    <path d="M10125.5 1825.38h125v40h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M10125.5 1825.38h125v40h-125z" />
      <text fill="#000" transform="translate(10125.5 1825.38)">
        <tspan x={19.363} y={24.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={24.62}>
          {" Sam Gillespie"}
        </tspan>
      </text>
    </g>
    <path d="M10265.5 1825.38h125v40h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M10265.5 1825.38h125v40h-125z" />
      <text fill="#000" transform="translate(10265.5 1825.38)">
        <tspan x={19.59} y={24.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={24.62}>
          {" Alex Gillespie"}
        </tspan>
      </text>
    </g>
    <path d="M10403 1825.38h125v40h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M10403 1825.38h125v40h-125z" />
      <text fill="#000" transform="translate(10403 1825.38)">
        <tspan x={19.027} y={24.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={24.62}>
          {" Nick Gillespie"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M10040.5 1825.38v-55h425v55M10190.5 1825.38v-55M10330.5 1825.38v-55M9990.5 1695.38v45h250v30"
    />
    <path d="M9050.5 1820.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M9050.5 1820.38h100v50h-100z" />
      <text fill="#000" transform="translate(9050.5 1820.38)">
        <tspan x={12.48} y={21.22} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22} fontSize={14}>
          {" Joseph Orsi"}
        </tspan>
        <tspan x={50} y={38.02} fontSize={14}>
          {"(1987-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M9100.5 1820.38v-50h150v50M9165.5 1695.38v37.5h0v37.5"
    />
    <path d="M8620.5 1820.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M8620.5 1820.38h100v50h-100z" />
      <text fill="#000" transform="translate(8620.5 1820.38)">
        <tspan x={13.152} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22}>
          {" Allison Orsi"}
        </tspan>
        <tspan x={50} y={38.02}>
          {"(1982-)"}
        </tspan>
      </text>
    </g>
    <path d="M8750.5 1820.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M8750.5 1820.38h120v50h-120z" />
      <text fill="#000" transform="translate(8750.5 1820.38)">
        <tspan x={13.305} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Stephanie Orsi"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1985-)"}
        </tspan>
      </text>
    </g>
    <path d="M8890.5 1820.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M8890.5 1820.38h120v50h-120z" />
      <text fill="#000" transform="translate(8890.5 1820.38)">
        <tspan x={17.332} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={68.719} y={21.22}>
          {" Nicholas Orsi"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1986-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M8670.5 1820.38v-50h280v50M8815.5 1820.38v-27.5h0v-97.5"
    />
    <g transform="translate(49070.5 850.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"189"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(49075.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"190"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(49265.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"191"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(49730.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"192"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M49870.5 1220.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M49870.5 1220.38h150v50h-150z" />
      <text fill="#000" transform="translate(49870.5 1220.38)">
        <tspan x={26.176} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Paolo Casalone"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1907-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M49935.5 1095.38v62.5h0v62.5" />
    <path d="M49965.5 680.38h140v30h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M49965.5 680.38h140v30h-140z" />
      <text fill="#000" transform="translate(49965.5 680.38)">
        <tspan x={22.664} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={19.62}>
          {" Luigia Gavazza"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M49965.5 695.38h-22.5 0-12.5" />
    <path d="M50310.5 680.38h140v30h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M50310.5 680.38h140v30h-140z" />
      <text fill="#000" transform="translate(50310.5 680.38)">
        <tspan x={20.953} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={19.62}>
          {" Felice Casalone"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M50270.5 695.38h40M50295.5 870.38v-87.5h0v-87.5" />
    <path strokeDasharray="3 4" d="M50140.5 670.38h130v50h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M50140.5 670.38h130v50h-130z" />
      <text fill="#000" transform="translate(50140.5 670.38)">
        <tspan x={65} y={21.22}>
          {"See Angela"}
        </tspan>
        <tspan x={65} y={38.02}>
          {"(1833-1871)"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M28265.5 1070.38h110v50h-110z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28265.5 1070.38h110v50h-110z" />
        <text fill="#000" transform="translate(28265.5 1070.38)">
          <tspan x={31.566} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={63.719} y={21.22}>
            {" Angela"}
          </tspan>
          <tspan x={55} y={38.02}>
            {"(1833-1871)"}
          </tspan>
        </text>
      </g>
    <path strokeDasharray="3 4" d="M28395.5 1080.38h130v30h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M28395.5 1080.38h130v30h-130z" />
      <text fill="#000" transform="translate(28395.5 1080.38)">
        <tspan x={65} y={19.62}>
          {"See Felice Casalone"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M28375.5 1095.38h20M28320.5 1020.38v25h0v25" />
      <path strokeWidth={3} d="M50980.5 870.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M50980.5 870.38h100v50h-100z" />
        <text fill="#000" fontSize={14} transform="translate(50980.5 870.38)">
          <tspan x={33.313} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Luigi"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1841-1918)"}
          </tspan>
        </text>
      </g>
    <path d="M50780.5 880.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M50780.5 880.38h150v30h-150z" />
      <text fill="#000" transform="translate(50780.5 880.38)">
        <tspan x={14.922} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Margherita Raviola"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M50765.5 1070.38h170v50h-170z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M50765.5 1070.38h170v50h-170z" />
        <text fill="#000" fontSize={14} transform="translate(50765.5 1070.38)">
          <tspan x={26.758} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={93.719} y={21.22}>
            {" Maddalena Cecilia"}
          </tspan>
          <tspan x={85} y={38.02}>
            {"(1866-)"}
          </tspan>
        </text>
      </g>
    <path strokeDasharray="3 4" d="M50540.5 1070.38h160v50h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M50540.5 1070.38h160v50h-160z" />
      <text fill="#000" transform="translate(50540.5 1070.38)">
        <tspan x={80} y={21.22}>
          {"See Ferdinando Lorenzo"}
        </tspan>
        <tspan x={80} y={38.02}>
          {"(1858-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M50850.5 1070.38v-100h417.5v100M50930.5 895.38h50M50700.5 1095.38h65"
    />
      <path strokeWidth={3} d="M51770.5 870.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M51770.5 870.38h100v50h-100z" />
        <text fill="#000" transform="translate(51770.5 870.38)">
          <tspan x={13.063} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Archangela"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1848-)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M52395.5 870.38h140v50h-140z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M52395.5 870.38h140v50h-140z" />
        <text fill="#000" transform="translate(52395.5 870.38)">
          <tspan x={15.883} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={78.719} y={21.22}>
            {" Francesco Capra"}
          </tspan>
          <tspan x={70} y={38.02}>
            {"(1838-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M52000.5 1070.38h-120 0-120" />
      <path strokeWidth={3} d="M51925.5 1070.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M51925.5 1070.38h150v50h-150z" />
        <text fill="#000" transform="translate(51925.5 1070.38)">
          <tspan x={14.781} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Arnoldo Francesco"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1890-)"}
          </tspan>
        </text>
      </g>
    <path d="M52325.5 1080.38h200v30h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M52325.5 1080.38h200v30h-200z" />
      <text fill="#000" transform="translate(52325.5 1080.38)">
        <tspan x={27.141} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={108.719} y={19.62}>
          {" Giovanni Gambertoglio"}
        </tspan>
      </text>
    </g>
      <path strokeWidth={3} d="M51290.5 1220.38h100v50h-100z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M51290.5 1220.38h100v50h-100z" />
        <text fill="#000" transform="translate(51290.5 1220.38)">
          <tspan x={30.719} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={58.719} y={21.22}>
            {" Felice"}
          </tspan>
          <tspan x={50} y={38.02}>
            {"(1914-1915)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M51340.5 1220.38v-40h665v50M53150.5 1095.38h-15 0-15M53033 1220.38v-50h200v50M53135.5 1095.38v37.5h0v37.5M52930.5 1245.38h2.5v135M53173 1380.38v-60h127.5v60M53235.5 1270.38v25h0v25M53445.5 1220.38v-50h170v50M53530.5 1095.38v37.5h0v37.5M53755.5 1395.38h55M53700.5 1245.38h-2.5v125M53785.5 1395.38v62.5h0v62.5M53840.5 1545.38h65M53905.5 1095.38h40M54250.5 1220.38v-50h185v50M54345.5 1095.38v37.5h0v37.5M54080.5 1370.38v-50h160v50M54160.5 1245.38v40h0v35M53203 1070.38v-100h1025v100M53660.5 895.38h70M53695.5 895.38v35h0v40M53430.5 1070.38v-50h0v-50M53835.5 1070.38v-50h0v-50"
    />
    <path
      fill="none"
      strokeDasharray="3 4"
      d="M49155.5 870.38v-100h775M49940 755.38q11 1 11 15M49930 770.38q0-15 10-15M50294.5 755.38q11 1 11 15M50284.5 770.38q0-15 10-15M49950.5 770.38h335M50305.5 770.38h315v300"
    />
    <path fill="none" d="M51550.5 1095.38v37.5h0v47.5" />
    <path d="M50970.5 1070.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M50970.5 1070.38h150v50h-150z" />
      <text fill="#000" transform="translate(50970.5 1070.38)">
        <tspan x={29.582} y={21.22} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={83.719} y={21.22} fontSize={14}>
          {" Teresa Poncini"}
        </tspan>
        <tspan x={75} y={38.02} fontSize={14}>
          {"(1894-1981)"}
        </tspan>
      </text>
    </g>
    <path d="M51055.5 1220.38h185v50h-185z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M51055.5 1220.38h185v50h-185z" />
      <text fill="#000" transform="translate(51055.5 1220.38)">
        <tspan x={26.105} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={101.219} y={21.22}>
          {" Louis (Luigi) Dominic"}
        </tspan>
        <tspan x={92.5} y={38.02}>
          {"(1910-1999)"}
        </tspan>
      </text>
    </g>
    <path d="M50805.5 1220.38h185v50h-185z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M50805.5 1220.38h185v50h-185z" />
      <text fill="#000" transform="translate(50805.5 1220.38)">
        <tspan x={35.039} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={101.219} y={21.22}>
          {" Eleanor Rosa Pace"}
        </tspan>
        <tspan x={92.5} y={38.02}>
          {"(1911-1980)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M50990.5 1245.38h65M51145.5 1095.38v62.5h0v62.5" />
    <g transform="translate(51155.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"193"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(51720.5 1050.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"194"}
          </tspan>
        </text>
      </g>
    </g>
      <path strokeWidth={3} d="M4070.5 1220.38h200v50h-200z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M4070.5 1220.38h200v50h-200z" />
        <text fill="#000" transform="translate(4070.5 1220.38)">
          <tspan
            x={27.676}
            y={21.22}
            fontFamily="Noto Color Emoji"
            fontSize={14}
          >
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={108.719} y={21.22} fontSize={14}>
            {" Maria Luigia Ermelinda"}
          </tspan>
          <tspan x={100} y={38.02} fontSize={14}>
            {"(1870-1956)"}
          </tspan>
        </text>
      </g>
      <path strokeWidth={3} d="M3770.5 1220.38h200v50h-200z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M3770.5 1220.38h200v50h-200z" />
        <text fill="#000" transform="translate(3770.5 1220.38)">
          <tspan x={35.289} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={108.719} y={21.22}>
            {" Pietro Gambertoglio"}
          </tspan>
          <tspan x={100} y={38.02}>
            {"(1866-1941)"}
          </tspan>
        </text>
      </g>
    <path
      fill="none"
      d="M3970.5 1245.38h100M4404.5 1155.38q11 0 11 15M4394.5 1170.38q0-15 10-15M4170.5 1220.38v-50h225M4845.5 1220.38v-50h-430M4820.5 1095.38v40h0v35"
    />
    <path d="M3935.5 1370.38h175v50h-175z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M3935.5 1370.38h175v50h-175z" />
      <text fill="#000" transform="translate(3935.5 1370.38)">
        <tspan x={26.359} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={96.219} y={21.22}>
          {" Rosa Gambertoglio"}
        </tspan>
        <tspan x={87.5} y={38.02}>
          {"(1899-1991)"}
        </tspan>
      </text>
    </g>
    <path d="M3695.5 1370.38h175v50h-175z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M3695.5 1370.38h175v50h-175z" />
      <text fill="#000" transform="translate(3695.5 1370.38)">
        <tspan x={30.867} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={96.219} y={21.22}>
          {" Agostino Garrone"}
        </tspan>
        <tspan x={87.5} y={38.02}>
          {"(1894-1980)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M3870.5 1395.38h65" />
    <path d="M3813 1520.38h175v50h-175z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M3813 1520.38h175v50h-175z" />
      <text fill="#000" transform="translate(3813 1520.38)">
        <tspan x={87.5} y={21.22}>
          {"\uD83C\uDDFA\uD83C\uDDF8 Norma Luise Garrone"}
        </tspan>
        <tspan x={87.5} y={38.02}>
          {"(1921-2002)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M3900.5 1395.38v62.5h0v62.5" />
    <path d="M4065.5 1520.38h305v50h-305z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M4065.5 1520.38h305v50h-305z" />
      <text fill="#000" transform="translate(4065.5 1520.38)">
        <tspan x={152.5} y={21.22}>
          {"\uD83C\uDDFA\uD83C\uDDF8 Clarence (Buster) Augustus McClellan, Jr"}
        </tspan>
        <tspan x={152.5} y={38.02}>
          {"(1915-2010)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M3988 1545.38h77.5" />
    <path d="M3938 1680.38h175v30h-175z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M3938 1680.38h175v30h-175z" />
      <text fill="#000" transform="translate(3938 1680.38)">
        <tspan x={87.5} y={19.62}>
          {"\uD83C\uDDFA\uD83C\uDDF8 Bruce McClellan"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M4025.5 1545.38v67.5h0v67.5" />
    <g transform="translate(4050.5 1200.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"195"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(22040.5 1645.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"197"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(23195.5 1500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"196"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M8625.5 1380.38h170v30h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M8625.5 1380.38h170v30h-170z" />
      <text fill="#000" transform="translate(8625.5 1380.38)">
        <tspan x={15.805} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={93.719} y={19.62}>
          {" Giovanni Riccomagno"}
        </tspan>
      </text>
    </g>
    <path d="M28530.5 1530.38h180v30h-180z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M28530.5 1530.38h180v30h-180z" />
      <text fill="#000" fontSize={14} transform="translate(28530.5 1530.38)">
        <tspan x={34.383} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={98.719} y={19.62}>
          {" Pierluigi Pogliano"}
        </tspan>
      </text>
    </g>
    <path d="M28845.5 1530.38h130v30h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M28845.5 1530.38h130v30h-130z" />
      <text fill="#000" fontSize={14} transform="translate(28845.5 1530.38)">
        <tspan x={18.68} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={73.719} y={19.62}>
          {" Carla Pogliano"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M28910.5 1530.38v-60h-350v-55M28620.5 1530.38v-30h0v-30"
    />
    <path d="M29020.5 1530.38h140v30h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M29020.5 1530.38h140v30h-140z" />
      <text fill="#000" fontSize={14} transform="translate(29020.5 1530.38)">
        <tspan x={16.043} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={78.719} y={19.62}>
          {" Attilio Accornero"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M28975.5 1545.38h45" />
    <path d="M28770.5 1680.38h195v30h-195z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M28770.5 1680.38h195v30h-195z" />
      <text fill="#000" fontSize={14} transform="translate(28770.5 1680.38)">
        <tspan x={23.262} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={106.219} y={19.62}>
          {" Maria Teresa Accornero"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M29000.5 1545.38v67.5h-145v67.5" />
    <path d="M28570.5 1680.38h155v30h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M28570.5 1680.38h155v30h-155z" />
      <text fill="#000" transform="translate(28570.5 1680.38)">
        <tspan x={20.473} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={86.219} y={19.62}>
          {" Giovanni Vogliotti"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M28770.5 1695.38h-22.5 0-22.5" />
    <path d="M28575.5 1830.38h155v30h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M28575.5 1830.38h155v30h-155z" />
      <text fill="#000" transform="translate(28575.5 1830.38)">
        <tspan x={34.141} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={86.219} y={19.62}>
          {" Elisa Vogliotti"}
        </tspan>
      </text>
    </g>
    <path d="M28775.5 1830.38h155v30h-155z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M28775.5 1830.38h155v30h-155z" />
      <text fill="#000" transform="translate(28775.5 1830.38)">
        <tspan x={31.184} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={86.219} y={19.62}>
          {" Elena Vogliotti"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M28653 1830.38v-60h200v60M28750.5 1695.38v37.5h0v37.5"
    />
    <g transform="translate(20170.5 1500.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"198"}
          </tspan>
        </text>
      </g>
    </g>
    <g transform="translate(25605.5 1495.38)">
      <circle cx={20} cy={20} r={20} />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M0 0h40v40H0z" />
        <text fill="#000">
          <tspan x={20} y={24.62}>
            {"199"}
          </tspan>
        </text>
      </g>
    </g>
    <path d="M29025.5 1680.38h195v30h-195z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M29025.5 1680.38h195v30h-195z" />
      <text fill="#000" fontSize={14} transform="translate(29025.5 1680.38)">
        <tspan x={12.242} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={106.219} y={19.62}>
          {" Lorenzo Camillo Accornero"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M29123 1680.38v-67.5h-122.5v-67.5M51560.5 1245.38h60M51120.5 1095.38h50M51485.5 1220.38v-20h0v-20"
    />
    <path d="M46670.5 1370.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M46670.5 1370.38h200v50h-200z" />
      <text fill="#000" transform="translate(46670.5 1370.38)">
        <tspan x={18.887} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Harry Louis Grattapaglia"}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(1912-1972)"}
        </tspan>
      </text>
    </g>
    <path d="M46210.5 1520.38h265v50h-265z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M46210.5 1520.38h265v50h-265z" />
      <text fill="#000" transform="translate(46210.5 1520.38)">
        <tspan x={31.313} y={21.22} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={141.219} y={21.22} fontSize={14}>
          {" Richard Dennis (Dick) Lewis, Sr"}
        </tspan>
        <tspan x={132.5} y={38.02} fontSize={14}>
          {"(1940-1990)"}
        </tspan>
      </text>
    </g>
    <path d="M46540.5 1520.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M46540.5 1520.38h200v50h-200z" />
      <text fill="#000" transform="translate(46540.5 1520.38)">
        <tspan x={13.156} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Camille Louis Grattapaglia"}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(1938-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M46605.5 1395.38h65M46475.5 1545.38h65M46640.5 1395.38v62.5h0v62.5"
    />
    <path d="M45895.5 1670.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M45895.5 1670.38h145v50h-145z" />
      <text fill="#000" transform="translate(45895.5 1670.38)">
        <tspan x={32.156} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Cathy Lewis"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1957-)"}
        </tspan>
      </text>
    </g>
    <path d="M46095.5 1680.38h145v30h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M46095.5 1680.38h145v30h-145z" />
      <text fill="#000" transform="translate(46095.5 1680.38)">
        <tspan x={31.961} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={81.219} y={19.62}>
          {" Mike Hamel"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M46040.5 1695.38h55" />
    <path d="M46295.5 1670.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M46295.5 1670.38h145v50h-145z" />
      <text fill="#000" transform="translate(46295.5 1670.38)">
        <tspan x={35.711} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Gina Lewis"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1969-)"}
        </tspan>
      </text>
    </g>
    <path d="M46495.5 1680.38h145v30h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M46495.5 1680.38h145v30h-145z" />
      <text fill="#000" transform="translate(46495.5 1680.38)">
        <tspan x={16.117} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={81.219} y={19.62}>
          {" Peter B Gardiner"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M46440.5 1695.38h55" />
    <path d="M46695.5 1670.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M46695.5 1670.38h145v50h-145z" />
      <text fill="#000" transform="translate(46695.5 1670.38)">
        <tspan x={25.984} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Richard Lewis"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1966-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M45968 1670.38v-50h800v50M46505.5 1545.38v40h0v35" />
    <path d="M45895.5 1820.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M45895.5 1820.38h145v50h-145z" />
      <text fill="#000" transform="translate(45895.5 1820.38)">
        <tspan x={19.164} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" David M. Hamel"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(1985-)"}
        </tspan>
      </text>
    </g>
    <path d="M46090.5 1820.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M46090.5 1820.38h145v50h-145z" />
      <text fill="#000" transform="translate(46090.5 1820.38)">
        <tspan x={24.129} y={21.22} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={81.219} y={21.22} fontSize={14}>
          {" Ryan S. Hamel"}
        </tspan>
        <tspan x={72.5} y={38.02} fontSize={14}>
          {"(1990-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M45968 1820.38v-50h195v50M46065.5 1695.38v75" />
    <path d="M46285.5 1820.38h180v50h-180z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M46285.5 1820.38h180v50h-180z" />
      <text fill="#000" transform="translate(46285.5 1820.38)">
        <tspan x={24.5} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={98.719} y={21.22}>
          {" Caeden B, Gardiner"}
        </tspan>
        <tspan x={90} y={38.02}>
          {"(2007-)"}
        </tspan>
      </text>
    </g>
    <path d="M46525.5 1820.38h145v50h-145z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M46525.5 1820.38h145v50h-145z" />
      <text fill="#000" transform="translate(46525.5 1820.38)">
        <tspan x={11.203} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={81.219} y={21.22}>
          {" Emma K. Gardiner"}
        </tspan>
        <tspan x={72.5} y={38.02}>
          {"(2007-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M46375.5 1820.38v-50h222.5v50M46470.5 1695.38v75" />
    <path d="M47220.5 1370.38h180v50h-180z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M47220.5 1370.38h180v50h-180z" />
      <text fill="#000" transform="translate(47220.5 1370.38)">
        <tspan x={26.293} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={98.719} y={21.22}>
          {" Beatrice MacMillan"}
        </tspan>
        <tspan x={90} y={38.02}>
          {"(1929-1992)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M47400.5 1395.38h55" />
    <path d="M46970.5 1520.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M46970.5 1520.38h150v50h-150z" />
      <text fill="#000" transform="translate(46970.5 1520.38)">
        <tspan x={31.906} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Paul Michael"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1960-)"}
        </tspan>
      </text>
    </g>
    <path d="M47170.5 1530.38h200v30h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M47170.5 1530.38h200v30h-200z" />
      <text fill="#000" transform="translate(47170.5 1530.38)">
        <tspan x={27.391} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={19.62}>
          {" Kimberly Maria Lange"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M47120.5 1545.38h50" />
    <path d="M47405.5 1520.38h100v50h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M47405.5 1520.38h100v50h-100z" />
      <text fill="#000" transform="translate(47405.5 1520.38)">
        <tspan x={23.934} y={21.22} fontFamily="Noto Color Emoji" fontSize={14}>
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={21.22} fontSize={14}>
          {" Angelo "}
        </tspan>
        <tspan x={50} y={38.02} fontSize={14}>
          {"(1968-)"}
        </tspan>
      </text>
    </g>
    <path d="M47555.5 1530.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M47555.5 1530.38h150v30h-150z" />
      <text fill="#000" transform="translate(47555.5 1530.38)">
        <tspan x={21.457} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Debbie Eatherly"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M47505.5 1545.38h50" />
    <path d="M47745.5 1530.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M47745.5 1530.38h100v30h-100z" />
      <text fill="#000" transform="translate(47745.5 1530.38)">
        <tspan x={33.121} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Debi"}
        </tspan>
      </text>
    </g>
    <path d="M47895.5 1530.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M47895.5 1530.38h150v30h-150z" />
      <text fill="#000" transform="translate(47895.5 1530.38)">
        <tspan x={34.723} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Shackleford"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M47845.5 1545.38h50" />
    <path d="M48080.5 1530.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M48080.5 1530.38h100v30h-100z" />
      <text fill="#000" transform="translate(48080.5 1530.38)">
        <tspan x={24.188} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Melody"}
        </tspan>
      </text>
    </g>
    <path d="M48230.5 1530.38h115v30h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M48230.5 1530.38h115v30h-115z" />
      <text fill="#000" transform="translate(48230.5 1530.38)">
        <tspan x={25.762} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={66.219} y={19.62}>
          {" Costance"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M48180.5 1545.38h50" />
    <path d="M46970.5 1670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M46970.5 1670.38h150v50h-150z" />
      <text fill="#000" transform="translate(46970.5 1670.38)">
        <tspan x={27.961} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Felicia Amaria"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1982-)"}
        </tspan>
      </text>
    </g>
    <path d="M47170.5 1670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M47170.5 1670.38h150v50h-150z" />
      <text fill="#000" transform="translate(47170.5 1670.38)">
        <tspan x={40.16} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Mary Elisa"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1982-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M47045.5 1670.38v-50h200v50M47145.5 1545.38v37.5h0v37.5M47045.5 1520.38v-50h1085v60M47795.5 1530.38v-30h0v-30M47455.5 1520.38v-25h0v-25M47425.5 1395.38v37.5h0v37.5"
    />
    <path d="M48570.5 1370.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M48570.5 1370.38h200v50h-200z" />
      <text fill="#000" transform="translate(48570.5 1370.38)">
        <tspan x={43.199} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Clara Ethel Cross"}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(1924-1995)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M48770.5 1395.38h85" />
    <path d="M48420.5 1520.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M48420.5 1520.38h150v50h-150z" />
      <text fill="#000" transform="translate(48420.5 1520.38)">
        <tspan x={35.215} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Steven Paul"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1950-)"}
        </tspan>
      </text>
    </g>
    <path d="M48620.5 1530.38h200v30h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M48620.5 1530.38h200v30h-200z" />
      <text fill="#000" transform="translate(48620.5 1530.38)">
        <tspan x={44.68} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={19.62}>
          {" Gay Mae Furrow"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M48570.5 1545.38h50" />
    <path d="M48915.5 1520.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M48915.5 1520.38h150v50h-150z" />
      <text fill="#000" transform="translate(48915.5 1520.38)">
        <tspan x={28.266} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Stacey Wayne"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1953-)"}
        </tspan>
      </text>
    </g>
    <path d="M49120.5 1530.38h200v30h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M49120.5 1530.38h200v30h-200z" />
      <text fill="#000" transform="translate(49120.5 1530.38)">
        <tspan x={50.863} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={19.62}>
          {" Jana Lee Binns"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M49065.5 1545.38h55M48495.5 1520.38v-50h495v50M48810.5 1395.38v35h0v40"
    />
    <path d="M48265.5 1670.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M48265.5 1670.38h150v50h-150z" />
      <text fill="#000" transform="translate(48265.5 1670.38)">
        <tspan x={33.07} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Nathan Paul"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1972-)"}
        </tspan>
      </text>
    </g>
    <path d="M48465.5 1680.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M48465.5 1680.38h150v30h-150z" />
      <text fill="#000" transform="translate(48465.5 1680.38)">
        <tspan x={35.926} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={19.62}>
          {" Tyler James"}
        </tspan>
      </text>
    </g>
    <path d="M48665.5 1680.38h115v30h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M48665.5 1680.38h115v30h-115z" />
      <text fill="#000" fontSize={14} transform="translate(48665.5 1680.38)">
        <tspan x={27.328} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={66.219} y={19.62}>
          {" Brandon"}
        </tspan>
      </text>
    </g>
    <path d="M48815.5 1670.38h110v50h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M48815.5 1670.38h110v50h-110z" />
      <text fill="#000" fontSize={14} transform="translate(48815.5 1670.38)">
        <tspan x={36.766} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={63.719} y={21.22}>
          {" Jesse"}
        </tspan>
        <tspan x={55} y={38.02}>
          {"(1975-)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M48340.5 1670.38v-50h530v50M48595.5 1545.38v37.5h0v37.5"
    />
    <path fill="none" d="M48545.5 1620.38h-5v60M48720.5 1620.38v30h0v30" />
    <path d="M49670.5 1370.38h200v50h-200z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M49670.5 1370.38h200v50h-200z" />
      <text fill="#000" transform="translate(49670.5 1370.38)">
        <tspan x={26.289} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={108.719} y={21.22}>
          {" Patricia Pauline Butier"}
        </tspan>
        <tspan x={100} y={38.02}>
          {"(1923-2011)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M49615.5 1395.38h55" />
    <path d="M49390.5 1530.38h110v30h-110z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M49390.5 1530.38h110v30h-110z" />
      <text fill="#000" transform="translate(49390.5 1530.38)">
        <tspan x={34.664} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={63.719} y={19.62}>
          {" David"}
        </tspan>
      </text>
    </g>
    <path d="M49540.5 1520.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M49540.5 1520.38h150v50h-150z" />
      <text fill="#000" fontSize={14} transform="translate(49540.5 1520.38)">
        <tspan x={35.543} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Robin Anne"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1955-)"}
        </tspan>
      </text>
    </g>
    <path d="M49740.5 1520.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M49740.5 1520.38h150v50h-150z" />
      <text fill="#000" fontSize={14} transform="translate(49740.5 1520.38)">
        <tspan x={35.219} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Laurie Lynn"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(1958-)"}
        </tspan>
      </text>
    </g>
    <path d="M49940.5 1530.38h175v30h-175z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M49940.5 1530.38h175v30h-175z" />
      <text fill="#000" fontSize={14} transform="translate(49940.5 1530.38)">
        <tspan x={21.215} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={96.219} y={19.62}>
          {" Michael A. Peterson"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M49890.5 1545.38h50M49445.5 1530.38v-60h370v50M49615.5 1520.38v-25h0v-25M49645.5 1395.38v37.5h0v37.5"
    />
    <path d="M49840.5 1680.38h160v30h-160z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M49840.5 1680.38h160v30h-160z" />
      <text fill="#000" fontSize={14} transform="translate(49840.5 1680.38)">
        <tspan x={30.684} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={88.719} y={19.62}>
          {" Cody Peterson"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M49920.5 1545.38v67.5h0v67.5" />
      <path strokeWidth={3} d="M26138 130.38h162.5v30H26138z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M26138 130.38h162.5v30H26138z" />
        <text fill="#000" fontSize={14} transform="translate(26138 130.38)">
          <tspan x={22.09} y={19.62} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={89.969} y={19.62}>
            {" Catharina Cagiola"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M26080.5 145.38h57.5" />
    <path d="M25865.5 30.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M25865.5 30.38h125v30h-125z" />
      <text fill="#000" transform="translate(25865.5 30.38)">
        <tspan x={17.102} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Joannes Pauli"}
        </tspan>
      </text>
    </g>
    <path d="M26048 30.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26048 30.38h100v30h-100z" />
      <text fill="#000" transform="translate(26048 30.38)">
        <tspan x={16.352} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Catharine"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M25990.5 45.38h57.5M26020.5 45.38v37.5h0v37.5" />
      <path strokeWidth={3} d="M28885.5 130.38h140v30h-140z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M28885.5 130.38h140v30h-140z" />
        <text fill="#000" fontSize={14} transform="translate(28885.5 130.38)">
          <tspan x={25.191} y={19.62} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={78.719} y={19.62}>
            {" Angela Monti"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M28835.5 145.38h50" />
    <path d="M38820.5 80.38h135v30h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M38820.5 80.38h135v30h-135z" />
      <text fill="#000" transform="translate(38820.5 80.38)">
        <tspan x={23.949} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={76.219} y={19.62}>
          {" Jois Dominici"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M38888 230.38v-60h0v-60" />
      <path strokeWidth={3} d="M780.5 230.38h150v30h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M780.5 230.38h150v30h-150z" />
        <text fill="#000" transform="translate(780.5 230.38)">
          <tspan x={35.758} y={19.62} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={19.62}>
            {" Anna Maria"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M705.5 245.38h75" />
      <path strokeWidth={3} d="M42620.5 220.38h150v50h-150z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M42620.5 220.38h150v50h-150z" />
        <text fill="#000" transform="translate(42620.5 220.38)">
          <tspan x={26.645} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDEE\uD83C\uDDF9"}
          </tspan>
          <tspan x={83.719} y={21.22}>
            {" Pauli Stephani"}
          </tspan>
          <tspan x={75} y={38.02}>
            {"(1711-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M42805.5 95.38v37.5h0v37.5" />
    <path strokeDasharray="5 6" d="M42420.5 230.38h150v30h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42420.5 230.38h150v30h-150z" />
      <text fill="#000" transform="translate(42420.5 230.38)">
        <tspan x={75} y={19.62}>
          {"See Anna Maria"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M42620.5 245.38h-25 0-25" />
    <path d="M785.5 130.38h130v30h-130z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M785.5 130.38h130v30h-130z" />
      <text fill="#000" transform="translate(785.5 130.38)">
        <tspan x={34.391} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={73.719} y={19.62}>
          {" Stephani"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M850.5 230.38v-35h0v-35M7760.5 1070.38v-100h-135M7590.5 895.38h50M7610.5 895.38h5v175M7455.5 970.38h5v100M7510.5 1095.38h55M7448 1220.38v-50h215v50M7540.5 1095.38v35h0v40M7275.5 1220.38v-50H6833M7365.5 1245.38v62.5h0v62.5M7063 1370.38v-60h827.5v60M7225.5 1695.38h65M7178 1820.38v-47.5h180v47.5M7260.5 1695.38v37.5h0v37.5M7415.5 1395.38h45M7440.5 1520.38v-62.5h0v-62.5M7490.5 1545.38h35M8450.5 1245.38v37.5h0v37.5M9370.5 1545.38h35M8740.5 1670.38v-50h1170v50M9090.5 1670.38v-25h0v-25M9390.5 1670.38v-25h0v-100M8790.5 1695.38h50M9140.5 1695.38h50M9440.5 1695.38h50M3425.5 1395.38v37.5h0v37.5M3540.5 1545.38v37.5h0v37.5M11300.5 1695.38h50M11010.5 1820.38v-50h402.5v50M11325.5 1695.38v37.5h0v37.5M11065.5 1845.38h50M11465.5 1845.38h50M10890.5 1970.38v-50h405v50M11090.5 1845.38v62.5h0v62.5M11490.5 1845.38v62.5h0v62.5M11248 1670.38v-50h1572.5v50M11640.5 1545.38v37.5h0v37.5M12180.5 1620.38v25h0v25M12235.5 1695.38h45M11933 1820.38v-50h500v50M12255.5 1695.38v62.5h0v62.5M12010.5 1845.38h45M12500.5 1845.38h45M11690.5 1970.38v-50h412.5v50M12035.5 1845.38v37.5h0v37.5"
    />
    <path
      fill="none"
      d="M11905.5 1920.38h-5v50M12303 1970.38v-50h707.5v50M12520.5 1845.38v37.5h0v37.5"
    />
    <path
      fill="none"
      d="M12495.5 1920.38h-10v50M12650.5 1920.38v25h0v25M12820.5 1920.38v25h0v25M12870.5 1695.38h50M12823 1820.38v-50h177.5v50M12895.5 1695.38v37.5h0v37.5M13370.5 1695.38h50M13395.5 1695.38v37.5h0v37.5M13240.5 1845.38h50M13188 1970.38v-50h175v50M13265.5 1845.38v37.5h0v37.5M13600.5 1845.38h40M14095.5 1695.38h50M13863 1820.38v-50h657.5v50M14120.5 1695.38v37.5h0v37.5M13940.5 1845.38h30M13853 1970.38v-50h340v50M13955.5 1845.38v37.5h0v37.5M14275.5 1995.38h50M14198 2120.38v-50h262.5v50M14300.5 1995.38v35h0v40M13545.5 2120.38v-50h422.5v50M13725.5 1995.38h45M13750.5 2120.38v-62.5h0v-62.5M14580.5 1845.38h42.5M14600.5 1970.38v-62.5h0v-62.5M15145.5 1695.38h45M15080.5 1820.38v-50h190v50M15165.5 1695.38v37.5h0v37.5M14950.5 1845.38h65M14775.5 1970.38v-50h390v50M14985.5 1845.38v37.5h0v37.5M15625.5 1845.38h50M15538 1970.38v-50h207.5v50M15650.5 1845.38v37.5h0v37.5M15935.5 1970.38v-50h350v50M16035.5 1845.38h40M16110.5 1920.38v25h0v25M16055.5 1845.38v37.5h0v37.5M16575.5 1845.38h65M16475.5 1970.38v-50h292.5v50"
    />
    <path
      fill="none"
      d="M16605.5 1845.38h10v125M16930.5 1970.38v-50h422.5v50M17070.5 1845.38h65M17105.5 1920.38v-37.5h0v-37.5M17070.5 1970.38v-25h0v-25M17210.5 1970.38v-25h0v-25M17620.5 1695.38h85M17805.5 1695.38h50M17670.5 1695.38v62.5h0v62.5M17560.5 1845.38h50M17498 1970.38v-50h217.5v50M17585.5 1845.38v37.5h0v37.5M17830.5 1695.38v62.5h0v62.5M17890.5 1845.38h40M18329 1695.38h71.5M18163.5 1820.38v-50h388v50M18365.5 1695.38v37.5h0v37.5"
    />
    <path
      fill="none"
      d="M18325.5 1770.38h1v50M18163 1870.38v55h0v55M18161.5 2010.38v55h0v55M18795.5 1695.38h50M18820.5 1820.38v-62.5h0v-62.5M19015.5 1695.38h40M19035.5 1820.38v-62.5h0v-62.5M18506.5 1545.38h55M18259 1670.38v-50h671.5v50M18530.5 1545.38v37.5h0v37.5M16405.5 1695.38h50M15425.5 1820.38v-50h1595v50M16525.5 1820.38v-25h0v-25M16375.5 1820.38v-25h0v-25M15965.5 1820.38v-25h0v-25M15575.5 1820.38v-25h0v-25M16430.5 1695.38v37.5h0v37.5M13318 1670.38v-50h4437.5v50M14045.5 1670.38v-25h0v-25M15080.5 1670.38v-25h0v-25M16355.5 1670.38v-25h0v-25M14820.5 1545.38v37.5h0v37.5M11728 1520.38v-50h5315v50M14905.5 1520.38v-25h0v-25M13635.5 1245.38h75M13670.5 1470.38v-112.5h0v-112.5M19465.5 1545.38h50M19490.5 1670.38v-62.5h0v-62.5M19585.5 1695.38h50M19220.5 1820.38v-50h487.5v50M19610.5 1695.38v37.5h0v37.5M19305.5 1845.38h50M19095.5 1970.38v-50h412.5v50M19330.5 1845.38v37.5h0v37.5M19300.5 1920.38v25h0v25M19790.5 1845.38h50M19708 1970.38v-50h192.5v50M19815.5 1845.38v37.5h0v37.5M20070.5 1695.38h35M20225.5 1695.38h40M20130.5 1820.38v-50h182v50M20245.5 1695.38v37.5h0v37.5M20290.5 1545.38h50M20165.5 1670.38v-50h325v50M20315.5 1545.38v37.5h0v37.5M20540.5 1695.38h50M20495 1820.38v-50h589.5v50M20700.5 1820.38v-25h0v-25M20794.5 1845.38h30M20565.5 1695.38v37.5h0v37.5M20240.5 1520.38v-75h0v-75M21300.5 1845.38h50M21325.5 1970.38v-62.5h0v-62.5M21670.5 1845.38h50M21595.5 1970.38v-50h200v50M21695.5 1845.38v37.5h0v37.5M22015.5 1695.38h45M21245 1820.38v-50h795.5v-75M21595.5 1820.38v-25h0v-25M22210.5 1695.38h75M22200.5 1820.38v-50h700v50M22250.5 1695.38v37.5h0v37.5M22200.5 1970.38v-50h400v50M22275.5 1845.38h50M22075.5 1995.38h50M21965.5 2120.38v-50h170v50M22100.5 1995.38v37.5h0v37.5M22275.5 1995.38h80M22300.5 1920.38v-37.5h0v-37.5M22675.5 1995.38h65M22705.5 2120.38v-62.5h0v-62.5M22975.5 1845.38h50M23000.5 1970.38v-62.5h0v-62.5M23320.5 1820.38v-50h400v50M23400.5 1845.38h45M23575.5 1695.38h70M23610.5 1770.38v-37.5h0v-37.5M23845.5 1845.38h-25 0-25M23720.5 1970.38v-50h225v50M23820.5 1845.38v37.5h0v37.5M23315.5 1545.38h50M24235.5 1695.38h50M24435.5 1695.38h50M24155.5 1820.38v-50h205v50M24260.5 1695.38v37.5h0v37.5M24485.5 1845.38h-25 0-25M24260.5 1970.38v-50h400v50M24460.5 1845.38v62.5h0v62.5M24360.5 1670.38v-52.5h-2225v52.5M23505.5 1670.38v-27.5h0v-25M23340.5 1545.38v36.25h0v36.25M24785.5 1845.38h50M24730.5 1820.38v-50h350v50M24885.5 1695.38h50M24910.5 1770.38v-37.5h0v-37.5M25205.5 1970.38v-50h250v50M25285.5 1845.38h60M25315.5 1920.38v-37.5h0v-37.5M25485.5 1695.38h50M25235.5 1820.38v-50h555v50M25635.5 1820.38v-25h0v-25M25510.5 1695.38v35h0v40M25780.5 1545.38h50M26015.5 1670.38v-50h-1180v50M25805.5 1545.38v37.5h0v37.5M25410.5 1670.38v-25h0v-25M25235.5 1245.38v87.5h0v87.5M26330.5 1520.38v-100h0v-100M26205.5 1245.38v35h0v35M26780.5 1670.38v-50h275v50M26885.5 1545.38v37.5h0v37.5M27105.5 1695.38h50M27060.5 1820.38v-50h157.5v50M27130.5 1695.38v37.5h0v37.5M27275.5 1845.38h45M27298 1970.38v-62.5h0v-62.5M28790.5 845.38h450M32705.5 1245.38v62.5h0v62.5M32795.5 1095.38v37.5h0v37.5M33590.5 1520.38v-50h370v50M33785.5 1395.38v37.5h0v37.5M33640.5 1545.38h65M33630.5 1070.38v-100h605M33830.5 970.38v50h0v50M33900.5 1095.38h60M34325.5 1175.38v97.5h0v97.5M34385.5 1395.38h50M34133 1520.38v-50h400v50M34410.5 1395.38v37.5h0v37.5M34205.5 1545.38h55M34605.5 1545.38h55M34960.5 1370.38v-75h0v-75M35020.5 1395.38h50M34895.5 1520.38v-50h305v50M35045.5 1395.38v62.5h0v62.5M35360.5 1520.38v-50h350v50M35535.5 1395.38v37.5h0v37.5M35410.5 1545.38h50M35760.5 1545.38h50M35260.5 1670.38v-50h350v50M35435.5 1545.38v37.5h0v37.5M35310.5 1695.38h50M35255.5 1820.38v-50h155v50M35335.5 1695.38v37.5h0v37.5M35785.5 1545.38v67.5h0v67.5M36025.5 1395.38h50M35965.5 1370.38v-150h-515M36430.5 1395.38h50M36178 1530.38v-60h397.5v50M36455.5 1395.38v37.5h0v37.5M36280.5 1545.38h60M36640.5 1545.38h50M36535.5 1820.38v-50h405v50M36705.5 1695.38h45M36725.5 1820.38v-62.5h0v-62.5M37115.5 1695.38h45M37140.5 1820.38v-62.5h0v-62.5M36985.5 1545.38h60M36630.5 1670.38v-50h800v50M37030.5 1670.38v-25h0v-25M37015.5 1545.38v37.5h0v37.5M37180.5 1395.38h45M36923 1520.38v-50h870v50M37200.5 1395.38v37.5h0v37.5M37855.5 1545.38h60M37710.5 1695.38h45M37640.5 1670.38v-50h550v50M38020.5 1670.38v-25h0v-25M37735.5 1695.38v62.5h0v62.5M37885.5 1545.38v37.5h0v37.5M37565.5 1395.38h70M38480.5 1545.38v37.5h0v37.5M38280.5 1370.38v-150h-1910v150M37505.5 1370.38v-75h0v-75M39048 1820.38v-125h2.5M39590.5 1245.38v62.5h0v62.5M40470.5 1545.38h55M40375.5 1695.38h65M40405.5 1820.38v-62.5h0v-62.5M40495.5 1670.38v-65h0v-60M41090.5 1545.38h105M41005.5 1520.38v-62.5h0v-62.5M41145.5 1670.38v-62.5h0v-62.5M42858 1520.38v-50h882.5v50M43140.5 1395.38h40M43160.5 1520.38v-25h0v-100M43460.5 1520.38v-25h0v-25M43230.5 1620.38v-37.5h0v-37.5M43815.5 1545.38v37.5h0v37.5M51980.5 670.38v-60h0v-65M52038 695.38h52.5M51030.5 870.38v-100h1625v100M51520.5 870.38v-50h0v-50M51820.5 870.38v-50h0v-50M51970.5 870.38v-50h0v-50M52280.5 870.38v-55h0v-45M52060.5 695.38v35h0v40M52025.5 895.38h50M51480.5 1070.38v-100h1380v100M52620.5 1070.38v-50h0v-50M52200.5 1070.38v-50h0v-50M52000.5 1070.38v-50h0v-50M51820.5 1070.38v-50h0v-50M52050.5 970.38v-37.5h0v-37.5M13810.5 1245.38h60M34630.5 1070.38v-50h0v-50M35060.5 1070.38v-50h0v-50M42520.5 545.38v37.5h0v37.5M46365.5 1670.38v-50h5"
    />
      <path strokeWidth={3} d="M45270.5 1370.38h145v50h-145z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M45270.5 1370.38h145v50h-145z" />
        <text fill="#000" transform="translate(45270.5 1370.38)">
          <tspan x={41.68} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDFA\uD83C\uDDF8"}
          </tspan>
          <tspan x={81.219} y={21.22}>
            {" Giacomo"}
          </tspan>
          <tspan x={72.5} y={38.02}>
            {"(1908-)"}
          </tspan>
        </text>
      </g>
    <path fill="none" d="M45100.5 1095.38v125h242.5v150" />
      <path strokeWidth={3} d="M2020.5 1220.38h200v50h-200z" />
      <g className="accomazzo-family-tree_svg__Text.cls">
        <path fill="none" stroke="none" d="M2020.5 1220.38h200v50h-200z" />
        <text fill="#000" transform="translate(2020.5 1220.38)">
          <tspan x={35.852} y={21.22} fontFamily="Noto Color Emoji">
            {"\uD83C\uDDFA\uD83C\uDDF8"}
          </tspan>
          <tspan x={108.719} y={21.22}>
            {" Augustina Coo-Coo"}
          </tspan>
          <tspan x={100} y={38.02}>
            {"(1914-)"}
          </tspan>
        </text>
      </g>
    <path d="M1870.5 1220.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M1870.5 1220.38h125v50h-125z" />
      <text fill="#000" transform="translate(1870.5 1220.38)">
        <tspan x={44.125} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Mary"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1913-1934)"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M1933 1220.38v-50h187.5v50M1965.5 1095.38v37.5h0v37.5M2520.5 1095.38h85"
    />
    <path d="M2270.5 1220.38h135v50h-135z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2270.5 1220.38h135v50h-135z" />
      <text fill="#000" transform="translate(2270.5 1220.38)">
        <tspan x={21.125} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={76.219} y={21.22}>
          {" Ernest Joseph"}
        </tspan>
        <tspan x={67.5} y={38.02}>
          {"(1921-)"}
        </tspan>
      </text>
    </g>
    <path d="M2490.5 1220.38h125v50h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2490.5 1220.38h125v50h-125z" />
      <text fill="#000" transform="translate(2490.5 1220.38)">
        <tspan x={19.746} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={21.22}>
          {" Rose Marino"}
        </tspan>
        <tspan x={62.5} y={38.02}>
          {"(1922-2007)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M2405.5 1245.38h85" />
    <path d="M2170.5 1380.38h80v30h-80z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2170.5 1380.38h80v30h-80z" />
      <text fill="#000" transform="translate(2170.5 1380.38)">
        <tspan x={22.906} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={48.719} y={19.62}>
          {" Terri"}
        </tspan>
      </text>
    </g>
    <path d="M2270.5 1380.38h100v30h-100z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2270.5 1380.38h100v30h-100z" />
      <text fill="#000" transform="translate(2270.5 1380.38)">
        <tspan x={11.129} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={58.719} y={19.62}>
          {" Janet Marie"}
        </tspan>
      </text>
    </g>
    <path d="M2385.5 1380.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2385.5 1380.38h125v30h-125z" />
      <text fill="#000" transform="translate(2385.5 1380.38)">
        <tspan x={14.281} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" David Thomas"}
        </tspan>
      </text>
    </g>
    <path d="M2700.5 1380.38h105v30h-105z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2700.5 1380.38h105v30h-105z" />
      <text fill="#000" fontSize={14} transform="translate(2700.5 1380.38)">
        <tspan x={17.996} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={61.219} y={19.62}>
          {" Anita Jean"}
        </tspan>
      </text>
    </g>
    <path d="M2540.5 1380.38h140v30h-140z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2540.5 1380.38h140v30h-140z" />
      <text fill="#000" fontSize={14} transform="translate(2540.5 1380.38)">
        <tspan x={13.184} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={78.719} y={19.62}>
          {" Jean Maria Polito"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M2210.5 1380.38v-60H2753v60M2338 1220.38v-50h480v50M2565.5 1095.38v37.5h0v37.5M2320.5 1320.38v30h0v30M2445.5 1245.38v105h0v30M2510.5 1395.38h30"
    />
    <path d="M2250.5 1530.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2250.5 1530.38h125v30h-125z" />
      <text fill="#000" transform="translate(2250.5 1530.38)">
        <tspan x={42.164} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" David"}
        </tspan>
      </text>
    </g>
    <path d="M2400.5 1530.38h125v30h-125z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2400.5 1530.38h125v30h-125z" />
      <text fill="#000" transform="translate(2400.5 1530.38)">
        <tspan x={18.012} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={71.219} y={19.62}>
          {" Angela Marie"}
        </tspan>
      </text>
    </g>
    <path d="M2550.5 1530.38h170v30h-170z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M2550.5 1530.38h170v30h-170z" />
      <text fill="#000" transform="translate(2550.5 1530.38)">
        <tspan x={33.047} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={93.719} y={19.62}>
          {" Francesca Rose"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      d="M2313 1530.38v-60h322.5v60M2525.5 1395.38v37.5h0v37.5"
    />
    <path fill="none" d="M2465.5 1470.38h-2.5v60" />
    <path d="M42445.5 1520.38h175v50h-175z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42445.5 1520.38h175v50h-175z" />
      <text fill="#000" transform="translate(42445.5 1520.38)">
        <tspan x={36.094} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDF7\uD83C\uDDFA\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={104.934} y={21.22}>
          {" Sofia Vassiaeva"}
        </tspan>
        <tspan x={87.5} y={38.02}>
          {"(1968-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M42620.5 1545.38h65" />
    <path d="M42600.5 1670.38h120v50h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M42600.5 1670.38h120v50h-120z" />
      <text fill="#000" transform="translate(42600.5 1670.38)">
        <tspan x={42.035} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDF7\uD83C\uDDFA\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={77.434} y={21.22}>
          {" Alina"}
        </tspan>
        <tspan x={60} y={38.02}>
          {"(1997-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M42655.5 1545.38v62.5h0v62.5" />
    <path d="M22370.5 2120.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M22370.5 2120.38h150v50h-150z" />
      <text fill="#000" transform="translate(22370.5 2120.38)">
        <tspan x={17.41} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Justin Anthony, Jr"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(2022-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M22295.5 2120.38v-50h150v50M22320.5 1995.38v75" />
    <path d="M23120.5 1970.38h240v50h-240z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M23120.5 1970.38h240v50h-240z" />
      <text fill="#000" transform="translate(23120.5 1970.38)">
        <tspan x={26.457} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDF5\uD83C\uDDEA"}
        </tspan>
        <tspan x={128.719} y={21.22}>
          {" Gianella Ariana Veas Salazar"}
        </tspan>
        <tspan x={120} y={38.02}>
          {"(2000-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M23075.5 1995.38h45" />
    <path d="M5620.5 1680.38h120v30h-120z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M5620.5 1680.38h120v30h-120z" />
      <text fill="#000" transform="translate(5620.5 1680.38)">
        <tspan x={14.984} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={68.719} y={19.62}>
          {" Luana Giolitti"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M5550.5 1695.38h70" />
    <path d="M43060.5 80.38h115v30h-115z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M43060.5 80.38h115v30h-115z" />
      <text fill="#000" transform="translate(43060.5 80.38)">
        <tspan x={30.801} y={19.62} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDEE\uD83C\uDDF9"}
        </tspan>
        <tspan x={66.219} y={19.62}>
          {" Francisi"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M43118 110.38v60h0v60" />
    <path d="M26070.5 1970.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26070.5 1970.38h150v50h-150z" />
      <text fill="#000" transform="translate(26070.5 1970.38)">
        <tspan x={21.77} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Cameron James"}
        </tspan>
        <tspan x={75} y={38.02}>
          {"(2025-)"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M25950.5 1970.38v-50h195v50" />
    <path d="M26815.5 1820.38h150v50h-150z" />
    <g className="accomazzo-family-tree_svg__Text.cls">
      <path fill="none" stroke="none" d="M26815.5 1820.38h150v50h-150z" />
      <text fill="#000" transform="translate(26815.5 1820.38)">
        <tspan x={32.043} y={21.22} fontFamily="Noto Color Emoji">
          {"\uD83C\uDDFA\uD83C\uDDF8"}
        </tspan>
        <tspan x={83.719} y={21.22}>
          {" Unyamanee "}
        </tspan>
        <tspan x={75} y={38.02}>
          {"Santanoo"}
        </tspan>
      </text>
    </g>
    <path fill="none" d="M26780.5 1845.38h35" />
  </svg>

  );
}

export default SvgAccomazzoFamilyTree;

